// Automatically generated with Reach 0.1.13 (f79282c4)
/* eslint-disable */
export const _version = '0.1.13';
export const _versionHash = '0.1.13 (f79282c4)';
export const _backendVersion = 27;

export function getExports(s) {
  const stdlib = s.reachStdlib;
  return {
    };
  };
export function _getEvents(s) {
  const stdlib = s.reachStdlib;
  return {
    };
  };
export function _getViews(s, viewlib) {
  const stdlib = s.reachStdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_Token;
  const ctc2 = stdlib.T_UInt;
  const ctc3 = stdlib.T_Bool;
  const ctc4 = stdlib.T_Tuple([ctc2, ctc2, ctc3]);
  const ctc5 = stdlib.T_Array(ctc4, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '2'));
  const ctc6 = stdlib.T_Object({
    i: ctc2,
    scale: ctc2
    });
  const ctc7 = stdlib.T_Object({
    i: ctc6,
    sign: ctc3
    });
  const ctc8 = stdlib.T_Null;
  const ctc9 = stdlib.T_Data({
    None: ctc8,
    Some: ctc0
    });
  const ctc10 = stdlib.T_Object({
    lastUpdateTime: ctc2,
    prizeClaimed: ctc3,
    rewardPerToken: ctc7,
    totalStake: ctc2,
    winner: ctc9
    });
  const ctc11 = stdlib.T_Struct([['scale', ctc2], ['i', ctc2]]);
  const ctc12 = stdlib.T_Struct([['sign', ctc3], ['i', ctc11]]);
  const ctc13 = stdlib.T_Struct([['totalStake', ctc2], ['lastUpdateTime', ctc2], ['rewardPerToken', ctc12], ['winner', ctc9], ['prizeClaimed', ctc3]]);
  const ctc14 = stdlib.T_Struct([['nft', ctc1], ['stakeToken', ctc1], ['stakingEndTime', ctc2]]);
  const ctc15 = stdlib.T_Struct([['userBalance', ctc2], ['userRewards', ctc12], ['userRewardPerTokenPaid', ctc12], ['userHasWithdrawn', ctc3]]);
  const ctc16 = stdlib.T_Data({
    None: ctc8,
    Some: ctc2
    });
  const ctc17 = stdlib.T_Data({
    None: ctc8,
    Some: ctc7
    });
  const ctc18 = stdlib.T_Data({
    None: ctc8,
    Some: ctc3
    });
  const map0_ctc = ctc16;
  
  const map1_ctc = ctc17;
  
  const map2_ctc = ctc17;
  
  const map3_ctc = ctc18;
  
  
  const _globalState = async (i, svs, args) => {
    if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '1'))) {
      const [v2917, v2918, v2919, v2920, v2929] = svs;
      stdlib.assert(false, 'illegal view')
      }
    if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '4'))) {
      const [v2917, v2918, v2919, v2920, v2985, v2988, v2995, v3025, v3026, v3027, v3028, v3029, v3031, v3033, v3034, v3036] = svs;
      return (await ((async () => {
        
        const v3041 = {
          lastUpdateTime: v3025,
          prizeClaimed: v3026,
          rewardPerToken: v3036,
          totalStake: v3028,
          winner: v3029
          };
        
        return v3041;}))(...args));
      }
    
    stdlib.assert(false, 'illegal view')
    };
  const _initialState = async (i, svs, args) => {
    if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '1'))) {
      const [v2917, v2918, v2919, v2920, v2929] = svs;
      return (await ((async () => {
        
        const v2936 = {
          nft: v2918,
          stakeToken: v2919,
          stakingEndTime: v2920
          };
        
        return v2936;}))(...args));
      }
    if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '4'))) {
      const [v2917, v2918, v2919, v2920, v2985, v2988, v2995, v3025, v3026, v3027, v3028, v3029, v3031, v3033, v3034, v3036] = svs;
      return (await ((async () => {
        
        const v2936 = {
          nft: v2918,
          stakeToken: v2919,
          stakingEndTime: v2920
          };
        
        return v2936;}))(...args));
      }
    
    stdlib.assert(false, 'illegal view')
    };
  const _localState = async (i, svs, args) => {
    if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '1'))) {
      const [v2917, v2918, v2919, v2920, v2929] = svs;
      stdlib.assert(false, 'illegal view')
      }
    if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '4'))) {
      const [v2917, v2918, v2919, v2920, v2985, v2988, v2995, v3025, v3026, v3027, v3028, v3029, v3031, v3033, v3034, v3036] = svs;
      return (await ((async (_v2948 ) => {
          const v2948 = stdlib.protect(ctc0, _v2948, null);
        
        const v2949 = stdlib.protect(map0_ctc, await viewlib.viewMapRef(0, ctc0, v2948, ctc2), null);
        const v2950 = stdlib.fromSome(v2949, stdlib.checkedBigNumberify('./index.rsh:99:68:decimal', stdlib.UInt_max, '0'));
        const v2951 = stdlib.protect(map1_ctc, await viewlib.viewMapRef(1, ctc0, v2948, ctc7), null);
        const v2952 = {
          i: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '0'),
          scale: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '10')
          };
        const v2953 = {
          i: v2952,
          sign: true
          };
        const v2954 = stdlib.fromSome(v2951, v2953);
        const v2955 = v2954.sign;
        const v2956 = v2954.i;
        const v2957 = v2956.scale;
        const v2958 = v2956.i;
        const v2959 = {
          i: v2958,
          scale: v2957
          };
        const v2960 = {
          i: v2959,
          sign: v2955
          };
        const v2961 = stdlib.protect(map2_ctc, await viewlib.viewMapRef(2, ctc0, v2948, ctc7), null);
        const v2964 = stdlib.fromSome(v2961, v2953);
        const v2965 = v2964.sign;
        const v2966 = v2964.i;
        const v2967 = v2966.scale;
        const v2968 = v2966.i;
        const v2969 = {
          i: v2968,
          scale: v2967
          };
        const v2970 = {
          i: v2969,
          sign: v2965
          };
        const v2971 = stdlib.protect(map3_ctc, await viewlib.viewMapRef(3, ctc0, v2948, ctc3), null);
        const v2972 = stdlib.fromSome(v2971, false);
        const v2977 = {
          userBalance: v2950,
          userHasWithdrawn: v2972,
          userRewardPerTokenPaid: v2970,
          userRewards: v2960
          };
        
        return v2977;}))(...args));
      }
    
    stdlib.assert(false, 'illegal view')
    };
  return {
    infos: {
      globalState: {
        decode: _globalState,
        dom: [],
        rng: ctc13
        },
      initialState: {
        decode: _initialState,
        dom: [],
        rng: ctc14
        },
      localState: {
        decode: _localState,
        dom: [ctc0],
        rng: ctc15
        }
      },
    views: {
      1: [ctc0, ctc1, ctc1, ctc2, ctc5],
      4: [ctc0, ctc1, ctc1, ctc2, ctc7, ctc10, ctc5, ctc2, ctc3, ctc7, ctc2, ctc9, ctc3, ctc2, ctc2, ctc12]
      }
    };
  
  };
export function _getMaps(s) {
  const stdlib = s.reachStdlib;
  const ctc0 = stdlib.T_Null;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Data({
    None: ctc0,
    Some: ctc1
    });
  const ctc3 = stdlib.T_Object({
    i: ctc1,
    scale: ctc1
    });
  const ctc4 = stdlib.T_Bool;
  const ctc5 = stdlib.T_Object({
    i: ctc3,
    sign: ctc4
    });
  const ctc6 = stdlib.T_Data({
    None: ctc0,
    Some: ctc5
    });
  const ctc7 = stdlib.T_Data({
    None: ctc0,
    Some: ctc4
    });
  const ctc8 = stdlib.T_Tuple([ctc2, ctc6, ctc6, ctc7]);
  return {
    mapDataTy: ctc8
    };
  };
export async function Deployer(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Deployer expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Deployer expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Null;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Data({
    None: ctc0,
    Some: ctc1
    });
  const ctc3 = stdlib.T_Object({
    i: ctc1,
    scale: ctc1
    });
  const ctc4 = stdlib.T_Bool;
  const ctc5 = stdlib.T_Object({
    i: ctc3,
    sign: ctc4
    });
  const ctc6 = stdlib.T_Data({
    None: ctc0,
    Some: ctc5
    });
  const ctc7 = stdlib.T_Data({
    None: ctc0,
    Some: ctc4
    });
  const ctc8 = stdlib.T_Token;
  const ctc9 = stdlib.T_Tuple([]);
  const ctc10 = stdlib.T_Address;
  const ctc11 = stdlib.T_Tuple([ctc10]);
  const ctc12 = stdlib.T_Tuple([ctc1]);
  const ctc13 = stdlib.T_Data({
    claim0_195: ctc9,
    setWinner0_195: ctc11,
    stake0_195: ctc12,
    unstake0_195: ctc12,
    updateTime0_195: ctc9,
    withdrawAll0_195: ctc9
    });
  const ctc14 = stdlib.T_Tuple([ctc1, ctc1, ctc4]);
  const ctc15 = stdlib.T_Array(ctc14, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '2'));
  
  const map0_ctc = ctc2;
  const map0 = stdlib.newMap({
    ctc: ctc,
    idx: 0,
    isAPI: false
    });
  
  const map1_ctc = ctc6;
  const map1 = stdlib.newMap({
    ctc: ctc,
    idx: 1,
    isAPI: false
    });
  
  const map2_ctc = ctc6;
  const map2 = stdlib.newMap({
    ctc: ctc,
    idx: 2,
    isAPI: false
    });
  
  const map3_ctc = ctc7;
  const map3 = stdlib.newMap({
    ctc: ctc,
    idx: 3,
    isAPI: false
    });
  
  
  const v2904 = [stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '0'), stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '0'), false];
  const v2905 = [v2904, v2904];
  const v2909 = stdlib.protect(ctc8, interact.nft, 'for Deployer\'s interact field nft');
  const v2910 = stdlib.protect(ctc8, interact.stakeToken, 'for Deployer\'s interact field stakeToken');
  const v2911 = stdlib.protect(ctc1, interact.stakingEndTime, 'for Deployer\'s interact field stakingEndTime');
  
  const v2914 = stdlib.tokenEq(v2909, v2910);
  const v2915 = v2914 ? false : true;
  stdlib.assert(v2915, {
    at: 'reach standard library:57:5:application',
    fs: ['at ./index.rsh:82:10:application call to "check" (defined at: reach standard library:49:32:function exp)'],
    msg: null,
    who: 'Deployer'
    });
  
  const txn1 = await (ctc.sendrecv({
    args: [v2909, v2910, v2911],
    evt_cnt: 3,
    funcNum: 0,
    lct: stdlib.checkedBigNumberify('./index.rsh:81:12:dot', stdlib.UInt_max, '0'),
    onlyIf: true,
    out_tys: [ctc8, ctc8, ctc1],
    pay: [stdlib.checkedBigNumberify('./index.rsh:81:12:decimal', stdlib.UInt_max, '0'), []],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      let sim_txn_ctr = stdlib.UInt_max;
      const getSimTokCtr = () => { sim_txn_ctr = sim_txn_ctr.sub(1); return sim_txn_ctr; };
      
      stdlib.simMapDupe(sim_r, 0, map0);
      stdlib.simMapDupe(sim_r, 1, map1);
      stdlib.simMapDupe(sim_r, 2, map2);
      stdlib.simMapDupe(sim_r, 3, map3);
      
      const {data: [v2918, v2919, v2920], secs: v2922, time: v2921, didSend: v70, from: v2917 } = txn1;
      
      const v2923 = v2905[stdlib.checkedBigNumberify('./index.rsh:81:12:dot', stdlib.UInt_max, '0')];
      const v2924 = stdlib.Array_set(v2923, '0', stdlib.checkedBigNumberify('./index.rsh:81:12:dot', stdlib.UInt_max, '0'));
      const v2925 = stdlib.Array_set(v2905, stdlib.checkedBigNumberify('./index.rsh:81:12:dot', stdlib.UInt_max, '0'), v2924);
      const v2927 = v2925[stdlib.checkedBigNumberify('./index.rsh:81:12:dot', stdlib.UInt_max, '1')];
      const v2928 = stdlib.Array_set(v2927, '0', stdlib.checkedBigNumberify('./index.rsh:81:12:dot', stdlib.UInt_max, '0'));
      const v2929 = stdlib.Array_set(v2925, stdlib.checkedBigNumberify('./index.rsh:81:12:dot', stdlib.UInt_max, '1'), v2928);
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '0'),
        kind: 'init',
        tok: v2918
        });
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '0'),
        kind: 'init',
        tok: v2919
        });
      ;
      sim_r.isHalt = false;
      
      return sim_r;
      }),
    soloSend: true,
    timeoutAt: undefined /* mto */,
    tys: [ctc8, ctc8, ctc1],
    waitIfNotPresent: false
    }));
  const {data: [v2918, v2919, v2920], secs: v2922, time: v2921, didSend: v70, from: v2917 } = txn1;
  const v2923 = v2905[stdlib.checkedBigNumberify('./index.rsh:81:12:dot', stdlib.UInt_max, '0')];
  const v2924 = stdlib.Array_set(v2923, '0', stdlib.checkedBigNumberify('./index.rsh:81:12:dot', stdlib.UInt_max, '0'));
  const v2925 = stdlib.Array_set(v2905, stdlib.checkedBigNumberify('./index.rsh:81:12:dot', stdlib.UInt_max, '0'), v2924);
  const v2927 = v2925[stdlib.checkedBigNumberify('./index.rsh:81:12:dot', stdlib.UInt_max, '1')];
  const v2928 = stdlib.Array_set(v2927, '0', stdlib.checkedBigNumberify('./index.rsh:81:12:dot', stdlib.UInt_max, '0'));
  const v2929 = stdlib.Array_set(v2925, stdlib.checkedBigNumberify('./index.rsh:81:12:dot', stdlib.UInt_max, '1'), v2928);
  const v2931 = stdlib.tokenEq(v2919, v2918);
  const v2932 = v2931 ? false : true;
  stdlib.assert(v2932, {
    at: './index.rsh:81:12:dot',
    fs: [],
    msg: 'non-network tokens distinct',
    who: 'Deployer'
    });
  const v2933 = stdlib.tokenEq(v2918, v2919);
  const v2934 = v2933 ? false : true;
  stdlib.assert(v2934, {
    at: 'reach standard library:57:5:application',
    fs: ['at ./index.rsh:82:10:application call to "check" (defined at: reach standard library:49:32:function exp)'],
    msg: null,
    who: 'Deployer'
    });
  ;
  ;
  ;
  const txn2 = await (ctc.sendrecv({
    args: [v2917, v2918, v2919, v2920, v2929],
    evt_cnt: 0,
    funcNum: 1,
    lct: v2921,
    onlyIf: true,
    out_tys: [],
    pay: [stdlib.checkedBigNumberify('./index.rsh:92:17:decimal', stdlib.UInt_max, '0'), [[stdlib.checkedBigNumberify('./index.rsh:92:21:decimal', stdlib.UInt_max, '1'), v2918]]],
    sim_p: (async (txn2) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      let sim_txn_ctr = stdlib.UInt_max;
      const getSimTokCtr = () => { sim_txn_ctr = sim_txn_ctr.sub(1); return sim_txn_ctr; };
      
      stdlib.simMapDupe(sim_r, 0, map0);
      stdlib.simMapDupe(sim_r, 1, map1);
      stdlib.simMapDupe(sim_r, 2, map2);
      stdlib.simMapDupe(sim_r, 3, map3);
      
      const {data: [], secs: v2939, time: v2938, didSend: v78, from: v2937 } = txn2;
      
      ;
      const v2940 = v2929[stdlib.checkedBigNumberify('./index.rsh:92:12:dot', stdlib.UInt_max, '0')];
      const v2941 = v2940[stdlib.checkedBigNumberify('./index.rsh:92:12:dot', stdlib.UInt_max, '0')];
      const v2942 = stdlib.add(v2941, stdlib.checkedBigNumberify('./index.rsh:92:21:decimal', stdlib.UInt_max, '1'));
      const v2944 = stdlib.Array_set(v2940, '0', v2942);
      const v2945 = stdlib.Array_set(v2929, stdlib.checkedBigNumberify('./index.rsh:92:12:dot', stdlib.UInt_max, '0'), v2944);
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./index.rsh:92:21:decimal', stdlib.UInt_max, '1'),
        kind: 'to',
        tok: v2918
        });
      
      const v2984 = {
        i: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '0'),
        scale: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '10')
        };
      const v2985 = {
        i: v2984,
        sign: true
        };
      const v2986 = ['None', null];
      const v2987 = {
        lastUpdateTime: v2938,
        prizeClaimed: false,
        rewardPerToken: v2985,
        totalStake: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '0'),
        winner: v2986
        };
      const v2988 = v2987;
      const v2989 = v2938;
      const v2995 = v2945;
      
      if (await (async () => {
        
        return true;})()) {
        const v3025 = v2988.lastUpdateTime;
        const v3026 = v2988.prizeClaimed;
        const v3027 = v2988.rewardPerToken;
        const v3028 = v2988.totalStake;
        const v3029 = v2988.winner;
        const v3031 = v3027.sign;
        const v3032 = v3027.i;
        const v3033 = v3032.scale;
        const v3034 = v3032.i;
        const v3035 = {
          i: v3034,
          scale: v3033
          };
        const v3036 = {
          i: v3035,
          sign: v3031
          };
        sim_r.isHalt = false;
        }
      else {
        sim_r.txns.push({
          kind: 'halt',
          tok: v2919
          })
        sim_r.txns.push({
          kind: 'halt',
          tok: v2918
          })
        sim_r.txns.push({
          kind: 'halt',
          tok: undefined /* Nothing */
          })
        sim_r.isHalt = true;
        }
      return sim_r;
      }),
    soloSend: true,
    timeoutAt: undefined /* mto */,
    tys: [ctc10, ctc8, ctc8, ctc1, ctc15],
    waitIfNotPresent: false
    }));
  const {data: [], secs: v2939, time: v2938, didSend: v78, from: v2937 } = txn2;
  ;
  const v2940 = v2929[stdlib.checkedBigNumberify('./index.rsh:92:12:dot', stdlib.UInt_max, '0')];
  const v2941 = v2940[stdlib.checkedBigNumberify('./index.rsh:92:12:dot', stdlib.UInt_max, '0')];
  const v2942 = stdlib.add(v2941, stdlib.checkedBigNumberify('./index.rsh:92:21:decimal', stdlib.UInt_max, '1'));
  const v2944 = stdlib.Array_set(v2940, '0', v2942);
  const v2945 = stdlib.Array_set(v2929, stdlib.checkedBigNumberify('./index.rsh:92:12:dot', stdlib.UInt_max, '0'), v2944);
  ;
  const v2946 = stdlib.addressEq(v2917, v2937);
  stdlib.assert(v2946, {
    at: './index.rsh:92:12:dot',
    fs: [],
    msg: 'sender correct',
    who: 'Deployer'
    });
  stdlib.protect(ctc0, await interact.disconnect(), {
    at: './index.rsh:93:31:application',
    fs: ['at ./index.rsh:93:31:application call to [unknown function] (defined at: ./index.rsh:93:31:function exp)', 'at ./index.rsh:93:31:application call to "liftedInteract" (defined at: ./index.rsh:93:31:application)'],
    msg: 'disconnect',
    who: 'Deployer'
    });
  
  const v2984 = {
    i: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '0'),
    scale: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '10')
    };
  const v2985 = {
    i: v2984,
    sign: true
    };
  const v2986 = ['None', null];
  const v2987 = {
    lastUpdateTime: v2938,
    prizeClaimed: false,
    rewardPerToken: v2985,
    totalStake: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '0'),
    winner: v2986
    };
  let v2988 = v2987;
  let v2989 = v2938;
  let v2995 = v2945;
  
  let txn3 = txn2;
  while (await (async () => {
    
    return true;})()) {
    const v3025 = v2988.lastUpdateTime;
    const v3026 = v2988.prizeClaimed;
    const v3027 = v2988.rewardPerToken;
    const v3028 = v2988.totalStake;
    const v3029 = v2988.winner;
    const v3031 = v3027.sign;
    const v3032 = v3027.i;
    const v3033 = v3032.scale;
    const v3034 = v3032.i;
    const v3035 = {
      i: v3034,
      scale: v3033
      };
    const v3036 = {
      i: v3035,
      sign: v3031
      };
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 1,
      funcNum: 3,
      out_tys: [ctc13],
      timeoutAt: undefined /* mto */,
      waitIfNotPresent: false
      }));
    const {data: [v3273], secs: v3275, time: v3274, didSend: v1278, from: v3272 } = txn4;
    switch (v3273[0]) {
      case 'claim0_195': {
        const v3276 = v3273[1];
        undefined /* setApiDetails */;
        ;
        ;
        const v3358 = v2995[stdlib.checkedBigNumberify('./index.rsh:123:31:dot', stdlib.UInt_max, '0')];
        const v3359 = v3358[stdlib.checkedBigNumberify('./index.rsh:123:31:dot', stdlib.UInt_max, '0')];
        ;
        const v3366 = v3026 ? false : true;
        stdlib.assert(v3366, {
          at: 'reach standard library:57:5:application',
          fs: ['at ./index.rsh:233:12:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:241:20:application call to [unknown function] (defined at: ./index.rsh:241:20:function exp)'],
          msg: 'Prize already claimed',
          who: 'Deployer'
          });
        let v3369;
        switch (v3029[0]) {
          case 'None': {
            const v3370 = v3029[1];
            v3369 = false;
            
            break;
            }
          case 'Some': {
            const v3371 = v3029[1];
            const v3372 = stdlib.addressEq(v3371, v3272);
            v3369 = v3372;
            
            break;
            }
          }
        stdlib.assert(v3369, {
          at: 'reach standard library:57:5:application',
          fs: ['at ./index.rsh:234:12:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:241:20:application call to [unknown function] (defined at: ./index.rsh:241:20:function exp)'],
          msg: 'Not winner',
          who: 'Deployer'
          });
        const v3376 = stdlib.le(stdlib.checkedBigNumberify('./index.rsh:238:13:decimal', stdlib.UInt_max, '1'), v3359);
        stdlib.assert(v3376, {
          at: 'reach standard library:57:5:application',
          fs: ['at ./index.rsh:238:12:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:241:20:application call to [unknown function] (defined at: ./index.rsh:241:20:function exp)'],
          msg: 'Insufficient tokens in contract',
          who: 'Deployer'
          });
        const v3379 = stdlib.le(v3274, v2920);
        const v3380 = v3379 ? false : true;
        stdlib.assert(v3380, {
          at: 'reach standard library:57:5:application',
          fs: ['at ./index.rsh:242:16:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:241:20:application call to [unknown function] (defined at: ./index.rsh:241:20:function exp)'],
          msg: 'Claiming period has not started',
          who: 'Deployer'
          });
        const v3399 = stdlib.sub(v3359, stdlib.checkedBigNumberify('./index.rsh:96:53:decimal', stdlib.UInt_max, '1'));
        const v3401 = stdlib.Array_set(v3358, '0', v3399);
        const v3402 = stdlib.Array_set(v2995, stdlib.checkedBigNumberify('./index.rsh:243:39:application', stdlib.UInt_max, '0'), v3401);
        ;
        const v3403 = null;
        await txn4.getOutput('claim', 'v3403', ctc0, v3403);
        const v3414 = {
          lastUpdateTime: v3025,
          prizeClaimed: true,
          rewardPerToken: v3027,
          totalStake: v3028,
          winner: v3029
          };
        const cv2988 = v3414;
        const cv2989 = v3274;
        const cv2995 = v3402;
        
        v2988 = cv2988;
        v2989 = cv2989;
        v2995 = cv2995;
        
        txn3 = txn4;
        continue;
        break;
        }
      case 'setWinner0_195': {
        const v4281 = v3273[1];
        undefined /* setApiDetails */;
        ;
        ;
        ;
        const v4422 = v4281[stdlib.checkedBigNumberify('./index.rsh:249:10:spread', stdlib.UInt_max, '0')];
        const v4423 = stdlib.addressEq(v3272, v2917);
        stdlib.assert(v4423, {
          at: 'reach standard library:57:5:application',
          fs: ['at ./index.rsh:250:12:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:254:20:application call to [unknown function] (defined at: ./index.rsh:254:20:function exp)'],
          msg: 'Only admin is allowed to set winner',
          who: 'Deployer'
          });
        const v4426 = {
          None: 0,
          Some: 1
          }[v3029[0]];
        const v4427 = stdlib.eq(v4426, stdlib.checkedBigNumberify('reach standard library:39:41:application', stdlib.UInt_max, '0'));
        stdlib.assert(v4427, {
          at: 'reach standard library:57:5:application',
          fs: ['at ./index.rsh:251:12:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:254:20:application call to [unknown function] (defined at: ./index.rsh:254:20:function exp)'],
          msg: 'Winner can only be set once',
          who: 'Deployer'
          });
        const v4431 = stdlib.le(v3274, v2920);
        const v4432 = v4431 ? false : true;
        stdlib.assert(v4432, {
          at: 'reach standard library:57:5:application',
          fs: ['at ./index.rsh:255:16:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:254:20:application call to [unknown function] (defined at: ./index.rsh:254:20:function exp)'],
          msg: 'Winner can only be set after staking period',
          who: 'Deployer'
          });
        const v4434 = null;
        await txn4.getOutput('setWinner', 'v4434', ctc0, v4434);
        const v4446 = ['Some', v4422];
        const v4447 = {
          lastUpdateTime: v3025,
          prizeClaimed: v3026,
          rewardPerToken: v3027,
          totalStake: v3028,
          winner: v4446
          };
        const cv2988 = v4447;
        const cv2989 = v3274;
        const cv2995 = v2995;
        
        v2988 = cv2988;
        v2989 = cv2989;
        v2995 = cv2995;
        
        txn3 = txn4;
        continue;
        break;
        }
      case 'stake0_195': {
        const v5286 = v3273[1];
        undefined /* setApiDetails */;
        const v5305 = v5286[stdlib.checkedBigNumberify('./index.rsh:168:10:spread', stdlib.UInt_max, '0')];
        ;
        const v5362 = v2995[stdlib.checkedBigNumberify('./index.rsh:123:31:dot', stdlib.UInt_max, '1')];
        const v5363 = v5362[stdlib.checkedBigNumberify('./index.rsh:123:31:dot', stdlib.UInt_max, '0')];
        const v5364 = stdlib.add(v5363, v5305);
        const v5366 = stdlib.Array_set(v5362, '0', v5364);
        const v5367 = stdlib.Array_set(v2995, stdlib.checkedBigNumberify('./index.rsh:123:31:dot', stdlib.UInt_max, '1'), v5366);
        ;
        ;
        const v5459 = stdlib.le(v3274, v2920);
        stdlib.assert(v5459, {
          at: 'reach standard library:57:5:application',
          fs: ['at ./index.rsh:172:16:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:171:20:application call to [unknown function] (defined at: ./index.rsh:171:20:function exp)'],
          msg: 'Staking period has ended',
          who: 'Deployer'
          });
        const v5462 = stdlib.eq(v3028, stdlib.checkedBigNumberify('./index.rsh:132:29:decimal', stdlib.UInt_max, '0'));
        let v5464;
        if (v5462) {
          v5464 = v3027;
          }
        else {
          const v5478 = stdlib.safeDiv(stdlib.checkedBigNumberify('reach standard library:252:57:application', stdlib.UInt_max, '10000000000000'), v3028);
          const v5487 = stdlib.safeSub(v3274, v3025);
          const v5496 = stdlib.safeMul(v5478, v5487);
          const v5499 = {
            i: v5496,
            scale: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '10000000')
            };
          const v5500 = {
            i: v5499,
            sign: true
            };
          const v5505 = stdlib.lt(v3033, stdlib.checkedBigNumberify('reach standard library:317:22:application', stdlib.UInt_max, '10000000'));
          const v5508 = v5505 ? stdlib.checkedBigNumberify('reach standard library:317:22:application', stdlib.UInt_max, '10000000') : v3033;
          let v5509;
          const v5512 = stdlib.eq(v3033, v5508);
          if (v5512) {
            v5509 = v3027;
            }
          else {
            const v5520 = stdlib.safeMul(v3034, v5508);
            const v5527 = stdlib.safeDiv(v5520, v3033);
            const v5530 = {
              i: v5527,
              scale: v5508
              };
            const v5531 = {
              i: v5530,
              sign: v3031
              };
            v5509 = v5531;
            }
          let v5534;
          const v5535 = stdlib.eq(stdlib.checkedBigNumberify('reach standard library:317:22:application', stdlib.UInt_max, '10000000'), v5508);
          if (v5535) {
            v5534 = v5500;
            }
          else {
            const v5541 = stdlib.safeMul(v5496, v5508);
            const v5545 = stdlib.safeDiv(v5541, stdlib.checkedBigNumberify('reach standard library:317:22:application', stdlib.UInt_max, '10000000'));
            const v5548 = {
              i: v5545,
              scale: v5508
              };
            const v5549 = {
              i: v5548,
              sign: true
              };
            v5534 = v5549;
            }
          const v5553 = v5509.sign;
          const v5554 = v5509.i;
          const v5555 = v5554.i;
          const v5556 = {
            i: v5555,
            sign: v5553
            };
          const v5558 = v5534.sign;
          const v5559 = v5534.i;
          const v5560 = v5559.i;
          const v5561 = {
            i: v5560,
            sign: v5558
            };
          let v5563;
          const v5564 = v5558 ? false : true;
          const v5565 = v5553 ? v5558 : v5564;
          if (v5565) {
            const v5566 = stdlib.safeAdd(v5555, v5560);
            const v5567 = {
              i: v5566,
              sign: v5553
              };
            v5563 = v5567;
            }
          else {
            const v5569 = stdlib.gt(v5555, v5560);
            const v5572 = [v5556, v5561];
            const v5575 = [v5561, v5556];
            const v5576 = v5569 ? v5572 : v5575;
            const v5577 = v5576[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '0')];
            const v5578 = v5576[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '1')];
            const v5579 = v5577.sign;
            const v5580 = v5577.i;
            const v5581 = v5578.i;
            const v5582 = stdlib.safeSub(v5580, v5581);
            const v5583 = {
              i: v5582,
              sign: v5579
              };
            v5563 = v5583;
            }
          const v5585 = v5563.sign;
          const v5586 = v5563.i;
          const v5587 = {
            i: v5586,
            scale: v5508
            };
          const v5588 = {
            i: v5587,
            sign: v5585
            };
          v5464 = v5588;
          }
        const v5594 = stdlib.protect(map1_ctc, await stdlib.mapRef(map1, ctc10, v3272, ctc5), null);
        const v5597 = stdlib.fromSome(v5594, v2985);
        const v5598 = stdlib.protect(map0_ctc, await stdlib.mapRef(map0, ctc10, v3272, ctc1), null);
        const v5599 = stdlib.fromSome(v5598, stdlib.checkedBigNumberify('./index.rsh:99:68:decimal', stdlib.UInt_max, '0'));
        const v5604 = stdlib.protect(map2_ctc, await stdlib.mapRef(map2, ctc10, v3272, ctc5), null);
        const v5607 = stdlib.fromSome(v5604, v2985);
        const v5608 = v5464.i;
        const v5609 = v5608.scale;
        const v5610 = v5607.i;
        const v5611 = v5610.scale;
        const v5612 = stdlib.lt(v5609, v5611);
        const v5617 = v5612 ? v5611 : v5609;
        let v5618;
        const v5621 = stdlib.eq(v5609, v5617);
        if (v5621) {
          v5618 = v5464;
          }
        else {
          const v5622 = v5464.sign;
          const v5624 = v5608.i;
          const v5629 = stdlib.safeMul(v5624, v5617);
          const v5636 = stdlib.safeDiv(v5629, v5609);
          const v5639 = {
            i: v5636,
            scale: v5617
            };
          const v5640 = {
            i: v5639,
            sign: v5622
            };
          v5618 = v5640;
          }
        let v5643;
        const v5646 = stdlib.eq(v5611, v5617);
        if (v5646) {
          v5643 = v5607;
          }
        else {
          const v5647 = v5607.sign;
          const v5649 = v5610.i;
          const v5654 = stdlib.safeMul(v5649, v5617);
          const v5661 = stdlib.safeDiv(v5654, v5611);
          const v5664 = {
            i: v5661,
            scale: v5617
            };
          const v5665 = {
            i: v5664,
            sign: v5647
            };
          v5643 = v5665;
          }
        const v5669 = v5618.sign;
        const v5670 = v5618.i;
        const v5671 = v5670.i;
        const v5672 = {
          i: v5671,
          sign: v5669
          };
        const v5674 = v5643.sign;
        const v5675 = v5643.i;
        const v5676 = v5675.i;
        const v5679 = v5674 ? false : true;
        const v5680 = {
          i: v5676,
          sign: v5679
          };
        let v5681;
        const v5683 = v5669 ? v5679 : v5674;
        if (v5683) {
          const v5684 = stdlib.safeAdd(v5671, v5676);
          const v5685 = {
            i: v5684,
            sign: v5669
            };
          v5681 = v5685;
          }
        else {
          const v5687 = stdlib.gt(v5671, v5676);
          const v5690 = [v5672, v5680];
          const v5693 = [v5680, v5672];
          const v5694 = v5687 ? v5690 : v5693;
          const v5695 = v5694[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '0')];
          const v5696 = v5694[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '1')];
          const v5697 = v5695.sign;
          const v5698 = v5695.i;
          const v5699 = v5696.i;
          const v5700 = stdlib.safeSub(v5698, v5699);
          const v5701 = {
            i: v5700,
            sign: v5697
            };
          v5681 = v5701;
          }
        const v5703 = v5681.sign;
        const v5704 = v5681.i;
        const v5714 = stdlib.safeMul(v5599, v5704);
        const v5721 = v5597.i;
        const v5722 = v5721.scale;
        const v5723 = stdlib.lt(v5722, v5617);
        const v5726 = v5723 ? v5617 : v5722;
        let v5727;
        const v5730 = stdlib.eq(v5722, v5726);
        if (v5730) {
          v5727 = v5597;
          }
        else {
          const v5731 = v5597.sign;
          const v5733 = v5721.i;
          const v5738 = stdlib.safeMul(v5733, v5726);
          const v5745 = stdlib.safeDiv(v5738, v5722);
          const v5748 = {
            i: v5745,
            scale: v5726
            };
          const v5749 = {
            i: v5748,
            sign: v5731
            };
          v5727 = v5749;
          }
        let v5752;
        const v5753 = stdlib.eq(v5617, v5726);
        if (v5753) {
          const v5754 = {
            i: v5714,
            scale: v5726
            };
          const v5755 = {
            i: v5754,
            sign: v5703
            };
          v5752 = v5755;
          }
        else {
          const v5760 = stdlib.safeMul(v5714, v5726);
          const v5765 = stdlib.safeDiv(v5760, v5617);
          const v5768 = {
            i: v5765,
            scale: v5726
            };
          const v5769 = {
            i: v5768,
            sign: v5703
            };
          v5752 = v5769;
          }
        const v5773 = v5727.sign;
        const v5774 = v5727.i;
        const v5775 = v5774.i;
        const v5776 = {
          i: v5775,
          sign: v5773
          };
        const v5778 = v5752.sign;
        const v5779 = v5752.i;
        const v5780 = v5779.i;
        const v5781 = {
          i: v5780,
          sign: v5778
          };
        let v5783;
        const v5784 = v5778 ? false : true;
        const v5785 = v5773 ? v5778 : v5784;
        if (v5785) {
          const v5786 = stdlib.safeAdd(v5775, v5780);
          const v5787 = {
            i: v5786,
            sign: v5773
            };
          v5783 = v5787;
          }
        else {
          const v5789 = stdlib.gt(v5775, v5780);
          const v5792 = [v5776, v5781];
          const v5795 = [v5781, v5776];
          const v5796 = v5789 ? v5792 : v5795;
          const v5797 = v5796[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '0')];
          const v5798 = v5796[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '1')];
          const v5799 = v5797.sign;
          const v5800 = v5797.i;
          const v5801 = v5798.i;
          const v5802 = stdlib.safeSub(v5800, v5801);
          const v5803 = {
            i: v5802,
            sign: v5799
            };
          v5783 = v5803;
          }
        const v5805 = v5783.sign;
        const v5806 = v5783.i;
        const v5807 = {
          i: v5806,
          scale: v5726
          };
        const v5808 = {
          i: v5807,
          sign: v5805
          };
        await stdlib.mapSet(map1, ctc10, v3272, ctc5, v5808);
        await stdlib.mapSet(map2, ctc10, v3272, ctc5, v5464);
        const v5815 = stdlib.safeAdd(v5599, v5305);
        await stdlib.mapSet(map0, ctc10, v3272, ctc1, v5815);
        const v5816 = null;
        await txn4.getOutput('stake', 'v5816', ctc0, v5816);
        const v5829 = stdlib.safeAdd(v3028, v5305);
        const v5831 = {
          lastUpdateTime: v3274,
          prizeClaimed: v3026,
          rewardPerToken: v5464,
          totalStake: v5829,
          winner: v3029
          };
        const cv2988 = v5831;
        const cv2989 = v3274;
        const cv2995 = v5367;
        
        v2988 = cv2988;
        v2989 = cv2989;
        v2995 = cv2995;
        
        txn3 = txn4;
        continue;
        break;
        }
      case 'unstake0_195': {
        const v6291 = v3273[1];
        undefined /* setApiDetails */;
        ;
        const v6367 = v2995[stdlib.checkedBigNumberify('./index.rsh:123:31:dot', stdlib.UInt_max, '1')];
        const v6368 = v6367[stdlib.checkedBigNumberify('./index.rsh:123:31:dot', stdlib.UInt_max, '0')];
        ;
        ;
        const v6839 = v6291[stdlib.checkedBigNumberify('./index.rsh:188:10:spread', stdlib.UInt_max, '0')];
        const v6840 = stdlib.protect(map0_ctc, await stdlib.mapRef(map0, ctc10, v3272, ctc1), null);
        const v6841 = stdlib.fromSome(v6840, stdlib.checkedBigNumberify('./index.rsh:99:68:decimal', stdlib.UInt_max, '0'));
        const v6842 = stdlib.le(v6839, v6841);
        stdlib.assert(v6842, {
          at: 'reach standard library:57:5:application',
          fs: ['at ./index.rsh:189:12:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:196:20:application call to [unknown function] (defined at: ./index.rsh:196:20:function exp)'],
          msg: 'Trying to unstake more than staked amount',
          who: 'Deployer'
          });
        const v6846 = stdlib.le(v6839, v6368);
        stdlib.assert(v6846, {
          at: 'reach standard library:57:5:application',
          fs: ['at ./index.rsh:193:12:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:196:20:application call to [unknown function] (defined at: ./index.rsh:196:20:function exp)'],
          msg: 'Insufficient tokens in contract',
          who: 'Deployer'
          });
        const v6850 = stdlib.le(v3274, v2920);
        stdlib.assert(v6850, {
          at: 'reach standard library:57:5:application',
          fs: ['at ./index.rsh:197:16:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:196:20:application call to [unknown function] (defined at: ./index.rsh:196:20:function exp)'],
          msg: 'Staking period has ended',
          who: 'Deployer'
          });
        const v6853 = stdlib.eq(v3028, stdlib.checkedBigNumberify('./index.rsh:132:29:decimal', stdlib.UInt_max, '0'));
        let v6855;
        if (v6853) {
          v6855 = v3027;
          }
        else {
          const v6869 = stdlib.safeDiv(stdlib.checkedBigNumberify('reach standard library:252:57:application', stdlib.UInt_max, '10000000000000'), v3028);
          const v6878 = stdlib.safeSub(v3274, v3025);
          const v6887 = stdlib.safeMul(v6869, v6878);
          const v6890 = {
            i: v6887,
            scale: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '10000000')
            };
          const v6891 = {
            i: v6890,
            sign: true
            };
          const v6896 = stdlib.lt(v3033, stdlib.checkedBigNumberify('reach standard library:317:22:application', stdlib.UInt_max, '10000000'));
          const v6899 = v6896 ? stdlib.checkedBigNumberify('reach standard library:317:22:application', stdlib.UInt_max, '10000000') : v3033;
          let v6900;
          const v6903 = stdlib.eq(v3033, v6899);
          if (v6903) {
            v6900 = v3027;
            }
          else {
            const v6911 = stdlib.safeMul(v3034, v6899);
            const v6918 = stdlib.safeDiv(v6911, v3033);
            const v6921 = {
              i: v6918,
              scale: v6899
              };
            const v6922 = {
              i: v6921,
              sign: v3031
              };
            v6900 = v6922;
            }
          let v6925;
          const v6926 = stdlib.eq(stdlib.checkedBigNumberify('reach standard library:317:22:application', stdlib.UInt_max, '10000000'), v6899);
          if (v6926) {
            v6925 = v6891;
            }
          else {
            const v6932 = stdlib.safeMul(v6887, v6899);
            const v6936 = stdlib.safeDiv(v6932, stdlib.checkedBigNumberify('reach standard library:317:22:application', stdlib.UInt_max, '10000000'));
            const v6939 = {
              i: v6936,
              scale: v6899
              };
            const v6940 = {
              i: v6939,
              sign: true
              };
            v6925 = v6940;
            }
          const v6944 = v6900.sign;
          const v6945 = v6900.i;
          const v6946 = v6945.i;
          const v6947 = {
            i: v6946,
            sign: v6944
            };
          const v6949 = v6925.sign;
          const v6950 = v6925.i;
          const v6951 = v6950.i;
          const v6952 = {
            i: v6951,
            sign: v6949
            };
          let v6954;
          const v6955 = v6949 ? false : true;
          const v6956 = v6944 ? v6949 : v6955;
          if (v6956) {
            const v6957 = stdlib.safeAdd(v6946, v6951);
            const v6958 = {
              i: v6957,
              sign: v6944
              };
            v6954 = v6958;
            }
          else {
            const v6960 = stdlib.gt(v6946, v6951);
            const v6963 = [v6947, v6952];
            const v6966 = [v6952, v6947];
            const v6967 = v6960 ? v6963 : v6966;
            const v6968 = v6967[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '0')];
            const v6969 = v6967[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '1')];
            const v6970 = v6968.sign;
            const v6971 = v6968.i;
            const v6972 = v6969.i;
            const v6973 = stdlib.safeSub(v6971, v6972);
            const v6974 = {
              i: v6973,
              sign: v6970
              };
            v6954 = v6974;
            }
          const v6976 = v6954.sign;
          const v6977 = v6954.i;
          const v6978 = {
            i: v6977,
            scale: v6899
            };
          const v6979 = {
            i: v6978,
            sign: v6976
            };
          v6855 = v6979;
          }
        const v6985 = stdlib.protect(map1_ctc, await stdlib.mapRef(map1, ctc10, v3272, ctc5), null);
        const v6988 = stdlib.fromSome(v6985, v2985);
        const v6995 = stdlib.protect(map2_ctc, await stdlib.mapRef(map2, ctc10, v3272, ctc5), null);
        const v6998 = stdlib.fromSome(v6995, v2985);
        const v6999 = v6855.i;
        const v7000 = v6999.scale;
        const v7001 = v6998.i;
        const v7002 = v7001.scale;
        const v7003 = stdlib.lt(v7000, v7002);
        const v7008 = v7003 ? v7002 : v7000;
        let v7009;
        const v7012 = stdlib.eq(v7000, v7008);
        if (v7012) {
          v7009 = v6855;
          }
        else {
          const v7013 = v6855.sign;
          const v7015 = v6999.i;
          const v7020 = stdlib.safeMul(v7015, v7008);
          const v7027 = stdlib.safeDiv(v7020, v7000);
          const v7030 = {
            i: v7027,
            scale: v7008
            };
          const v7031 = {
            i: v7030,
            sign: v7013
            };
          v7009 = v7031;
          }
        let v7034;
        const v7037 = stdlib.eq(v7002, v7008);
        if (v7037) {
          v7034 = v6998;
          }
        else {
          const v7038 = v6998.sign;
          const v7040 = v7001.i;
          const v7045 = stdlib.safeMul(v7040, v7008);
          const v7052 = stdlib.safeDiv(v7045, v7002);
          const v7055 = {
            i: v7052,
            scale: v7008
            };
          const v7056 = {
            i: v7055,
            sign: v7038
            };
          v7034 = v7056;
          }
        const v7060 = v7009.sign;
        const v7061 = v7009.i;
        const v7062 = v7061.i;
        const v7063 = {
          i: v7062,
          sign: v7060
          };
        const v7065 = v7034.sign;
        const v7066 = v7034.i;
        const v7067 = v7066.i;
        const v7070 = v7065 ? false : true;
        const v7071 = {
          i: v7067,
          sign: v7070
          };
        let v7072;
        const v7074 = v7060 ? v7070 : v7065;
        if (v7074) {
          const v7075 = stdlib.safeAdd(v7062, v7067);
          const v7076 = {
            i: v7075,
            sign: v7060
            };
          v7072 = v7076;
          }
        else {
          const v7078 = stdlib.gt(v7062, v7067);
          const v7081 = [v7063, v7071];
          const v7084 = [v7071, v7063];
          const v7085 = v7078 ? v7081 : v7084;
          const v7086 = v7085[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '0')];
          const v7087 = v7085[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '1')];
          const v7088 = v7086.sign;
          const v7089 = v7086.i;
          const v7090 = v7087.i;
          const v7091 = stdlib.safeSub(v7089, v7090);
          const v7092 = {
            i: v7091,
            sign: v7088
            };
          v7072 = v7092;
          }
        const v7094 = v7072.sign;
        const v7095 = v7072.i;
        const v7105 = stdlib.safeMul(v6841, v7095);
        const v7112 = v6988.i;
        const v7113 = v7112.scale;
        const v7114 = stdlib.lt(v7113, v7008);
        const v7117 = v7114 ? v7008 : v7113;
        let v7118;
        const v7121 = stdlib.eq(v7113, v7117);
        if (v7121) {
          v7118 = v6988;
          }
        else {
          const v7122 = v6988.sign;
          const v7124 = v7112.i;
          const v7129 = stdlib.safeMul(v7124, v7117);
          const v7136 = stdlib.safeDiv(v7129, v7113);
          const v7139 = {
            i: v7136,
            scale: v7117
            };
          const v7140 = {
            i: v7139,
            sign: v7122
            };
          v7118 = v7140;
          }
        let v7143;
        const v7144 = stdlib.eq(v7008, v7117);
        if (v7144) {
          const v7145 = {
            i: v7105,
            scale: v7117
            };
          const v7146 = {
            i: v7145,
            sign: v7094
            };
          v7143 = v7146;
          }
        else {
          const v7151 = stdlib.safeMul(v7105, v7117);
          const v7156 = stdlib.safeDiv(v7151, v7008);
          const v7159 = {
            i: v7156,
            scale: v7117
            };
          const v7160 = {
            i: v7159,
            sign: v7094
            };
          v7143 = v7160;
          }
        const v7164 = v7118.sign;
        const v7165 = v7118.i;
        const v7166 = v7165.i;
        const v7167 = {
          i: v7166,
          sign: v7164
          };
        const v7169 = v7143.sign;
        const v7170 = v7143.i;
        const v7171 = v7170.i;
        const v7172 = {
          i: v7171,
          sign: v7169
          };
        let v7174;
        const v7175 = v7169 ? false : true;
        const v7176 = v7164 ? v7169 : v7175;
        if (v7176) {
          const v7177 = stdlib.safeAdd(v7166, v7171);
          const v7178 = {
            i: v7177,
            sign: v7164
            };
          v7174 = v7178;
          }
        else {
          const v7180 = stdlib.gt(v7166, v7171);
          const v7183 = [v7167, v7172];
          const v7186 = [v7172, v7167];
          const v7187 = v7180 ? v7183 : v7186;
          const v7188 = v7187[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '0')];
          const v7189 = v7187[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '1')];
          const v7190 = v7188.sign;
          const v7191 = v7188.i;
          const v7192 = v7189.i;
          const v7193 = stdlib.safeSub(v7191, v7192);
          const v7194 = {
            i: v7193,
            sign: v7190
            };
          v7174 = v7194;
          }
        const v7196 = v7174.sign;
        const v7197 = v7174.i;
        const v7198 = {
          i: v7197,
          scale: v7117
          };
        const v7199 = {
          i: v7198,
          sign: v7196
          };
        await stdlib.mapSet(map1, ctc10, v3272, ctc5, v7199);
        await stdlib.mapSet(map2, ctc10, v3272, ctc5, v6855);
        const v7206 = stdlib.safeSub(v6841, v6839);
        await stdlib.mapSet(map0, ctc10, v3272, ctc1, v7206);
        const v7224 = stdlib.sub(v6368, v6839);
        const v7226 = stdlib.Array_set(v6367, '0', v7224);
        const v7227 = stdlib.Array_set(v2995, stdlib.checkedBigNumberify('./index.rsh:203:44:application', stdlib.UInt_max, '1'), v7226);
        ;
        const v7228 = null;
        await txn4.getOutput('unstake', 'v7228', ctc0, v7228);
        const v7241 = stdlib.safeSub(v3028, v6839);
        const v7243 = {
          lastUpdateTime: v3274,
          prizeClaimed: v3026,
          rewardPerToken: v6855,
          totalStake: v7241,
          winner: v3029
          };
        const cv2988 = v7243;
        const cv2989 = v3274;
        const cv2995 = v7227;
        
        v2988 = cv2988;
        v2989 = cv2989;
        v2995 = cv2995;
        
        txn3 = txn4;
        continue;
        break;
        }
      case 'updateTime0_195': {
        const v7296 = v3273[1];
        undefined /* setApiDetails */;
        ;
        ;
        ;
        const v8251 = v3274;
        await txn4.getOutput('updateTime', 'v8251', ctc1, v8251);
        const cv2988 = v2988;
        const cv2989 = v3274;
        const cv2995 = v2995;
        
        v2988 = cv2988;
        v2989 = cv2989;
        v2995 = cv2995;
        
        txn3 = txn4;
        continue;
        break;
        }
      case 'withdrawAll0_195': {
        const v8301 = v3273[1];
        undefined /* setApiDetails */;
        ;
        const v8377 = v2995[stdlib.checkedBigNumberify('./index.rsh:123:31:dot', stdlib.UInt_max, '1')];
        const v8378 = v8377[stdlib.checkedBigNumberify('./index.rsh:123:31:dot', stdlib.UInt_max, '0')];
        ;
        ;
        const v9263 = stdlib.protect(map3_ctc, await stdlib.mapRef(map3, ctc10, v3272, ctc4), null);
        const v9264 = stdlib.fromSome(v9263, false);
        const v9265 = v9264 ? false : true;
        stdlib.assert(v9265, {
          at: 'reach standard library:57:5:application',
          fs: ['at ./index.rsh:216:12:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:223:20:application call to [unknown function] (defined at: ./index.rsh:223:20:function exp)'],
          msg: 'Already withdrawn previously',
          who: 'Deployer'
          });
        const v9267 = stdlib.protect(map0_ctc, await stdlib.mapRef(map0, ctc10, v3272, ctc1), null);
        const v9268 = stdlib.fromSome(v9267, stdlib.checkedBigNumberify('./index.rsh:99:68:decimal', stdlib.UInt_max, '0'));
        const v9271 = stdlib.le(v9268, v8378);
        stdlib.assert(v9271, {
          at: 'reach standard library:57:5:application',
          fs: ['at ./index.rsh:217:12:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:223:20:application call to [unknown function] (defined at: ./index.rsh:223:20:function exp)'],
          msg: 'Insufficient tokens in contract',
          who: 'Deployer'
          });
        const v9274 = stdlib.le(v3274, v2920);
        const v9275 = v9274 ? false : true;
        stdlib.assert(v9275, {
          at: 'reach standard library:57:5:application',
          fs: ['at ./index.rsh:224:16:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:223:20:application call to [unknown function] (defined at: ./index.rsh:223:20:function exp)'],
          msg: 'Withdrawal period has not started',
          who: 'Deployer'
          });
        await stdlib.mapSet(map3, ctc10, v3272, ctc4, true);
        const v9296 = stdlib.sub(v8378, v9268);
        const v9298 = stdlib.Array_set(v8377, '0', v9296);
        const v9299 = stdlib.Array_set(v2995, stdlib.checkedBigNumberify('./index.rsh:226:58:application', stdlib.UInt_max, '1'), v9298);
        ;
        const v9300 = null;
        await txn4.getOutput('withdrawAll', 'v9300', ctc0, v9300);
        const cv2988 = v2988;
        const cv2989 = v3274;
        const cv2995 = v9299;
        
        v2988 = cv2988;
        v2989 = cv2989;
        v2995 = cv2995;
        
        txn3 = txn4;
        continue;
        break;
        }
      }
    
    }
  return;
  
  
  
  
  };
export async function _claim4(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for _claim4 expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for _claim4 expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Null;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Data({
    None: ctc0,
    Some: ctc1
    });
  const ctc3 = stdlib.T_Object({
    i: ctc1,
    scale: ctc1
    });
  const ctc4 = stdlib.T_Bool;
  const ctc5 = stdlib.T_Object({
    i: ctc3,
    sign: ctc4
    });
  const ctc6 = stdlib.T_Data({
    None: ctc0,
    Some: ctc5
    });
  const ctc7 = stdlib.T_Data({
    None: ctc0,
    Some: ctc4
    });
  const ctc8 = stdlib.T_Address;
  const ctc9 = stdlib.T_Token;
  const ctc10 = stdlib.T_Data({
    None: ctc0,
    Some: ctc8
    });
  const ctc11 = stdlib.T_Object({
    lastUpdateTime: ctc1,
    prizeClaimed: ctc4,
    rewardPerToken: ctc5,
    totalStake: ctc1,
    winner: ctc10
    });
  const ctc12 = stdlib.T_Tuple([ctc1, ctc1, ctc4]);
  const ctc13 = stdlib.T_Array(ctc12, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '2'));
  const ctc14 = stdlib.T_Struct([['scale', ctc1], ['i', ctc1]]);
  const ctc15 = stdlib.T_Struct([['sign', ctc4], ['i', ctc14]]);
  const ctc16 = stdlib.T_Tuple([]);
  const ctc17 = stdlib.T_Tuple([ctc8]);
  const ctc18 = stdlib.T_Tuple([ctc1]);
  const ctc19 = stdlib.T_Data({
    claim0_195: ctc16,
    setWinner0_195: ctc17,
    stake0_195: ctc18,
    unstake0_195: ctc18,
    updateTime0_195: ctc16,
    withdrawAll0_195: ctc16
    });
  
  const map0_ctc = ctc2;
  const map0 = stdlib.newMap({
    ctc: ctc,
    idx: 0,
    isAPI: true
    });
  
  const map1_ctc = ctc6;
  const map1 = stdlib.newMap({
    ctc: ctc,
    idx: 1,
    isAPI: true
    });
  
  const map2_ctc = ctc6;
  const map2 = stdlib.newMap({
    ctc: ctc,
    idx: 2,
    isAPI: true
    });
  
  const map3_ctc = ctc7;
  const map3 = stdlib.newMap({
    ctc: ctc,
    idx: 3,
    isAPI: true
    });
  
  
  const [v2917, v2918, v2919, v2920, v2985, v2988, v2995, v3025, v3026, v3027, v3028, v3029, v3031, v3033, v3034, v3036] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '4'), [ctc8, ctc9, ctc9, ctc1, ctc5, ctc11, ctc13, ctc1, ctc4, ctc5, ctc1, ctc10, ctc4, ctc1, ctc1, ctc15]);
  const v3092 = ctc.selfAddress();
  const v3094 = stdlib.protect(ctc16, await interact.in(), {
    at: './index.rsh:1:23:application',
    fs: ['at ./index.rsh:232:29:application call to [unknown function] (defined at: ./index.rsh:232:29:function exp)', 'at ./index.rsh:123:31:application call to "runclaim0_195" (defined at: ./index.rsh:232:10:function exp)', 'at ./index.rsh:123:31:application call to [unknown function] (defined at: ./index.rsh:123:31:function exp)'],
    msg: 'in',
    who: 'claim'
    });
  const v3096 = v3026 ? false : true;
  stdlib.assert(v3096, {
    at: 'reach standard library:57:5:application',
    fs: ['at ./index.rsh:233:12:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:232:29:application call to [unknown function] (defined at: ./index.rsh:232:29:function exp)', 'at ./index.rsh:123:31:application call to "runclaim0_195" (defined at: ./index.rsh:232:10:function exp)', 'at ./index.rsh:123:31:application call to [unknown function] (defined at: ./index.rsh:123:31:function exp)'],
    msg: 'Prize already claimed',
    who: 'claim'
    });
  let v3099;
  switch (v3029[0]) {
    case 'None': {
      const v3100 = v3029[1];
      v3099 = false;
      
      break;
      }
    case 'Some': {
      const v3101 = v3029[1];
      const v3102 = stdlib.addressEq(v3101, v3092);
      v3099 = v3102;
      
      break;
      }
    }
  stdlib.assert(v3099, {
    at: 'reach standard library:57:5:application',
    fs: ['at ./index.rsh:234:12:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:232:29:application call to [unknown function] (defined at: ./index.rsh:232:29:function exp)', 'at ./index.rsh:123:31:application call to "runclaim0_195" (defined at: ./index.rsh:232:10:function exp)', 'at ./index.rsh:123:31:application call to [unknown function] (defined at: ./index.rsh:123:31:function exp)'],
    msg: 'Not winner',
    who: 'claim'
    });
  const v3104 = v2995[stdlib.checkedBigNumberify('./index.rsh:238:25:application', stdlib.UInt_max, '0')];
  const v3105 = v3104[stdlib.checkedBigNumberify('./index.rsh:238:25:application', stdlib.UInt_max, '0')];
  const v3106 = stdlib.le(stdlib.checkedBigNumberify('./index.rsh:238:13:decimal', stdlib.UInt_max, '1'), v3105);
  stdlib.assert(v3106, {
    at: 'reach standard library:57:5:application',
    fs: ['at ./index.rsh:238:12:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:232:29:application call to [unknown function] (defined at: ./index.rsh:232:29:function exp)', 'at ./index.rsh:123:31:application call to "runclaim0_195" (defined at: ./index.rsh:232:10:function exp)', 'at ./index.rsh:123:31:application call to [unknown function] (defined at: ./index.rsh:123:31:function exp)'],
    msg: 'Insufficient tokens in contract',
    who: 'claim'
    });
  const v3111 = ['claim0_195', v3094];
  
  const txn1 = await (ctc.sendrecv({
    args: [v2917, v2918, v2919, v2920, v2985, v2988, v2995, v3025, v3026, v3027, v3028, v3029, v3031, v3033, v3034, v3036, v3111],
    evt_cnt: 1,
    funcNum: 3,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '0'),
    onlyIf: true,
    out_tys: [ctc19],
    pay: [stdlib.checkedBigNumberify('./index.rsh:232:10:decimal', stdlib.UInt_max, '0'), [[stdlib.checkedBigNumberify('./index.rsh:167:14:decimal', stdlib.UInt_max, '0'), v2919], [stdlib.checkedBigNumberify('./index.rsh:167:14:decimal', stdlib.UInt_max, '0'), v2918]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      let sim_txn_ctr = stdlib.UInt_max;
      const getSimTokCtr = () => { sim_txn_ctr = sim_txn_ctr.sub(1); return sim_txn_ctr; };
      
      stdlib.simMapDupe(sim_r, 0, map0);
      stdlib.simMapDupe(sim_r, 1, map1);
      stdlib.simMapDupe(sim_r, 2, map2);
      stdlib.simMapDupe(sim_r, 3, map3);
      
      const {data: [v3273], secs: v3275, time: v3274, didSend: v1278, from: v3272 } = txn1;
      
      switch (v3273[0]) {
        case 'claim0_195': {
          const v3276 = v3273[1];
          sim_r.txns.push({
            kind: 'api',
            who: "claim"
            });
          ;
          ;
          const v3358 = v2995[stdlib.checkedBigNumberify('./index.rsh:123:31:dot', stdlib.UInt_max, '0')];
          const v3359 = v3358[stdlib.checkedBigNumberify('./index.rsh:123:31:dot', stdlib.UInt_max, '0')];
          ;
          const v3399 = stdlib.sub(v3359, stdlib.checkedBigNumberify('./index.rsh:96:53:decimal', stdlib.UInt_max, '1'));
          const v3401 = stdlib.Array_set(v3358, '0', v3399);
          const v3402 = stdlib.Array_set(v2995, stdlib.checkedBigNumberify('./index.rsh:243:39:application', stdlib.UInt_max, '0'), v3401);
          sim_r.txns.push({
            kind: 'from',
            to: v3272,
            tok: v2918
            });
          const v3403 = null;
          const v3404 = await txn1.getOutput('claim', 'v3403', ctc0, v3403);
          
          const v3414 = {
            lastUpdateTime: v3025,
            prizeClaimed: true,
            rewardPerToken: v3027,
            totalStake: v3028,
            winner: v3029
            };
          const v10418 = v3414;
          const v10420 = v3402;
          const v10421 = v3414.lastUpdateTime;
          const v10422 = v3414.prizeClaimed;
          const v10423 = v3414.rewardPerToken;
          const v10424 = v3414.totalStake;
          const v10425 = v3414.winner;
          const v10426 = v10423.sign;
          const v10427 = v10423.i;
          const v10428 = v10427.scale;
          const v10429 = v10427.i;
          const v10430 = {
            i: v10429,
            scale: v10428
            };
          const v10431 = {
            i: v10430,
            sign: v10426
            };
          sim_r.isHalt = false;
          
          break;
          }
        case 'setWinner0_195': {
          const v4281 = v3273[1];
          
          break;
          }
        case 'stake0_195': {
          const v5286 = v3273[1];
          
          break;
          }
        case 'unstake0_195': {
          const v6291 = v3273[1];
          
          break;
          }
        case 'updateTime0_195': {
          const v7296 = v3273[1];
          
          break;
          }
        case 'withdrawAll0_195': {
          const v8301 = v3273[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined /* mto */,
    tys: [ctc8, ctc9, ctc9, ctc1, ctc5, ctc11, ctc13, ctc1, ctc4, ctc5, ctc1, ctc10, ctc4, ctc1, ctc1, ctc15, ctc19],
    waitIfNotPresent: false
    }));
  const {data: [v3273], secs: v3275, time: v3274, didSend: v1278, from: v3272 } = txn1;
  switch (v3273[0]) {
    case 'claim0_195': {
      const v3276 = v3273[1];
      undefined /* setApiDetails */;
      ;
      ;
      const v3358 = v2995[stdlib.checkedBigNumberify('./index.rsh:123:31:dot', stdlib.UInt_max, '0')];
      const v3359 = v3358[stdlib.checkedBigNumberify('./index.rsh:123:31:dot', stdlib.UInt_max, '0')];
      ;
      const v3366 = v3026 ? false : true;
      stdlib.assert(v3366, {
        at: 'reach standard library:57:5:application',
        fs: ['at ./index.rsh:233:12:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:241:20:application call to [unknown function] (defined at: ./index.rsh:241:20:function exp)'],
        msg: 'Prize already claimed',
        who: 'claim'
        });
      let v3369;
      switch (v3029[0]) {
        case 'None': {
          const v3370 = v3029[1];
          v3369 = false;
          
          break;
          }
        case 'Some': {
          const v3371 = v3029[1];
          const v3372 = stdlib.addressEq(v3371, v3272);
          v3369 = v3372;
          
          break;
          }
        }
      stdlib.assert(v3369, {
        at: 'reach standard library:57:5:application',
        fs: ['at ./index.rsh:234:12:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:241:20:application call to [unknown function] (defined at: ./index.rsh:241:20:function exp)'],
        msg: 'Not winner',
        who: 'claim'
        });
      const v3376 = stdlib.le(stdlib.checkedBigNumberify('./index.rsh:238:13:decimal', stdlib.UInt_max, '1'), v3359);
      stdlib.assert(v3376, {
        at: 'reach standard library:57:5:application',
        fs: ['at ./index.rsh:238:12:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:241:20:application call to [unknown function] (defined at: ./index.rsh:241:20:function exp)'],
        msg: 'Insufficient tokens in contract',
        who: 'claim'
        });
      const v3379 = stdlib.le(v3274, v2920);
      const v3380 = v3379 ? false : true;
      stdlib.assert(v3380, {
        at: 'reach standard library:57:5:application',
        fs: ['at ./index.rsh:242:16:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:241:20:application call to [unknown function] (defined at: ./index.rsh:241:20:function exp)'],
        msg: 'Claiming period has not started',
        who: 'claim'
        });
      const v3399 = stdlib.sub(v3359, stdlib.checkedBigNumberify('./index.rsh:96:53:decimal', stdlib.UInt_max, '1'));
      const v3401 = stdlib.Array_set(v3358, '0', v3399);
      const v3402 = stdlib.Array_set(v2995, stdlib.checkedBigNumberify('./index.rsh:243:39:application', stdlib.UInt_max, '0'), v3401);
      ;
      const v3403 = null;
      const v3404 = await txn1.getOutput('claim', 'v3403', ctc0, v3403);
      if (v1278) {
        stdlib.protect(ctc0, await interact.out(v3276, v3404), {
          at: './index.rsh:232:11:application',
          fs: ['at ./index.rsh:232:11:application call to [unknown function] (defined at: ./index.rsh:232:11:function exp)', 'at ./index.rsh:244:19:application call to "callback" (defined at: ./index.rsh:241:20:function exp)', 'at ./index.rsh:241:20:application call to [unknown function] (defined at: ./index.rsh:241:20:function exp)'],
          msg: 'out',
          who: 'claim'
          });
        }
      else {
        }
      
      const v3414 = {
        lastUpdateTime: v3025,
        prizeClaimed: true,
        rewardPerToken: v3027,
        totalStake: v3028,
        winner: v3029
        };
      const v10418 = v3414;
      const v10420 = v3402;
      const v10421 = v3414.lastUpdateTime;
      const v10422 = v3414.prizeClaimed;
      const v10423 = v3414.rewardPerToken;
      const v10424 = v3414.totalStake;
      const v10425 = v3414.winner;
      const v10426 = v10423.sign;
      const v10427 = v10423.i;
      const v10428 = v10427.scale;
      const v10429 = v10427.i;
      const v10430 = {
        i: v10429,
        scale: v10428
        };
      const v10431 = {
        i: v10430,
        sign: v10426
        };
      return;
      
      break;
      }
    case 'setWinner0_195': {
      const v4281 = v3273[1];
      return;
      break;
      }
    case 'stake0_195': {
      const v5286 = v3273[1];
      return;
      break;
      }
    case 'unstake0_195': {
      const v6291 = v3273[1];
      return;
      break;
      }
    case 'updateTime0_195': {
      const v7296 = v3273[1];
      return;
      break;
      }
    case 'withdrawAll0_195': {
      const v8301 = v3273[1];
      return;
      break;
      }
    }
  
  
  };
export async function _setWinner4(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for _setWinner4 expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for _setWinner4 expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Null;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Data({
    None: ctc0,
    Some: ctc1
    });
  const ctc3 = stdlib.T_Object({
    i: ctc1,
    scale: ctc1
    });
  const ctc4 = stdlib.T_Bool;
  const ctc5 = stdlib.T_Object({
    i: ctc3,
    sign: ctc4
    });
  const ctc6 = stdlib.T_Data({
    None: ctc0,
    Some: ctc5
    });
  const ctc7 = stdlib.T_Data({
    None: ctc0,
    Some: ctc4
    });
  const ctc8 = stdlib.T_Address;
  const ctc9 = stdlib.T_Token;
  const ctc10 = stdlib.T_Data({
    None: ctc0,
    Some: ctc8
    });
  const ctc11 = stdlib.T_Object({
    lastUpdateTime: ctc1,
    prizeClaimed: ctc4,
    rewardPerToken: ctc5,
    totalStake: ctc1,
    winner: ctc10
    });
  const ctc12 = stdlib.T_Tuple([ctc1, ctc1, ctc4]);
  const ctc13 = stdlib.T_Array(ctc12, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '2'));
  const ctc14 = stdlib.T_Struct([['scale', ctc1], ['i', ctc1]]);
  const ctc15 = stdlib.T_Struct([['sign', ctc4], ['i', ctc14]]);
  const ctc16 = stdlib.T_Tuple([ctc8]);
  const ctc17 = stdlib.T_Tuple([]);
  const ctc18 = stdlib.T_Tuple([ctc1]);
  const ctc19 = stdlib.T_Data({
    claim0_195: ctc17,
    setWinner0_195: ctc16,
    stake0_195: ctc18,
    unstake0_195: ctc18,
    updateTime0_195: ctc17,
    withdrawAll0_195: ctc17
    });
  
  const map0_ctc = ctc2;
  const map0 = stdlib.newMap({
    ctc: ctc,
    idx: 0,
    isAPI: true
    });
  
  const map1_ctc = ctc6;
  const map1 = stdlib.newMap({
    ctc: ctc,
    idx: 1,
    isAPI: true
    });
  
  const map2_ctc = ctc6;
  const map2 = stdlib.newMap({
    ctc: ctc,
    idx: 2,
    isAPI: true
    });
  
  const map3_ctc = ctc7;
  const map3 = stdlib.newMap({
    ctc: ctc,
    idx: 3,
    isAPI: true
    });
  
  
  const [v2917, v2918, v2919, v2920, v2985, v2988, v2995, v3025, v3026, v3027, v3028, v3029, v3031, v3033, v3034, v3036] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '4'), [ctc8, ctc9, ctc9, ctc1, ctc5, ctc11, ctc13, ctc1, ctc4, ctc5, ctc1, ctc10, ctc4, ctc1, ctc1, ctc15]);
  const v3113 = ctc.selfAddress();
  const v3115 = stdlib.protect(ctc16, await interact.in(), {
    at: './index.rsh:1:23:application',
    fs: ['at ./index.rsh:249:48:application call to [unknown function] (defined at: ./index.rsh:249:48:function exp)', 'at ./index.rsh:123:31:application call to "runsetWinner0_195" (defined at: ./index.rsh:249:10:function exp)', 'at ./index.rsh:123:31:application call to [unknown function] (defined at: ./index.rsh:123:31:function exp)'],
    msg: 'in',
    who: 'setWinner'
    });
  const v3118 = stdlib.addressEq(v3113, v2917);
  stdlib.assert(v3118, {
    at: 'reach standard library:57:5:application',
    fs: ['at ./index.rsh:250:12:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:249:48:application call to [unknown function] (defined at: ./index.rsh:249:48:function exp)', 'at ./index.rsh:123:31:application call to "runsetWinner0_195" (defined at: ./index.rsh:249:10:function exp)', 'at ./index.rsh:123:31:application call to [unknown function] (defined at: ./index.rsh:123:31:function exp)'],
    msg: 'Only admin is allowed to set winner',
    who: 'setWinner'
    });
  const v3121 = {
    None: 0,
    Some: 1
    }[v3029[0]];
  const v3122 = stdlib.eq(v3121, stdlib.checkedBigNumberify('reach standard library:39:41:application', stdlib.UInt_max, '0'));
  stdlib.assert(v3122, {
    at: 'reach standard library:57:5:application',
    fs: ['at ./index.rsh:251:12:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:249:48:application call to [unknown function] (defined at: ./index.rsh:249:48:function exp)', 'at ./index.rsh:123:31:application call to "runsetWinner0_195" (defined at: ./index.rsh:249:10:function exp)', 'at ./index.rsh:123:31:application call to [unknown function] (defined at: ./index.rsh:123:31:function exp)'],
    msg: 'Winner can only be set once',
    who: 'setWinner'
    });
  const v3129 = ['setWinner0_195', v3115];
  
  const txn1 = await (ctc.sendrecv({
    args: [v2917, v2918, v2919, v2920, v2985, v2988, v2995, v3025, v3026, v3027, v3028, v3029, v3031, v3033, v3034, v3036, v3129],
    evt_cnt: 1,
    funcNum: 3,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '0'),
    onlyIf: true,
    out_tys: [ctc19],
    pay: [stdlib.checkedBigNumberify('./index.rsh:249:10:decimal', stdlib.UInt_max, '0'), [[stdlib.checkedBigNumberify('./index.rsh:167:14:decimal', stdlib.UInt_max, '0'), v2919], [stdlib.checkedBigNumberify('./index.rsh:167:14:decimal', stdlib.UInt_max, '0'), v2918]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      let sim_txn_ctr = stdlib.UInt_max;
      const getSimTokCtr = () => { sim_txn_ctr = sim_txn_ctr.sub(1); return sim_txn_ctr; };
      
      stdlib.simMapDupe(sim_r, 0, map0);
      stdlib.simMapDupe(sim_r, 1, map1);
      stdlib.simMapDupe(sim_r, 2, map2);
      stdlib.simMapDupe(sim_r, 3, map3);
      
      const {data: [v3273], secs: v3275, time: v3274, didSend: v1278, from: v3272 } = txn1;
      
      switch (v3273[0]) {
        case 'claim0_195': {
          const v3276 = v3273[1];
          
          break;
          }
        case 'setWinner0_195': {
          const v4281 = v3273[1];
          sim_r.txns.push({
            kind: 'api',
            who: "setWinner"
            });
          ;
          ;
          ;
          const v4422 = v4281[stdlib.checkedBigNumberify('./index.rsh:249:10:spread', stdlib.UInt_max, '0')];
          const v4434 = null;
          const v4435 = await txn1.getOutput('setWinner', 'v4434', ctc0, v4434);
          
          const v4446 = ['Some', v4422];
          const v4447 = {
            lastUpdateTime: v3025,
            prizeClaimed: v3026,
            rewardPerToken: v3027,
            totalStake: v3028,
            winner: v4446
            };
          const v10593 = v4447;
          const v10595 = v2995;
          const v10596 = v4447.lastUpdateTime;
          const v10597 = v4447.prizeClaimed;
          const v10598 = v4447.rewardPerToken;
          const v10599 = v4447.totalStake;
          const v10600 = v4447.winner;
          const v10601 = v10598.sign;
          const v10602 = v10598.i;
          const v10603 = v10602.scale;
          const v10604 = v10602.i;
          const v10605 = {
            i: v10604,
            scale: v10603
            };
          const v10606 = {
            i: v10605,
            sign: v10601
            };
          sim_r.isHalt = false;
          
          break;
          }
        case 'stake0_195': {
          const v5286 = v3273[1];
          
          break;
          }
        case 'unstake0_195': {
          const v6291 = v3273[1];
          
          break;
          }
        case 'updateTime0_195': {
          const v7296 = v3273[1];
          
          break;
          }
        case 'withdrawAll0_195': {
          const v8301 = v3273[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined /* mto */,
    tys: [ctc8, ctc9, ctc9, ctc1, ctc5, ctc11, ctc13, ctc1, ctc4, ctc5, ctc1, ctc10, ctc4, ctc1, ctc1, ctc15, ctc19],
    waitIfNotPresent: false
    }));
  const {data: [v3273], secs: v3275, time: v3274, didSend: v1278, from: v3272 } = txn1;
  switch (v3273[0]) {
    case 'claim0_195': {
      const v3276 = v3273[1];
      return;
      break;
      }
    case 'setWinner0_195': {
      const v4281 = v3273[1];
      undefined /* setApiDetails */;
      ;
      ;
      ;
      const v4422 = v4281[stdlib.checkedBigNumberify('./index.rsh:249:10:spread', stdlib.UInt_max, '0')];
      const v4423 = stdlib.addressEq(v3272, v2917);
      stdlib.assert(v4423, {
        at: 'reach standard library:57:5:application',
        fs: ['at ./index.rsh:250:12:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:254:20:application call to [unknown function] (defined at: ./index.rsh:254:20:function exp)'],
        msg: 'Only admin is allowed to set winner',
        who: 'setWinner'
        });
      const v4426 = {
        None: 0,
        Some: 1
        }[v3029[0]];
      const v4427 = stdlib.eq(v4426, stdlib.checkedBigNumberify('reach standard library:39:41:application', stdlib.UInt_max, '0'));
      stdlib.assert(v4427, {
        at: 'reach standard library:57:5:application',
        fs: ['at ./index.rsh:251:12:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:254:20:application call to [unknown function] (defined at: ./index.rsh:254:20:function exp)'],
        msg: 'Winner can only be set once',
        who: 'setWinner'
        });
      const v4431 = stdlib.le(v3274, v2920);
      const v4432 = v4431 ? false : true;
      stdlib.assert(v4432, {
        at: 'reach standard library:57:5:application',
        fs: ['at ./index.rsh:255:16:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:254:20:application call to [unknown function] (defined at: ./index.rsh:254:20:function exp)'],
        msg: 'Winner can only be set after staking period',
        who: 'setWinner'
        });
      const v4434 = null;
      const v4435 = await txn1.getOutput('setWinner', 'v4434', ctc0, v4434);
      if (v1278) {
        stdlib.protect(ctc0, await interact.out(v4281, v4435), {
          at: './index.rsh:249:11:application',
          fs: ['at ./index.rsh:249:11:application call to [unknown function] (defined at: ./index.rsh:249:11:function exp)', 'at ./index.rsh:259:19:application call to "callback" (defined at: ./index.rsh:254:20:function exp)', 'at ./index.rsh:254:20:application call to [unknown function] (defined at: ./index.rsh:254:20:function exp)'],
          msg: 'out',
          who: 'setWinner'
          });
        }
      else {
        }
      
      const v4446 = ['Some', v4422];
      const v4447 = {
        lastUpdateTime: v3025,
        prizeClaimed: v3026,
        rewardPerToken: v3027,
        totalStake: v3028,
        winner: v4446
        };
      const v10593 = v4447;
      const v10595 = v2995;
      const v10596 = v4447.lastUpdateTime;
      const v10597 = v4447.prizeClaimed;
      const v10598 = v4447.rewardPerToken;
      const v10599 = v4447.totalStake;
      const v10600 = v4447.winner;
      const v10601 = v10598.sign;
      const v10602 = v10598.i;
      const v10603 = v10602.scale;
      const v10604 = v10602.i;
      const v10605 = {
        i: v10604,
        scale: v10603
        };
      const v10606 = {
        i: v10605,
        sign: v10601
        };
      return;
      
      break;
      }
    case 'stake0_195': {
      const v5286 = v3273[1];
      return;
      break;
      }
    case 'unstake0_195': {
      const v6291 = v3273[1];
      return;
      break;
      }
    case 'updateTime0_195': {
      const v7296 = v3273[1];
      return;
      break;
      }
    case 'withdrawAll0_195': {
      const v8301 = v3273[1];
      return;
      break;
      }
    }
  
  
  };
export async function _stake4(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for _stake4 expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for _stake4 expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Null;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Data({
    None: ctc0,
    Some: ctc1
    });
  const ctc3 = stdlib.T_Object({
    i: ctc1,
    scale: ctc1
    });
  const ctc4 = stdlib.T_Bool;
  const ctc5 = stdlib.T_Object({
    i: ctc3,
    sign: ctc4
    });
  const ctc6 = stdlib.T_Data({
    None: ctc0,
    Some: ctc5
    });
  const ctc7 = stdlib.T_Data({
    None: ctc0,
    Some: ctc4
    });
  const ctc8 = stdlib.T_Address;
  const ctc9 = stdlib.T_Token;
  const ctc10 = stdlib.T_Data({
    None: ctc0,
    Some: ctc8
    });
  const ctc11 = stdlib.T_Object({
    lastUpdateTime: ctc1,
    prizeClaimed: ctc4,
    rewardPerToken: ctc5,
    totalStake: ctc1,
    winner: ctc10
    });
  const ctc12 = stdlib.T_Tuple([ctc1, ctc1, ctc4]);
  const ctc13 = stdlib.T_Array(ctc12, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '2'));
  const ctc14 = stdlib.T_Struct([['scale', ctc1], ['i', ctc1]]);
  const ctc15 = stdlib.T_Struct([['sign', ctc4], ['i', ctc14]]);
  const ctc16 = stdlib.T_Tuple([ctc1]);
  const ctc17 = stdlib.T_Tuple([]);
  const ctc18 = stdlib.T_Tuple([ctc8]);
  const ctc19 = stdlib.T_Data({
    claim0_195: ctc17,
    setWinner0_195: ctc18,
    stake0_195: ctc16,
    unstake0_195: ctc16,
    updateTime0_195: ctc17,
    withdrawAll0_195: ctc17
    });
  
  const map0_ctc = ctc2;
  const map0 = stdlib.newMap({
    ctc: ctc,
    idx: 0,
    isAPI: true
    });
  
  const map1_ctc = ctc6;
  const map1 = stdlib.newMap({
    ctc: ctc,
    idx: 1,
    isAPI: true
    });
  
  const map2_ctc = ctc6;
  const map2 = stdlib.newMap({
    ctc: ctc,
    idx: 2,
    isAPI: true
    });
  
  const map3_ctc = ctc7;
  const map3 = stdlib.newMap({
    ctc: ctc,
    idx: 3,
    isAPI: true
    });
  
  
  const [v2917, v2918, v2919, v2920, v2985, v2988, v2995, v3025, v3026, v3027, v3028, v3029, v3031, v3033, v3034, v3036] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '4'), [ctc8, ctc9, ctc9, ctc1, ctc5, ctc11, ctc13, ctc1, ctc4, ctc5, ctc1, ctc10, ctc4, ctc1, ctc1, ctc15]);
  const v3044 = stdlib.protect(ctc16, await interact.in(), {
    at: './index.rsh:1:23:application',
    fs: ['at ./index.rsh:168:32:application call to [unknown function] (defined at: ./index.rsh:168:32:function exp)', 'at ./index.rsh:123:31:application call to "runstake0_195" (defined at: ./index.rsh:168:10:function exp)', 'at ./index.rsh:123:31:application call to [unknown function] (defined at: ./index.rsh:123:31:function exp)'],
    msg: 'in',
    who: 'stake'
    });
  const v3045 = v3044[stdlib.checkedBigNumberify('./index.rsh:1:23:application', stdlib.UInt_max, '0')];
  const v3052 = ['stake0_195', v3044];
  
  const txn1 = await (ctc.sendrecv({
    args: [v2917, v2918, v2919, v2920, v2985, v2988, v2995, v3025, v3026, v3027, v3028, v3029, v3031, v3033, v3034, v3036, v3052],
    evt_cnt: 1,
    funcNum: 3,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '0'),
    onlyIf: true,
    out_tys: [ctc19],
    pay: [stdlib.checkedBigNumberify('./index.rsh:95:37:decimal', stdlib.UInt_max, '0'), [[v3045, v2919], [stdlib.checkedBigNumberify('./index.rsh:95:60:decimal', stdlib.UInt_max, '0'), v2918]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      let sim_txn_ctr = stdlib.UInt_max;
      const getSimTokCtr = () => { sim_txn_ctr = sim_txn_ctr.sub(1); return sim_txn_ctr; };
      
      stdlib.simMapDupe(sim_r, 0, map0);
      stdlib.simMapDupe(sim_r, 1, map1);
      stdlib.simMapDupe(sim_r, 2, map2);
      stdlib.simMapDupe(sim_r, 3, map3);
      
      const {data: [v3273], secs: v3275, time: v3274, didSend: v1278, from: v3272 } = txn1;
      
      switch (v3273[0]) {
        case 'claim0_195': {
          const v3276 = v3273[1];
          
          break;
          }
        case 'setWinner0_195': {
          const v4281 = v3273[1];
          
          break;
          }
        case 'stake0_195': {
          const v5286 = v3273[1];
          sim_r.txns.push({
            kind: 'api',
            who: "stake"
            });
          const v5305 = v5286[stdlib.checkedBigNumberify('./index.rsh:168:10:spread', stdlib.UInt_max, '0')];
          ;
          const v5362 = v2995[stdlib.checkedBigNumberify('./index.rsh:123:31:dot', stdlib.UInt_max, '1')];
          const v5363 = v5362[stdlib.checkedBigNumberify('./index.rsh:123:31:dot', stdlib.UInt_max, '0')];
          const v5364 = stdlib.add(v5363, v5305);
          const v5366 = stdlib.Array_set(v5362, '0', v5364);
          const v5367 = stdlib.Array_set(v2995, stdlib.checkedBigNumberify('./index.rsh:123:31:dot', stdlib.UInt_max, '1'), v5366);
          sim_r.txns.push({
            amt: v5305,
            kind: 'to',
            tok: v2919
            });
          ;
          const v5462 = stdlib.eq(v3028, stdlib.checkedBigNumberify('./index.rsh:132:29:decimal', stdlib.UInt_max, '0'));
          let v5464;
          if (v5462) {
            v5464 = v3027;
            }
          else {
            const v5478 = stdlib.safeDiv(stdlib.checkedBigNumberify('reach standard library:252:57:application', stdlib.UInt_max, '10000000000000'), v3028);
            const v5487 = stdlib.safeSub(v3274, v3025);
            const v5496 = stdlib.safeMul(v5478, v5487);
            const v5499 = {
              i: v5496,
              scale: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '10000000')
              };
            const v5500 = {
              i: v5499,
              sign: true
              };
            const v5505 = stdlib.lt(v3033, stdlib.checkedBigNumberify('reach standard library:317:22:application', stdlib.UInt_max, '10000000'));
            const v5508 = v5505 ? stdlib.checkedBigNumberify('reach standard library:317:22:application', stdlib.UInt_max, '10000000') : v3033;
            let v5509;
            const v5512 = stdlib.eq(v3033, v5508);
            if (v5512) {
              v5509 = v3027;
              }
            else {
              const v5520 = stdlib.safeMul(v3034, v5508);
              const v5527 = stdlib.safeDiv(v5520, v3033);
              const v5530 = {
                i: v5527,
                scale: v5508
                };
              const v5531 = {
                i: v5530,
                sign: v3031
                };
              v5509 = v5531;
              }
            let v5534;
            const v5535 = stdlib.eq(stdlib.checkedBigNumberify('reach standard library:317:22:application', stdlib.UInt_max, '10000000'), v5508);
            if (v5535) {
              v5534 = v5500;
              }
            else {
              const v5541 = stdlib.safeMul(v5496, v5508);
              const v5545 = stdlib.safeDiv(v5541, stdlib.checkedBigNumberify('reach standard library:317:22:application', stdlib.UInt_max, '10000000'));
              const v5548 = {
                i: v5545,
                scale: v5508
                };
              const v5549 = {
                i: v5548,
                sign: true
                };
              v5534 = v5549;
              }
            const v5553 = v5509.sign;
            const v5554 = v5509.i;
            const v5555 = v5554.i;
            const v5556 = {
              i: v5555,
              sign: v5553
              };
            const v5558 = v5534.sign;
            const v5559 = v5534.i;
            const v5560 = v5559.i;
            const v5561 = {
              i: v5560,
              sign: v5558
              };
            let v5563;
            const v5564 = v5558 ? false : true;
            const v5565 = v5553 ? v5558 : v5564;
            if (v5565) {
              const v5566 = stdlib.safeAdd(v5555, v5560);
              const v5567 = {
                i: v5566,
                sign: v5553
                };
              v5563 = v5567;
              }
            else {
              const v5569 = stdlib.gt(v5555, v5560);
              const v5572 = [v5556, v5561];
              const v5575 = [v5561, v5556];
              const v5576 = v5569 ? v5572 : v5575;
              const v5577 = v5576[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '0')];
              const v5578 = v5576[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '1')];
              const v5579 = v5577.sign;
              const v5580 = v5577.i;
              const v5581 = v5578.i;
              const v5582 = stdlib.safeSub(v5580, v5581);
              const v5583 = {
                i: v5582,
                sign: v5579
                };
              v5563 = v5583;
              }
            const v5585 = v5563.sign;
            const v5586 = v5563.i;
            const v5587 = {
              i: v5586,
              scale: v5508
              };
            const v5588 = {
              i: v5587,
              sign: v5585
              };
            v5464 = v5588;
            }
          const v5594 = stdlib.protect(map1_ctc, await stdlib.simMapRef(sim_r, 1, ctc8, v3272, ctc5), null);
          const v5597 = stdlib.fromSome(v5594, v2985);
          const v5598 = stdlib.protect(map0_ctc, await stdlib.simMapRef(sim_r, 0, ctc8, v3272, ctc1), null);
          const v5599 = stdlib.fromSome(v5598, stdlib.checkedBigNumberify('./index.rsh:99:68:decimal', stdlib.UInt_max, '0'));
          const v5604 = stdlib.protect(map2_ctc, await stdlib.simMapRef(sim_r, 2, ctc8, v3272, ctc5), null);
          const v5607 = stdlib.fromSome(v5604, v2985);
          const v5608 = v5464.i;
          const v5609 = v5608.scale;
          const v5610 = v5607.i;
          const v5611 = v5610.scale;
          const v5612 = stdlib.lt(v5609, v5611);
          const v5617 = v5612 ? v5611 : v5609;
          let v5618;
          const v5621 = stdlib.eq(v5609, v5617);
          if (v5621) {
            v5618 = v5464;
            }
          else {
            const v5622 = v5464.sign;
            const v5624 = v5608.i;
            const v5629 = stdlib.safeMul(v5624, v5617);
            const v5636 = stdlib.safeDiv(v5629, v5609);
            const v5639 = {
              i: v5636,
              scale: v5617
              };
            const v5640 = {
              i: v5639,
              sign: v5622
              };
            v5618 = v5640;
            }
          let v5643;
          const v5646 = stdlib.eq(v5611, v5617);
          if (v5646) {
            v5643 = v5607;
            }
          else {
            const v5647 = v5607.sign;
            const v5649 = v5610.i;
            const v5654 = stdlib.safeMul(v5649, v5617);
            const v5661 = stdlib.safeDiv(v5654, v5611);
            const v5664 = {
              i: v5661,
              scale: v5617
              };
            const v5665 = {
              i: v5664,
              sign: v5647
              };
            v5643 = v5665;
            }
          const v5669 = v5618.sign;
          const v5670 = v5618.i;
          const v5671 = v5670.i;
          const v5672 = {
            i: v5671,
            sign: v5669
            };
          const v5674 = v5643.sign;
          const v5675 = v5643.i;
          const v5676 = v5675.i;
          const v5679 = v5674 ? false : true;
          const v5680 = {
            i: v5676,
            sign: v5679
            };
          let v5681;
          const v5683 = v5669 ? v5679 : v5674;
          if (v5683) {
            const v5684 = stdlib.safeAdd(v5671, v5676);
            const v5685 = {
              i: v5684,
              sign: v5669
              };
            v5681 = v5685;
            }
          else {
            const v5687 = stdlib.gt(v5671, v5676);
            const v5690 = [v5672, v5680];
            const v5693 = [v5680, v5672];
            const v5694 = v5687 ? v5690 : v5693;
            const v5695 = v5694[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '0')];
            const v5696 = v5694[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '1')];
            const v5697 = v5695.sign;
            const v5698 = v5695.i;
            const v5699 = v5696.i;
            const v5700 = stdlib.safeSub(v5698, v5699);
            const v5701 = {
              i: v5700,
              sign: v5697
              };
            v5681 = v5701;
            }
          const v5703 = v5681.sign;
          const v5704 = v5681.i;
          const v5714 = stdlib.safeMul(v5599, v5704);
          const v5721 = v5597.i;
          const v5722 = v5721.scale;
          const v5723 = stdlib.lt(v5722, v5617);
          const v5726 = v5723 ? v5617 : v5722;
          let v5727;
          const v5730 = stdlib.eq(v5722, v5726);
          if (v5730) {
            v5727 = v5597;
            }
          else {
            const v5731 = v5597.sign;
            const v5733 = v5721.i;
            const v5738 = stdlib.safeMul(v5733, v5726);
            const v5745 = stdlib.safeDiv(v5738, v5722);
            const v5748 = {
              i: v5745,
              scale: v5726
              };
            const v5749 = {
              i: v5748,
              sign: v5731
              };
            v5727 = v5749;
            }
          let v5752;
          const v5753 = stdlib.eq(v5617, v5726);
          if (v5753) {
            const v5754 = {
              i: v5714,
              scale: v5726
              };
            const v5755 = {
              i: v5754,
              sign: v5703
              };
            v5752 = v5755;
            }
          else {
            const v5760 = stdlib.safeMul(v5714, v5726);
            const v5765 = stdlib.safeDiv(v5760, v5617);
            const v5768 = {
              i: v5765,
              scale: v5726
              };
            const v5769 = {
              i: v5768,
              sign: v5703
              };
            v5752 = v5769;
            }
          const v5773 = v5727.sign;
          const v5774 = v5727.i;
          const v5775 = v5774.i;
          const v5776 = {
            i: v5775,
            sign: v5773
            };
          const v5778 = v5752.sign;
          const v5779 = v5752.i;
          const v5780 = v5779.i;
          const v5781 = {
            i: v5780,
            sign: v5778
            };
          let v5783;
          const v5784 = v5778 ? false : true;
          const v5785 = v5773 ? v5778 : v5784;
          if (v5785) {
            const v5786 = stdlib.safeAdd(v5775, v5780);
            const v5787 = {
              i: v5786,
              sign: v5773
              };
            v5783 = v5787;
            }
          else {
            const v5789 = stdlib.gt(v5775, v5780);
            const v5792 = [v5776, v5781];
            const v5795 = [v5781, v5776];
            const v5796 = v5789 ? v5792 : v5795;
            const v5797 = v5796[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '0')];
            const v5798 = v5796[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '1')];
            const v5799 = v5797.sign;
            const v5800 = v5797.i;
            const v5801 = v5798.i;
            const v5802 = stdlib.safeSub(v5800, v5801);
            const v5803 = {
              i: v5802,
              sign: v5799
              };
            v5783 = v5803;
            }
          const v5805 = v5783.sign;
          const v5806 = v5783.i;
          const v5807 = {
            i: v5806,
            scale: v5726
            };
          const v5808 = {
            i: v5807,
            sign: v5805
            };
          await stdlib.simMapSet(sim_r, 1, ctc8, v3272, ctc5, v5808);
          await stdlib.simMapSet(sim_r, 2, ctc8, v3272, ctc5, v5464);
          const v5815 = stdlib.safeAdd(v5599, v5305);
          await stdlib.simMapSet(sim_r, 0, ctc8, v3272, ctc1, v5815);
          const v5816 = null;
          const v5817 = await txn1.getOutput('stake', 'v5816', ctc0, v5816);
          
          const v5829 = stdlib.safeAdd(v3028, v5305);
          const v5831 = {
            lastUpdateTime: v3274,
            prizeClaimed: v3026,
            rewardPerToken: v5464,
            totalStake: v5829,
            winner: v3029
            };
          const v10768 = v5831;
          const v10770 = v5367;
          const v10771 = v5831.lastUpdateTime;
          const v10772 = v5831.prizeClaimed;
          const v10773 = v5831.rewardPerToken;
          const v10774 = v5831.totalStake;
          const v10775 = v5831.winner;
          const v10776 = v10773.sign;
          const v10777 = v10773.i;
          const v10778 = v10777.scale;
          const v10779 = v10777.i;
          const v10780 = {
            i: v10779,
            scale: v10778
            };
          const v10781 = {
            i: v10780,
            sign: v10776
            };
          sim_r.isHalt = false;
          
          break;
          }
        case 'unstake0_195': {
          const v6291 = v3273[1];
          
          break;
          }
        case 'updateTime0_195': {
          const v7296 = v3273[1];
          
          break;
          }
        case 'withdrawAll0_195': {
          const v8301 = v3273[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined /* mto */,
    tys: [ctc8, ctc9, ctc9, ctc1, ctc5, ctc11, ctc13, ctc1, ctc4, ctc5, ctc1, ctc10, ctc4, ctc1, ctc1, ctc15, ctc19],
    waitIfNotPresent: false
    }));
  const {data: [v3273], secs: v3275, time: v3274, didSend: v1278, from: v3272 } = txn1;
  switch (v3273[0]) {
    case 'claim0_195': {
      const v3276 = v3273[1];
      return;
      break;
      }
    case 'setWinner0_195': {
      const v4281 = v3273[1];
      return;
      break;
      }
    case 'stake0_195': {
      const v5286 = v3273[1];
      undefined /* setApiDetails */;
      const v5305 = v5286[stdlib.checkedBigNumberify('./index.rsh:168:10:spread', stdlib.UInt_max, '0')];
      ;
      const v5362 = v2995[stdlib.checkedBigNumberify('./index.rsh:123:31:dot', stdlib.UInt_max, '1')];
      const v5363 = v5362[stdlib.checkedBigNumberify('./index.rsh:123:31:dot', stdlib.UInt_max, '0')];
      const v5364 = stdlib.add(v5363, v5305);
      const v5366 = stdlib.Array_set(v5362, '0', v5364);
      const v5367 = stdlib.Array_set(v2995, stdlib.checkedBigNumberify('./index.rsh:123:31:dot', stdlib.UInt_max, '1'), v5366);
      ;
      ;
      const v5459 = stdlib.le(v3274, v2920);
      stdlib.assert(v5459, {
        at: 'reach standard library:57:5:application',
        fs: ['at ./index.rsh:172:16:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:171:20:application call to [unknown function] (defined at: ./index.rsh:171:20:function exp)'],
        msg: 'Staking period has ended',
        who: 'stake'
        });
      const v5462 = stdlib.eq(v3028, stdlib.checkedBigNumberify('./index.rsh:132:29:decimal', stdlib.UInt_max, '0'));
      let v5464;
      if (v5462) {
        v5464 = v3027;
        }
      else {
        const v5478 = stdlib.safeDiv(stdlib.checkedBigNumberify('reach standard library:252:57:application', stdlib.UInt_max, '10000000000000'), v3028);
        const v5487 = stdlib.safeSub(v3274, v3025);
        const v5496 = stdlib.safeMul(v5478, v5487);
        const v5499 = {
          i: v5496,
          scale: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '10000000')
          };
        const v5500 = {
          i: v5499,
          sign: true
          };
        const v5505 = stdlib.lt(v3033, stdlib.checkedBigNumberify('reach standard library:317:22:application', stdlib.UInt_max, '10000000'));
        const v5508 = v5505 ? stdlib.checkedBigNumberify('reach standard library:317:22:application', stdlib.UInt_max, '10000000') : v3033;
        let v5509;
        const v5512 = stdlib.eq(v3033, v5508);
        if (v5512) {
          v5509 = v3027;
          }
        else {
          const v5520 = stdlib.safeMul(v3034, v5508);
          const v5527 = stdlib.safeDiv(v5520, v3033);
          const v5530 = {
            i: v5527,
            scale: v5508
            };
          const v5531 = {
            i: v5530,
            sign: v3031
            };
          v5509 = v5531;
          }
        let v5534;
        const v5535 = stdlib.eq(stdlib.checkedBigNumberify('reach standard library:317:22:application', stdlib.UInt_max, '10000000'), v5508);
        if (v5535) {
          v5534 = v5500;
          }
        else {
          const v5541 = stdlib.safeMul(v5496, v5508);
          const v5545 = stdlib.safeDiv(v5541, stdlib.checkedBigNumberify('reach standard library:317:22:application', stdlib.UInt_max, '10000000'));
          const v5548 = {
            i: v5545,
            scale: v5508
            };
          const v5549 = {
            i: v5548,
            sign: true
            };
          v5534 = v5549;
          }
        const v5553 = v5509.sign;
        const v5554 = v5509.i;
        const v5555 = v5554.i;
        const v5556 = {
          i: v5555,
          sign: v5553
          };
        const v5558 = v5534.sign;
        const v5559 = v5534.i;
        const v5560 = v5559.i;
        const v5561 = {
          i: v5560,
          sign: v5558
          };
        let v5563;
        const v5564 = v5558 ? false : true;
        const v5565 = v5553 ? v5558 : v5564;
        if (v5565) {
          const v5566 = stdlib.safeAdd(v5555, v5560);
          const v5567 = {
            i: v5566,
            sign: v5553
            };
          v5563 = v5567;
          }
        else {
          const v5569 = stdlib.gt(v5555, v5560);
          const v5572 = [v5556, v5561];
          const v5575 = [v5561, v5556];
          const v5576 = v5569 ? v5572 : v5575;
          const v5577 = v5576[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '0')];
          const v5578 = v5576[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '1')];
          const v5579 = v5577.sign;
          const v5580 = v5577.i;
          const v5581 = v5578.i;
          const v5582 = stdlib.safeSub(v5580, v5581);
          const v5583 = {
            i: v5582,
            sign: v5579
            };
          v5563 = v5583;
          }
        const v5585 = v5563.sign;
        const v5586 = v5563.i;
        const v5587 = {
          i: v5586,
          scale: v5508
          };
        const v5588 = {
          i: v5587,
          sign: v5585
          };
        v5464 = v5588;
        }
      const v5594 = stdlib.protect(map1_ctc, await stdlib.mapRef(map1, ctc8, v3272, ctc5), null);
      const v5597 = stdlib.fromSome(v5594, v2985);
      const v5598 = stdlib.protect(map0_ctc, await stdlib.mapRef(map0, ctc8, v3272, ctc1), null);
      const v5599 = stdlib.fromSome(v5598, stdlib.checkedBigNumberify('./index.rsh:99:68:decimal', stdlib.UInt_max, '0'));
      const v5604 = stdlib.protect(map2_ctc, await stdlib.mapRef(map2, ctc8, v3272, ctc5), null);
      const v5607 = stdlib.fromSome(v5604, v2985);
      const v5608 = v5464.i;
      const v5609 = v5608.scale;
      const v5610 = v5607.i;
      const v5611 = v5610.scale;
      const v5612 = stdlib.lt(v5609, v5611);
      const v5617 = v5612 ? v5611 : v5609;
      let v5618;
      const v5621 = stdlib.eq(v5609, v5617);
      if (v5621) {
        v5618 = v5464;
        }
      else {
        const v5622 = v5464.sign;
        const v5624 = v5608.i;
        const v5629 = stdlib.safeMul(v5624, v5617);
        const v5636 = stdlib.safeDiv(v5629, v5609);
        const v5639 = {
          i: v5636,
          scale: v5617
          };
        const v5640 = {
          i: v5639,
          sign: v5622
          };
        v5618 = v5640;
        }
      let v5643;
      const v5646 = stdlib.eq(v5611, v5617);
      if (v5646) {
        v5643 = v5607;
        }
      else {
        const v5647 = v5607.sign;
        const v5649 = v5610.i;
        const v5654 = stdlib.safeMul(v5649, v5617);
        const v5661 = stdlib.safeDiv(v5654, v5611);
        const v5664 = {
          i: v5661,
          scale: v5617
          };
        const v5665 = {
          i: v5664,
          sign: v5647
          };
        v5643 = v5665;
        }
      const v5669 = v5618.sign;
      const v5670 = v5618.i;
      const v5671 = v5670.i;
      const v5672 = {
        i: v5671,
        sign: v5669
        };
      const v5674 = v5643.sign;
      const v5675 = v5643.i;
      const v5676 = v5675.i;
      const v5679 = v5674 ? false : true;
      const v5680 = {
        i: v5676,
        sign: v5679
        };
      let v5681;
      const v5683 = v5669 ? v5679 : v5674;
      if (v5683) {
        const v5684 = stdlib.safeAdd(v5671, v5676);
        const v5685 = {
          i: v5684,
          sign: v5669
          };
        v5681 = v5685;
        }
      else {
        const v5687 = stdlib.gt(v5671, v5676);
        const v5690 = [v5672, v5680];
        const v5693 = [v5680, v5672];
        const v5694 = v5687 ? v5690 : v5693;
        const v5695 = v5694[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '0')];
        const v5696 = v5694[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '1')];
        const v5697 = v5695.sign;
        const v5698 = v5695.i;
        const v5699 = v5696.i;
        const v5700 = stdlib.safeSub(v5698, v5699);
        const v5701 = {
          i: v5700,
          sign: v5697
          };
        v5681 = v5701;
        }
      const v5703 = v5681.sign;
      const v5704 = v5681.i;
      const v5714 = stdlib.safeMul(v5599, v5704);
      const v5721 = v5597.i;
      const v5722 = v5721.scale;
      const v5723 = stdlib.lt(v5722, v5617);
      const v5726 = v5723 ? v5617 : v5722;
      let v5727;
      const v5730 = stdlib.eq(v5722, v5726);
      if (v5730) {
        v5727 = v5597;
        }
      else {
        const v5731 = v5597.sign;
        const v5733 = v5721.i;
        const v5738 = stdlib.safeMul(v5733, v5726);
        const v5745 = stdlib.safeDiv(v5738, v5722);
        const v5748 = {
          i: v5745,
          scale: v5726
          };
        const v5749 = {
          i: v5748,
          sign: v5731
          };
        v5727 = v5749;
        }
      let v5752;
      const v5753 = stdlib.eq(v5617, v5726);
      if (v5753) {
        const v5754 = {
          i: v5714,
          scale: v5726
          };
        const v5755 = {
          i: v5754,
          sign: v5703
          };
        v5752 = v5755;
        }
      else {
        const v5760 = stdlib.safeMul(v5714, v5726);
        const v5765 = stdlib.safeDiv(v5760, v5617);
        const v5768 = {
          i: v5765,
          scale: v5726
          };
        const v5769 = {
          i: v5768,
          sign: v5703
          };
        v5752 = v5769;
        }
      const v5773 = v5727.sign;
      const v5774 = v5727.i;
      const v5775 = v5774.i;
      const v5776 = {
        i: v5775,
        sign: v5773
        };
      const v5778 = v5752.sign;
      const v5779 = v5752.i;
      const v5780 = v5779.i;
      const v5781 = {
        i: v5780,
        sign: v5778
        };
      let v5783;
      const v5784 = v5778 ? false : true;
      const v5785 = v5773 ? v5778 : v5784;
      if (v5785) {
        const v5786 = stdlib.safeAdd(v5775, v5780);
        const v5787 = {
          i: v5786,
          sign: v5773
          };
        v5783 = v5787;
        }
      else {
        const v5789 = stdlib.gt(v5775, v5780);
        const v5792 = [v5776, v5781];
        const v5795 = [v5781, v5776];
        const v5796 = v5789 ? v5792 : v5795;
        const v5797 = v5796[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '0')];
        const v5798 = v5796[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '1')];
        const v5799 = v5797.sign;
        const v5800 = v5797.i;
        const v5801 = v5798.i;
        const v5802 = stdlib.safeSub(v5800, v5801);
        const v5803 = {
          i: v5802,
          sign: v5799
          };
        v5783 = v5803;
        }
      const v5805 = v5783.sign;
      const v5806 = v5783.i;
      const v5807 = {
        i: v5806,
        scale: v5726
        };
      const v5808 = {
        i: v5807,
        sign: v5805
        };
      await stdlib.mapSet(map1, ctc8, v3272, ctc5, v5808);
      await stdlib.mapSet(map2, ctc8, v3272, ctc5, v5464);
      const v5815 = stdlib.safeAdd(v5599, v5305);
      await stdlib.mapSet(map0, ctc8, v3272, ctc1, v5815);
      const v5816 = null;
      const v5817 = await txn1.getOutput('stake', 'v5816', ctc0, v5816);
      if (v1278) {
        stdlib.protect(ctc0, await interact.out(v5286, v5817), {
          at: './index.rsh:168:11:application',
          fs: ['at ./index.rsh:168:11:application call to [unknown function] (defined at: ./index.rsh:168:11:function exp)', 'at ./index.rsh:178:19:application call to "callback" (defined at: ./index.rsh:171:20:function exp)', 'at ./index.rsh:171:20:application call to [unknown function] (defined at: ./index.rsh:171:20:function exp)'],
          msg: 'out',
          who: 'stake'
          });
        }
      else {
        }
      
      const v5829 = stdlib.safeAdd(v3028, v5305);
      const v5831 = {
        lastUpdateTime: v3274,
        prizeClaimed: v3026,
        rewardPerToken: v5464,
        totalStake: v5829,
        winner: v3029
        };
      const v10768 = v5831;
      const v10770 = v5367;
      const v10771 = v5831.lastUpdateTime;
      const v10772 = v5831.prizeClaimed;
      const v10773 = v5831.rewardPerToken;
      const v10774 = v5831.totalStake;
      const v10775 = v5831.winner;
      const v10776 = v10773.sign;
      const v10777 = v10773.i;
      const v10778 = v10777.scale;
      const v10779 = v10777.i;
      const v10780 = {
        i: v10779,
        scale: v10778
        };
      const v10781 = {
        i: v10780,
        sign: v10776
        };
      return;
      
      break;
      }
    case 'unstake0_195': {
      const v6291 = v3273[1];
      return;
      break;
      }
    case 'updateTime0_195': {
      const v7296 = v3273[1];
      return;
      break;
      }
    case 'withdrawAll0_195': {
      const v8301 = v3273[1];
      return;
      break;
      }
    }
  
  
  };
export async function _unstake4(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for _unstake4 expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for _unstake4 expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Null;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Data({
    None: ctc0,
    Some: ctc1
    });
  const ctc3 = stdlib.T_Object({
    i: ctc1,
    scale: ctc1
    });
  const ctc4 = stdlib.T_Bool;
  const ctc5 = stdlib.T_Object({
    i: ctc3,
    sign: ctc4
    });
  const ctc6 = stdlib.T_Data({
    None: ctc0,
    Some: ctc5
    });
  const ctc7 = stdlib.T_Data({
    None: ctc0,
    Some: ctc4
    });
  const ctc8 = stdlib.T_Address;
  const ctc9 = stdlib.T_Token;
  const ctc10 = stdlib.T_Data({
    None: ctc0,
    Some: ctc8
    });
  const ctc11 = stdlib.T_Object({
    lastUpdateTime: ctc1,
    prizeClaimed: ctc4,
    rewardPerToken: ctc5,
    totalStake: ctc1,
    winner: ctc10
    });
  const ctc12 = stdlib.T_Tuple([ctc1, ctc1, ctc4]);
  const ctc13 = stdlib.T_Array(ctc12, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '2'));
  const ctc14 = stdlib.T_Struct([['scale', ctc1], ['i', ctc1]]);
  const ctc15 = stdlib.T_Struct([['sign', ctc4], ['i', ctc14]]);
  const ctc16 = stdlib.T_Tuple([ctc1]);
  const ctc17 = stdlib.T_Tuple([]);
  const ctc18 = stdlib.T_Tuple([ctc8]);
  const ctc19 = stdlib.T_Data({
    claim0_195: ctc17,
    setWinner0_195: ctc18,
    stake0_195: ctc16,
    unstake0_195: ctc16,
    updateTime0_195: ctc17,
    withdrawAll0_195: ctc17
    });
  
  const map0_ctc = ctc2;
  const map0 = stdlib.newMap({
    ctc: ctc,
    idx: 0,
    isAPI: true
    });
  
  const map1_ctc = ctc6;
  const map1 = stdlib.newMap({
    ctc: ctc,
    idx: 1,
    isAPI: true
    });
  
  const map2_ctc = ctc6;
  const map2 = stdlib.newMap({
    ctc: ctc,
    idx: 2,
    isAPI: true
    });
  
  const map3_ctc = ctc7;
  const map3 = stdlib.newMap({
    ctc: ctc,
    idx: 3,
    isAPI: true
    });
  
  
  const [v2917, v2918, v2919, v2920, v2985, v2988, v2995, v3025, v3026, v3027, v3028, v3029, v3031, v3033, v3034, v3036] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '4'), [ctc8, ctc9, ctc9, ctc1, ctc5, ctc11, ctc13, ctc1, ctc4, ctc5, ctc1, ctc10, ctc4, ctc1, ctc1, ctc15]);
  const v3054 = ctc.selfAddress();
  const v3056 = stdlib.protect(ctc16, await interact.in(), {
    at: './index.rsh:1:23:application',
    fs: ['at ./index.rsh:188:34:application call to [unknown function] (defined at: ./index.rsh:188:34:function exp)', 'at ./index.rsh:123:31:application call to "rununstake0_195" (defined at: ./index.rsh:188:10:function exp)', 'at ./index.rsh:123:31:application call to [unknown function] (defined at: ./index.rsh:123:31:function exp)'],
    msg: 'in',
    who: 'unstake'
    });
  const v3057 = v3056[stdlib.checkedBigNumberify('./index.rsh:1:23:application', stdlib.UInt_max, '0')];
  const v3059 = stdlib.protect(map0_ctc, await stdlib.mapRef(map0, ctc8, v3054, ctc1), null);
  const v3060 = stdlib.fromSome(v3059, stdlib.checkedBigNumberify('./index.rsh:99:68:decimal', stdlib.UInt_max, '0'));
  const v3061 = stdlib.le(v3057, v3060);
  stdlib.assert(v3061, {
    at: 'reach standard library:57:5:application',
    fs: ['at ./index.rsh:189:12:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:188:34:application call to [unknown function] (defined at: ./index.rsh:188:34:function exp)', 'at ./index.rsh:123:31:application call to "rununstake0_195" (defined at: ./index.rsh:188:10:function exp)', 'at ./index.rsh:123:31:application call to [unknown function] (defined at: ./index.rsh:123:31:function exp)'],
    msg: 'Trying to unstake more than staked amount',
    who: 'unstake'
    });
  const v3063 = v2995[stdlib.checkedBigNumberify('./index.rsh:193:27:application', stdlib.UInt_max, '1')];
  const v3064 = v3063[stdlib.checkedBigNumberify('./index.rsh:193:27:application', stdlib.UInt_max, '0')];
  const v3065 = stdlib.le(v3057, v3064);
  stdlib.assert(v3065, {
    at: 'reach standard library:57:5:application',
    fs: ['at ./index.rsh:193:12:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:188:34:application call to [unknown function] (defined at: ./index.rsh:188:34:function exp)', 'at ./index.rsh:123:31:application call to "rununstake0_195" (defined at: ./index.rsh:188:10:function exp)', 'at ./index.rsh:123:31:application call to [unknown function] (defined at: ./index.rsh:123:31:function exp)'],
    msg: 'Insufficient tokens in contract',
    who: 'unstake'
    });
  const v3072 = ['unstake0_195', v3056];
  
  const txn1 = await (ctc.sendrecv({
    args: [v2917, v2918, v2919, v2920, v2985, v2988, v2995, v3025, v3026, v3027, v3028, v3029, v3031, v3033, v3034, v3036, v3072],
    evt_cnt: 1,
    funcNum: 3,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '0'),
    onlyIf: true,
    out_tys: [ctc19],
    pay: [stdlib.checkedBigNumberify('./index.rsh:188:10:decimal', stdlib.UInt_max, '0'), [[stdlib.checkedBigNumberify('./index.rsh:167:14:decimal', stdlib.UInt_max, '0'), v2919], [stdlib.checkedBigNumberify('./index.rsh:167:14:decimal', stdlib.UInt_max, '0'), v2918]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      let sim_txn_ctr = stdlib.UInt_max;
      const getSimTokCtr = () => { sim_txn_ctr = sim_txn_ctr.sub(1); return sim_txn_ctr; };
      
      stdlib.simMapDupe(sim_r, 0, map0);
      stdlib.simMapDupe(sim_r, 1, map1);
      stdlib.simMapDupe(sim_r, 2, map2);
      stdlib.simMapDupe(sim_r, 3, map3);
      
      const {data: [v3273], secs: v3275, time: v3274, didSend: v1278, from: v3272 } = txn1;
      
      switch (v3273[0]) {
        case 'claim0_195': {
          const v3276 = v3273[1];
          
          break;
          }
        case 'setWinner0_195': {
          const v4281 = v3273[1];
          
          break;
          }
        case 'stake0_195': {
          const v5286 = v3273[1];
          
          break;
          }
        case 'unstake0_195': {
          const v6291 = v3273[1];
          sim_r.txns.push({
            kind: 'api',
            who: "unstake"
            });
          ;
          const v6367 = v2995[stdlib.checkedBigNumberify('./index.rsh:123:31:dot', stdlib.UInt_max, '1')];
          const v6368 = v6367[stdlib.checkedBigNumberify('./index.rsh:123:31:dot', stdlib.UInt_max, '0')];
          ;
          ;
          const v6839 = v6291[stdlib.checkedBigNumberify('./index.rsh:188:10:spread', stdlib.UInt_max, '0')];
          const v6840 = stdlib.protect(map0_ctc, await stdlib.simMapRef(sim_r, 0, ctc8, v3272, ctc1), null);
          const v6841 = stdlib.fromSome(v6840, stdlib.checkedBigNumberify('./index.rsh:99:68:decimal', stdlib.UInt_max, '0'));
          const v6853 = stdlib.eq(v3028, stdlib.checkedBigNumberify('./index.rsh:132:29:decimal', stdlib.UInt_max, '0'));
          let v6855;
          if (v6853) {
            v6855 = v3027;
            }
          else {
            const v6869 = stdlib.safeDiv(stdlib.checkedBigNumberify('reach standard library:252:57:application', stdlib.UInt_max, '10000000000000'), v3028);
            const v6878 = stdlib.safeSub(v3274, v3025);
            const v6887 = stdlib.safeMul(v6869, v6878);
            const v6890 = {
              i: v6887,
              scale: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '10000000')
              };
            const v6891 = {
              i: v6890,
              sign: true
              };
            const v6896 = stdlib.lt(v3033, stdlib.checkedBigNumberify('reach standard library:317:22:application', stdlib.UInt_max, '10000000'));
            const v6899 = v6896 ? stdlib.checkedBigNumberify('reach standard library:317:22:application', stdlib.UInt_max, '10000000') : v3033;
            let v6900;
            const v6903 = stdlib.eq(v3033, v6899);
            if (v6903) {
              v6900 = v3027;
              }
            else {
              const v6911 = stdlib.safeMul(v3034, v6899);
              const v6918 = stdlib.safeDiv(v6911, v3033);
              const v6921 = {
                i: v6918,
                scale: v6899
                };
              const v6922 = {
                i: v6921,
                sign: v3031
                };
              v6900 = v6922;
              }
            let v6925;
            const v6926 = stdlib.eq(stdlib.checkedBigNumberify('reach standard library:317:22:application', stdlib.UInt_max, '10000000'), v6899);
            if (v6926) {
              v6925 = v6891;
              }
            else {
              const v6932 = stdlib.safeMul(v6887, v6899);
              const v6936 = stdlib.safeDiv(v6932, stdlib.checkedBigNumberify('reach standard library:317:22:application', stdlib.UInt_max, '10000000'));
              const v6939 = {
                i: v6936,
                scale: v6899
                };
              const v6940 = {
                i: v6939,
                sign: true
                };
              v6925 = v6940;
              }
            const v6944 = v6900.sign;
            const v6945 = v6900.i;
            const v6946 = v6945.i;
            const v6947 = {
              i: v6946,
              sign: v6944
              };
            const v6949 = v6925.sign;
            const v6950 = v6925.i;
            const v6951 = v6950.i;
            const v6952 = {
              i: v6951,
              sign: v6949
              };
            let v6954;
            const v6955 = v6949 ? false : true;
            const v6956 = v6944 ? v6949 : v6955;
            if (v6956) {
              const v6957 = stdlib.safeAdd(v6946, v6951);
              const v6958 = {
                i: v6957,
                sign: v6944
                };
              v6954 = v6958;
              }
            else {
              const v6960 = stdlib.gt(v6946, v6951);
              const v6963 = [v6947, v6952];
              const v6966 = [v6952, v6947];
              const v6967 = v6960 ? v6963 : v6966;
              const v6968 = v6967[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '0')];
              const v6969 = v6967[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '1')];
              const v6970 = v6968.sign;
              const v6971 = v6968.i;
              const v6972 = v6969.i;
              const v6973 = stdlib.safeSub(v6971, v6972);
              const v6974 = {
                i: v6973,
                sign: v6970
                };
              v6954 = v6974;
              }
            const v6976 = v6954.sign;
            const v6977 = v6954.i;
            const v6978 = {
              i: v6977,
              scale: v6899
              };
            const v6979 = {
              i: v6978,
              sign: v6976
              };
            v6855 = v6979;
            }
          const v6985 = stdlib.protect(map1_ctc, await stdlib.simMapRef(sim_r, 1, ctc8, v3272, ctc5), null);
          const v6988 = stdlib.fromSome(v6985, v2985);
          const v6995 = stdlib.protect(map2_ctc, await stdlib.simMapRef(sim_r, 2, ctc8, v3272, ctc5), null);
          const v6998 = stdlib.fromSome(v6995, v2985);
          const v6999 = v6855.i;
          const v7000 = v6999.scale;
          const v7001 = v6998.i;
          const v7002 = v7001.scale;
          const v7003 = stdlib.lt(v7000, v7002);
          const v7008 = v7003 ? v7002 : v7000;
          let v7009;
          const v7012 = stdlib.eq(v7000, v7008);
          if (v7012) {
            v7009 = v6855;
            }
          else {
            const v7013 = v6855.sign;
            const v7015 = v6999.i;
            const v7020 = stdlib.safeMul(v7015, v7008);
            const v7027 = stdlib.safeDiv(v7020, v7000);
            const v7030 = {
              i: v7027,
              scale: v7008
              };
            const v7031 = {
              i: v7030,
              sign: v7013
              };
            v7009 = v7031;
            }
          let v7034;
          const v7037 = stdlib.eq(v7002, v7008);
          if (v7037) {
            v7034 = v6998;
            }
          else {
            const v7038 = v6998.sign;
            const v7040 = v7001.i;
            const v7045 = stdlib.safeMul(v7040, v7008);
            const v7052 = stdlib.safeDiv(v7045, v7002);
            const v7055 = {
              i: v7052,
              scale: v7008
              };
            const v7056 = {
              i: v7055,
              sign: v7038
              };
            v7034 = v7056;
            }
          const v7060 = v7009.sign;
          const v7061 = v7009.i;
          const v7062 = v7061.i;
          const v7063 = {
            i: v7062,
            sign: v7060
            };
          const v7065 = v7034.sign;
          const v7066 = v7034.i;
          const v7067 = v7066.i;
          const v7070 = v7065 ? false : true;
          const v7071 = {
            i: v7067,
            sign: v7070
            };
          let v7072;
          const v7074 = v7060 ? v7070 : v7065;
          if (v7074) {
            const v7075 = stdlib.safeAdd(v7062, v7067);
            const v7076 = {
              i: v7075,
              sign: v7060
              };
            v7072 = v7076;
            }
          else {
            const v7078 = stdlib.gt(v7062, v7067);
            const v7081 = [v7063, v7071];
            const v7084 = [v7071, v7063];
            const v7085 = v7078 ? v7081 : v7084;
            const v7086 = v7085[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '0')];
            const v7087 = v7085[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '1')];
            const v7088 = v7086.sign;
            const v7089 = v7086.i;
            const v7090 = v7087.i;
            const v7091 = stdlib.safeSub(v7089, v7090);
            const v7092 = {
              i: v7091,
              sign: v7088
              };
            v7072 = v7092;
            }
          const v7094 = v7072.sign;
          const v7095 = v7072.i;
          const v7105 = stdlib.safeMul(v6841, v7095);
          const v7112 = v6988.i;
          const v7113 = v7112.scale;
          const v7114 = stdlib.lt(v7113, v7008);
          const v7117 = v7114 ? v7008 : v7113;
          let v7118;
          const v7121 = stdlib.eq(v7113, v7117);
          if (v7121) {
            v7118 = v6988;
            }
          else {
            const v7122 = v6988.sign;
            const v7124 = v7112.i;
            const v7129 = stdlib.safeMul(v7124, v7117);
            const v7136 = stdlib.safeDiv(v7129, v7113);
            const v7139 = {
              i: v7136,
              scale: v7117
              };
            const v7140 = {
              i: v7139,
              sign: v7122
              };
            v7118 = v7140;
            }
          let v7143;
          const v7144 = stdlib.eq(v7008, v7117);
          if (v7144) {
            const v7145 = {
              i: v7105,
              scale: v7117
              };
            const v7146 = {
              i: v7145,
              sign: v7094
              };
            v7143 = v7146;
            }
          else {
            const v7151 = stdlib.safeMul(v7105, v7117);
            const v7156 = stdlib.safeDiv(v7151, v7008);
            const v7159 = {
              i: v7156,
              scale: v7117
              };
            const v7160 = {
              i: v7159,
              sign: v7094
              };
            v7143 = v7160;
            }
          const v7164 = v7118.sign;
          const v7165 = v7118.i;
          const v7166 = v7165.i;
          const v7167 = {
            i: v7166,
            sign: v7164
            };
          const v7169 = v7143.sign;
          const v7170 = v7143.i;
          const v7171 = v7170.i;
          const v7172 = {
            i: v7171,
            sign: v7169
            };
          let v7174;
          const v7175 = v7169 ? false : true;
          const v7176 = v7164 ? v7169 : v7175;
          if (v7176) {
            const v7177 = stdlib.safeAdd(v7166, v7171);
            const v7178 = {
              i: v7177,
              sign: v7164
              };
            v7174 = v7178;
            }
          else {
            const v7180 = stdlib.gt(v7166, v7171);
            const v7183 = [v7167, v7172];
            const v7186 = [v7172, v7167];
            const v7187 = v7180 ? v7183 : v7186;
            const v7188 = v7187[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '0')];
            const v7189 = v7187[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '1')];
            const v7190 = v7188.sign;
            const v7191 = v7188.i;
            const v7192 = v7189.i;
            const v7193 = stdlib.safeSub(v7191, v7192);
            const v7194 = {
              i: v7193,
              sign: v7190
              };
            v7174 = v7194;
            }
          const v7196 = v7174.sign;
          const v7197 = v7174.i;
          const v7198 = {
            i: v7197,
            scale: v7117
            };
          const v7199 = {
            i: v7198,
            sign: v7196
            };
          await stdlib.simMapSet(sim_r, 1, ctc8, v3272, ctc5, v7199);
          await stdlib.simMapSet(sim_r, 2, ctc8, v3272, ctc5, v6855);
          const v7206 = stdlib.safeSub(v6841, v6839);
          await stdlib.simMapSet(sim_r, 0, ctc8, v3272, ctc1, v7206);
          const v7224 = stdlib.sub(v6368, v6839);
          const v7226 = stdlib.Array_set(v6367, '0', v7224);
          const v7227 = stdlib.Array_set(v2995, stdlib.checkedBigNumberify('./index.rsh:203:44:application', stdlib.UInt_max, '1'), v7226);
          sim_r.txns.push({
            kind: 'from',
            to: v3272,
            tok: v2919
            });
          const v7228 = null;
          const v7229 = await txn1.getOutput('unstake', 'v7228', ctc0, v7228);
          
          const v7241 = stdlib.safeSub(v3028, v6839);
          const v7243 = {
            lastUpdateTime: v3274,
            prizeClaimed: v3026,
            rewardPerToken: v6855,
            totalStake: v7241,
            winner: v3029
            };
          const v10943 = v7243;
          const v10945 = v7227;
          const v10946 = v7243.lastUpdateTime;
          const v10947 = v7243.prizeClaimed;
          const v10948 = v7243.rewardPerToken;
          const v10949 = v7243.totalStake;
          const v10950 = v7243.winner;
          const v10951 = v10948.sign;
          const v10952 = v10948.i;
          const v10953 = v10952.scale;
          const v10954 = v10952.i;
          const v10955 = {
            i: v10954,
            scale: v10953
            };
          const v10956 = {
            i: v10955,
            sign: v10951
            };
          sim_r.isHalt = false;
          
          break;
          }
        case 'updateTime0_195': {
          const v7296 = v3273[1];
          
          break;
          }
        case 'withdrawAll0_195': {
          const v8301 = v3273[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined /* mto */,
    tys: [ctc8, ctc9, ctc9, ctc1, ctc5, ctc11, ctc13, ctc1, ctc4, ctc5, ctc1, ctc10, ctc4, ctc1, ctc1, ctc15, ctc19],
    waitIfNotPresent: false
    }));
  const {data: [v3273], secs: v3275, time: v3274, didSend: v1278, from: v3272 } = txn1;
  switch (v3273[0]) {
    case 'claim0_195': {
      const v3276 = v3273[1];
      return;
      break;
      }
    case 'setWinner0_195': {
      const v4281 = v3273[1];
      return;
      break;
      }
    case 'stake0_195': {
      const v5286 = v3273[1];
      return;
      break;
      }
    case 'unstake0_195': {
      const v6291 = v3273[1];
      undefined /* setApiDetails */;
      ;
      const v6367 = v2995[stdlib.checkedBigNumberify('./index.rsh:123:31:dot', stdlib.UInt_max, '1')];
      const v6368 = v6367[stdlib.checkedBigNumberify('./index.rsh:123:31:dot', stdlib.UInt_max, '0')];
      ;
      ;
      const v6839 = v6291[stdlib.checkedBigNumberify('./index.rsh:188:10:spread', stdlib.UInt_max, '0')];
      const v6840 = stdlib.protect(map0_ctc, await stdlib.mapRef(map0, ctc8, v3272, ctc1), null);
      const v6841 = stdlib.fromSome(v6840, stdlib.checkedBigNumberify('./index.rsh:99:68:decimal', stdlib.UInt_max, '0'));
      const v6842 = stdlib.le(v6839, v6841);
      stdlib.assert(v6842, {
        at: 'reach standard library:57:5:application',
        fs: ['at ./index.rsh:189:12:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:196:20:application call to [unknown function] (defined at: ./index.rsh:196:20:function exp)'],
        msg: 'Trying to unstake more than staked amount',
        who: 'unstake'
        });
      const v6846 = stdlib.le(v6839, v6368);
      stdlib.assert(v6846, {
        at: 'reach standard library:57:5:application',
        fs: ['at ./index.rsh:193:12:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:196:20:application call to [unknown function] (defined at: ./index.rsh:196:20:function exp)'],
        msg: 'Insufficient tokens in contract',
        who: 'unstake'
        });
      const v6850 = stdlib.le(v3274, v2920);
      stdlib.assert(v6850, {
        at: 'reach standard library:57:5:application',
        fs: ['at ./index.rsh:197:16:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:196:20:application call to [unknown function] (defined at: ./index.rsh:196:20:function exp)'],
        msg: 'Staking period has ended',
        who: 'unstake'
        });
      const v6853 = stdlib.eq(v3028, stdlib.checkedBigNumberify('./index.rsh:132:29:decimal', stdlib.UInt_max, '0'));
      let v6855;
      if (v6853) {
        v6855 = v3027;
        }
      else {
        const v6869 = stdlib.safeDiv(stdlib.checkedBigNumberify('reach standard library:252:57:application', stdlib.UInt_max, '10000000000000'), v3028);
        const v6878 = stdlib.safeSub(v3274, v3025);
        const v6887 = stdlib.safeMul(v6869, v6878);
        const v6890 = {
          i: v6887,
          scale: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '10000000')
          };
        const v6891 = {
          i: v6890,
          sign: true
          };
        const v6896 = stdlib.lt(v3033, stdlib.checkedBigNumberify('reach standard library:317:22:application', stdlib.UInt_max, '10000000'));
        const v6899 = v6896 ? stdlib.checkedBigNumberify('reach standard library:317:22:application', stdlib.UInt_max, '10000000') : v3033;
        let v6900;
        const v6903 = stdlib.eq(v3033, v6899);
        if (v6903) {
          v6900 = v3027;
          }
        else {
          const v6911 = stdlib.safeMul(v3034, v6899);
          const v6918 = stdlib.safeDiv(v6911, v3033);
          const v6921 = {
            i: v6918,
            scale: v6899
            };
          const v6922 = {
            i: v6921,
            sign: v3031
            };
          v6900 = v6922;
          }
        let v6925;
        const v6926 = stdlib.eq(stdlib.checkedBigNumberify('reach standard library:317:22:application', stdlib.UInt_max, '10000000'), v6899);
        if (v6926) {
          v6925 = v6891;
          }
        else {
          const v6932 = stdlib.safeMul(v6887, v6899);
          const v6936 = stdlib.safeDiv(v6932, stdlib.checkedBigNumberify('reach standard library:317:22:application', stdlib.UInt_max, '10000000'));
          const v6939 = {
            i: v6936,
            scale: v6899
            };
          const v6940 = {
            i: v6939,
            sign: true
            };
          v6925 = v6940;
          }
        const v6944 = v6900.sign;
        const v6945 = v6900.i;
        const v6946 = v6945.i;
        const v6947 = {
          i: v6946,
          sign: v6944
          };
        const v6949 = v6925.sign;
        const v6950 = v6925.i;
        const v6951 = v6950.i;
        const v6952 = {
          i: v6951,
          sign: v6949
          };
        let v6954;
        const v6955 = v6949 ? false : true;
        const v6956 = v6944 ? v6949 : v6955;
        if (v6956) {
          const v6957 = stdlib.safeAdd(v6946, v6951);
          const v6958 = {
            i: v6957,
            sign: v6944
            };
          v6954 = v6958;
          }
        else {
          const v6960 = stdlib.gt(v6946, v6951);
          const v6963 = [v6947, v6952];
          const v6966 = [v6952, v6947];
          const v6967 = v6960 ? v6963 : v6966;
          const v6968 = v6967[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '0')];
          const v6969 = v6967[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '1')];
          const v6970 = v6968.sign;
          const v6971 = v6968.i;
          const v6972 = v6969.i;
          const v6973 = stdlib.safeSub(v6971, v6972);
          const v6974 = {
            i: v6973,
            sign: v6970
            };
          v6954 = v6974;
          }
        const v6976 = v6954.sign;
        const v6977 = v6954.i;
        const v6978 = {
          i: v6977,
          scale: v6899
          };
        const v6979 = {
          i: v6978,
          sign: v6976
          };
        v6855 = v6979;
        }
      const v6985 = stdlib.protect(map1_ctc, await stdlib.mapRef(map1, ctc8, v3272, ctc5), null);
      const v6988 = stdlib.fromSome(v6985, v2985);
      const v6995 = stdlib.protect(map2_ctc, await stdlib.mapRef(map2, ctc8, v3272, ctc5), null);
      const v6998 = stdlib.fromSome(v6995, v2985);
      const v6999 = v6855.i;
      const v7000 = v6999.scale;
      const v7001 = v6998.i;
      const v7002 = v7001.scale;
      const v7003 = stdlib.lt(v7000, v7002);
      const v7008 = v7003 ? v7002 : v7000;
      let v7009;
      const v7012 = stdlib.eq(v7000, v7008);
      if (v7012) {
        v7009 = v6855;
        }
      else {
        const v7013 = v6855.sign;
        const v7015 = v6999.i;
        const v7020 = stdlib.safeMul(v7015, v7008);
        const v7027 = stdlib.safeDiv(v7020, v7000);
        const v7030 = {
          i: v7027,
          scale: v7008
          };
        const v7031 = {
          i: v7030,
          sign: v7013
          };
        v7009 = v7031;
        }
      let v7034;
      const v7037 = stdlib.eq(v7002, v7008);
      if (v7037) {
        v7034 = v6998;
        }
      else {
        const v7038 = v6998.sign;
        const v7040 = v7001.i;
        const v7045 = stdlib.safeMul(v7040, v7008);
        const v7052 = stdlib.safeDiv(v7045, v7002);
        const v7055 = {
          i: v7052,
          scale: v7008
          };
        const v7056 = {
          i: v7055,
          sign: v7038
          };
        v7034 = v7056;
        }
      const v7060 = v7009.sign;
      const v7061 = v7009.i;
      const v7062 = v7061.i;
      const v7063 = {
        i: v7062,
        sign: v7060
        };
      const v7065 = v7034.sign;
      const v7066 = v7034.i;
      const v7067 = v7066.i;
      const v7070 = v7065 ? false : true;
      const v7071 = {
        i: v7067,
        sign: v7070
        };
      let v7072;
      const v7074 = v7060 ? v7070 : v7065;
      if (v7074) {
        const v7075 = stdlib.safeAdd(v7062, v7067);
        const v7076 = {
          i: v7075,
          sign: v7060
          };
        v7072 = v7076;
        }
      else {
        const v7078 = stdlib.gt(v7062, v7067);
        const v7081 = [v7063, v7071];
        const v7084 = [v7071, v7063];
        const v7085 = v7078 ? v7081 : v7084;
        const v7086 = v7085[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '0')];
        const v7087 = v7085[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '1')];
        const v7088 = v7086.sign;
        const v7089 = v7086.i;
        const v7090 = v7087.i;
        const v7091 = stdlib.safeSub(v7089, v7090);
        const v7092 = {
          i: v7091,
          sign: v7088
          };
        v7072 = v7092;
        }
      const v7094 = v7072.sign;
      const v7095 = v7072.i;
      const v7105 = stdlib.safeMul(v6841, v7095);
      const v7112 = v6988.i;
      const v7113 = v7112.scale;
      const v7114 = stdlib.lt(v7113, v7008);
      const v7117 = v7114 ? v7008 : v7113;
      let v7118;
      const v7121 = stdlib.eq(v7113, v7117);
      if (v7121) {
        v7118 = v6988;
        }
      else {
        const v7122 = v6988.sign;
        const v7124 = v7112.i;
        const v7129 = stdlib.safeMul(v7124, v7117);
        const v7136 = stdlib.safeDiv(v7129, v7113);
        const v7139 = {
          i: v7136,
          scale: v7117
          };
        const v7140 = {
          i: v7139,
          sign: v7122
          };
        v7118 = v7140;
        }
      let v7143;
      const v7144 = stdlib.eq(v7008, v7117);
      if (v7144) {
        const v7145 = {
          i: v7105,
          scale: v7117
          };
        const v7146 = {
          i: v7145,
          sign: v7094
          };
        v7143 = v7146;
        }
      else {
        const v7151 = stdlib.safeMul(v7105, v7117);
        const v7156 = stdlib.safeDiv(v7151, v7008);
        const v7159 = {
          i: v7156,
          scale: v7117
          };
        const v7160 = {
          i: v7159,
          sign: v7094
          };
        v7143 = v7160;
        }
      const v7164 = v7118.sign;
      const v7165 = v7118.i;
      const v7166 = v7165.i;
      const v7167 = {
        i: v7166,
        sign: v7164
        };
      const v7169 = v7143.sign;
      const v7170 = v7143.i;
      const v7171 = v7170.i;
      const v7172 = {
        i: v7171,
        sign: v7169
        };
      let v7174;
      const v7175 = v7169 ? false : true;
      const v7176 = v7164 ? v7169 : v7175;
      if (v7176) {
        const v7177 = stdlib.safeAdd(v7166, v7171);
        const v7178 = {
          i: v7177,
          sign: v7164
          };
        v7174 = v7178;
        }
      else {
        const v7180 = stdlib.gt(v7166, v7171);
        const v7183 = [v7167, v7172];
        const v7186 = [v7172, v7167];
        const v7187 = v7180 ? v7183 : v7186;
        const v7188 = v7187[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '0')];
        const v7189 = v7187[stdlib.checkedBigNumberify('reach standard library:245:11:array', stdlib.UInt_max, '1')];
        const v7190 = v7188.sign;
        const v7191 = v7188.i;
        const v7192 = v7189.i;
        const v7193 = stdlib.safeSub(v7191, v7192);
        const v7194 = {
          i: v7193,
          sign: v7190
          };
        v7174 = v7194;
        }
      const v7196 = v7174.sign;
      const v7197 = v7174.i;
      const v7198 = {
        i: v7197,
        scale: v7117
        };
      const v7199 = {
        i: v7198,
        sign: v7196
        };
      await stdlib.mapSet(map1, ctc8, v3272, ctc5, v7199);
      await stdlib.mapSet(map2, ctc8, v3272, ctc5, v6855);
      const v7206 = stdlib.safeSub(v6841, v6839);
      await stdlib.mapSet(map0, ctc8, v3272, ctc1, v7206);
      const v7224 = stdlib.sub(v6368, v6839);
      const v7226 = stdlib.Array_set(v6367, '0', v7224);
      const v7227 = stdlib.Array_set(v2995, stdlib.checkedBigNumberify('./index.rsh:203:44:application', stdlib.UInt_max, '1'), v7226);
      ;
      const v7228 = null;
      const v7229 = await txn1.getOutput('unstake', 'v7228', ctc0, v7228);
      if (v1278) {
        stdlib.protect(ctc0, await interact.out(v6291, v7229), {
          at: './index.rsh:188:11:application',
          fs: ['at ./index.rsh:188:11:application call to [unknown function] (defined at: ./index.rsh:188:11:function exp)', 'at ./index.rsh:205:19:application call to "callback" (defined at: ./index.rsh:196:20:function exp)', 'at ./index.rsh:196:20:application call to [unknown function] (defined at: ./index.rsh:196:20:function exp)'],
          msg: 'out',
          who: 'unstake'
          });
        }
      else {
        }
      
      const v7241 = stdlib.safeSub(v3028, v6839);
      const v7243 = {
        lastUpdateTime: v3274,
        prizeClaimed: v3026,
        rewardPerToken: v6855,
        totalStake: v7241,
        winner: v3029
        };
      const v10943 = v7243;
      const v10945 = v7227;
      const v10946 = v7243.lastUpdateTime;
      const v10947 = v7243.prizeClaimed;
      const v10948 = v7243.rewardPerToken;
      const v10949 = v7243.totalStake;
      const v10950 = v7243.winner;
      const v10951 = v10948.sign;
      const v10952 = v10948.i;
      const v10953 = v10952.scale;
      const v10954 = v10952.i;
      const v10955 = {
        i: v10954,
        scale: v10953
        };
      const v10956 = {
        i: v10955,
        sign: v10951
        };
      return;
      
      break;
      }
    case 'updateTime0_195': {
      const v7296 = v3273[1];
      return;
      break;
      }
    case 'withdrawAll0_195': {
      const v8301 = v3273[1];
      return;
      break;
      }
    }
  
  
  };
export async function _updateTime4(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for _updateTime4 expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for _updateTime4 expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Null;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Data({
    None: ctc0,
    Some: ctc1
    });
  const ctc3 = stdlib.T_Object({
    i: ctc1,
    scale: ctc1
    });
  const ctc4 = stdlib.T_Bool;
  const ctc5 = stdlib.T_Object({
    i: ctc3,
    sign: ctc4
    });
  const ctc6 = stdlib.T_Data({
    None: ctc0,
    Some: ctc5
    });
  const ctc7 = stdlib.T_Data({
    None: ctc0,
    Some: ctc4
    });
  const ctc8 = stdlib.T_Address;
  const ctc9 = stdlib.T_Token;
  const ctc10 = stdlib.T_Data({
    None: ctc0,
    Some: ctc8
    });
  const ctc11 = stdlib.T_Object({
    lastUpdateTime: ctc1,
    prizeClaimed: ctc4,
    rewardPerToken: ctc5,
    totalStake: ctc1,
    winner: ctc10
    });
  const ctc12 = stdlib.T_Tuple([ctc1, ctc1, ctc4]);
  const ctc13 = stdlib.T_Array(ctc12, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '2'));
  const ctc14 = stdlib.T_Struct([['scale', ctc1], ['i', ctc1]]);
  const ctc15 = stdlib.T_Struct([['sign', ctc4], ['i', ctc14]]);
  const ctc16 = stdlib.T_Tuple([]);
  const ctc17 = stdlib.T_Tuple([ctc8]);
  const ctc18 = stdlib.T_Tuple([ctc1]);
  const ctc19 = stdlib.T_Data({
    claim0_195: ctc16,
    setWinner0_195: ctc17,
    stake0_195: ctc18,
    unstake0_195: ctc18,
    updateTime0_195: ctc16,
    withdrawAll0_195: ctc16
    });
  
  const map0_ctc = ctc2;
  const map0 = stdlib.newMap({
    ctc: ctc,
    idx: 0,
    isAPI: true
    });
  
  const map1_ctc = ctc6;
  const map1 = stdlib.newMap({
    ctc: ctc,
    idx: 1,
    isAPI: true
    });
  
  const map2_ctc = ctc6;
  const map2 = stdlib.newMap({
    ctc: ctc,
    idx: 2,
    isAPI: true
    });
  
  const map3_ctc = ctc7;
  const map3 = stdlib.newMap({
    ctc: ctc,
    idx: 3,
    isAPI: true
    });
  
  
  const [v2917, v2918, v2919, v2920, v2985, v2988, v2995, v3025, v3026, v3027, v3028, v3029, v3031, v3033, v3034, v3036] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '4'), [ctc8, ctc9, ctc9, ctc1, ctc5, ctc11, ctc13, ctc1, ctc4, ctc5, ctc1, ctc10, ctc4, ctc1, ctc1, ctc15]);
  const v3133 = stdlib.protect(ctc16, await interact.in(), {
    at: './index.rsh:1:23:application',
    fs: ['at ./index.rsh:264:35:application call to [unknown function] (defined at: ./index.rsh:264:35:function exp)', 'at ./index.rsh:123:31:application call to "runupdateTime0_195" (defined at: ./index.rsh:264:10:function exp)', 'at ./index.rsh:123:31:application call to [unknown function] (defined at: ./index.rsh:123:31:function exp)'],
    msg: 'in',
    who: 'updateTime'
    });
  const v3137 = ['updateTime0_195', v3133];
  
  const txn1 = await (ctc.sendrecv({
    args: [v2917, v2918, v2919, v2920, v2985, v2988, v2995, v3025, v3026, v3027, v3028, v3029, v3031, v3033, v3034, v3036, v3137],
    evt_cnt: 1,
    funcNum: 3,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '0'),
    onlyIf: true,
    out_tys: [ctc19],
    pay: [stdlib.checkedBigNumberify('./index.rsh:264:10:decimal', stdlib.UInt_max, '0'), [[stdlib.checkedBigNumberify('./index.rsh:167:14:decimal', stdlib.UInt_max, '0'), v2919], [stdlib.checkedBigNumberify('./index.rsh:167:14:decimal', stdlib.UInt_max, '0'), v2918]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      let sim_txn_ctr = stdlib.UInt_max;
      const getSimTokCtr = () => { sim_txn_ctr = sim_txn_ctr.sub(1); return sim_txn_ctr; };
      
      stdlib.simMapDupe(sim_r, 0, map0);
      stdlib.simMapDupe(sim_r, 1, map1);
      stdlib.simMapDupe(sim_r, 2, map2);
      stdlib.simMapDupe(sim_r, 3, map3);
      
      const {data: [v3273], secs: v3275, time: v3274, didSend: v1278, from: v3272 } = txn1;
      
      switch (v3273[0]) {
        case 'claim0_195': {
          const v3276 = v3273[1];
          
          break;
          }
        case 'setWinner0_195': {
          const v4281 = v3273[1];
          
          break;
          }
        case 'stake0_195': {
          const v5286 = v3273[1];
          
          break;
          }
        case 'unstake0_195': {
          const v6291 = v3273[1];
          
          break;
          }
        case 'updateTime0_195': {
          const v7296 = v3273[1];
          sim_r.txns.push({
            kind: 'api',
            who: "updateTime"
            });
          ;
          ;
          ;
          const v8251 = v3274;
          const v8252 = await txn1.getOutput('updateTime', 'v8251', ctc1, v8251);
          
          const v11118 = v2988;
          const v11120 = v2995;
          const v11121 = v2988.lastUpdateTime;
          const v11122 = v2988.prizeClaimed;
          const v11123 = v2988.rewardPerToken;
          const v11124 = v2988.totalStake;
          const v11125 = v2988.winner;
          const v11126 = v11123.sign;
          const v11127 = v11123.i;
          const v11128 = v11127.scale;
          const v11129 = v11127.i;
          const v11130 = {
            i: v11129,
            scale: v11128
            };
          const v11131 = {
            i: v11130,
            sign: v11126
            };
          sim_r.isHalt = false;
          
          break;
          }
        case 'withdrawAll0_195': {
          const v8301 = v3273[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined /* mto */,
    tys: [ctc8, ctc9, ctc9, ctc1, ctc5, ctc11, ctc13, ctc1, ctc4, ctc5, ctc1, ctc10, ctc4, ctc1, ctc1, ctc15, ctc19],
    waitIfNotPresent: false
    }));
  const {data: [v3273], secs: v3275, time: v3274, didSend: v1278, from: v3272 } = txn1;
  switch (v3273[0]) {
    case 'claim0_195': {
      const v3276 = v3273[1];
      return;
      break;
      }
    case 'setWinner0_195': {
      const v4281 = v3273[1];
      return;
      break;
      }
    case 'stake0_195': {
      const v5286 = v3273[1];
      return;
      break;
      }
    case 'unstake0_195': {
      const v6291 = v3273[1];
      return;
      break;
      }
    case 'updateTime0_195': {
      const v7296 = v3273[1];
      undefined /* setApiDetails */;
      ;
      ;
      ;
      const v8251 = v3274;
      const v8252 = await txn1.getOutput('updateTime', 'v8251', ctc1, v8251);
      if (v1278) {
        stdlib.protect(ctc0, await interact.out(v7296, v8252), {
          at: './index.rsh:264:11:application',
          fs: ['at ./index.rsh:264:11:application call to [unknown function] (defined at: ./index.rsh:264:11:function exp)', 'at ./index.rsh:267:19:application call to "callback" (defined at: ./index.rsh:266:20:function exp)', 'at ./index.rsh:266:20:application call to [unknown function] (defined at: ./index.rsh:266:20:function exp)'],
          msg: 'out',
          who: 'updateTime'
          });
        }
      else {
        }
      
      const v11118 = v2988;
      const v11120 = v2995;
      const v11121 = v2988.lastUpdateTime;
      const v11122 = v2988.prizeClaimed;
      const v11123 = v2988.rewardPerToken;
      const v11124 = v2988.totalStake;
      const v11125 = v2988.winner;
      const v11126 = v11123.sign;
      const v11127 = v11123.i;
      const v11128 = v11127.scale;
      const v11129 = v11127.i;
      const v11130 = {
        i: v11129,
        scale: v11128
        };
      const v11131 = {
        i: v11130,
        sign: v11126
        };
      return;
      
      break;
      }
    case 'withdrawAll0_195': {
      const v8301 = v3273[1];
      return;
      break;
      }
    }
  
  
  };
export async function _withdrawAll4(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for _withdrawAll4 expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for _withdrawAll4 expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Null;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Data({
    None: ctc0,
    Some: ctc1
    });
  const ctc3 = stdlib.T_Object({
    i: ctc1,
    scale: ctc1
    });
  const ctc4 = stdlib.T_Bool;
  const ctc5 = stdlib.T_Object({
    i: ctc3,
    sign: ctc4
    });
  const ctc6 = stdlib.T_Data({
    None: ctc0,
    Some: ctc5
    });
  const ctc7 = stdlib.T_Data({
    None: ctc0,
    Some: ctc4
    });
  const ctc8 = stdlib.T_Address;
  const ctc9 = stdlib.T_Token;
  const ctc10 = stdlib.T_Data({
    None: ctc0,
    Some: ctc8
    });
  const ctc11 = stdlib.T_Object({
    lastUpdateTime: ctc1,
    prizeClaimed: ctc4,
    rewardPerToken: ctc5,
    totalStake: ctc1,
    winner: ctc10
    });
  const ctc12 = stdlib.T_Tuple([ctc1, ctc1, ctc4]);
  const ctc13 = stdlib.T_Array(ctc12, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '2'));
  const ctc14 = stdlib.T_Struct([['scale', ctc1], ['i', ctc1]]);
  const ctc15 = stdlib.T_Struct([['sign', ctc4], ['i', ctc14]]);
  const ctc16 = stdlib.T_Tuple([]);
  const ctc17 = stdlib.T_Tuple([ctc8]);
  const ctc18 = stdlib.T_Tuple([ctc1]);
  const ctc19 = stdlib.T_Data({
    claim0_195: ctc16,
    setWinner0_195: ctc17,
    stake0_195: ctc18,
    unstake0_195: ctc18,
    updateTime0_195: ctc16,
    withdrawAll0_195: ctc16
    });
  
  const map0_ctc = ctc2;
  const map0 = stdlib.newMap({
    ctc: ctc,
    idx: 0,
    isAPI: true
    });
  
  const map1_ctc = ctc6;
  const map1 = stdlib.newMap({
    ctc: ctc,
    idx: 1,
    isAPI: true
    });
  
  const map2_ctc = ctc6;
  const map2 = stdlib.newMap({
    ctc: ctc,
    idx: 2,
    isAPI: true
    });
  
  const map3_ctc = ctc7;
  const map3 = stdlib.newMap({
    ctc: ctc,
    idx: 3,
    isAPI: true
    });
  
  
  const [v2917, v2918, v2919, v2920, v2985, v2988, v2995, v3025, v3026, v3027, v3028, v3029, v3031, v3033, v3034, v3036] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '4'), [ctc8, ctc9, ctc9, ctc1, ctc5, ctc11, ctc13, ctc1, ctc4, ctc5, ctc1, ctc10, ctc4, ctc1, ctc1, ctc15]);
  const v3074 = ctc.selfAddress();
  const v3076 = stdlib.protect(ctc16, await interact.in(), {
    at: './index.rsh:1:23:application',
    fs: ['at ./index.rsh:215:35:application call to [unknown function] (defined at: ./index.rsh:215:35:function exp)', 'at ./index.rsh:123:31:application call to "runwithdrawAll0_195" (defined at: ./index.rsh:215:10:function exp)', 'at ./index.rsh:123:31:application call to [unknown function] (defined at: ./index.rsh:123:31:function exp)'],
    msg: 'in',
    who: 'withdrawAll'
    });
  const v3077 = stdlib.protect(map3_ctc, await stdlib.mapRef(map3, ctc8, v3074, ctc4), null);
  const v3078 = stdlib.fromSome(v3077, false);
  const v3079 = v3078 ? false : true;
  stdlib.assert(v3079, {
    at: 'reach standard library:57:5:application',
    fs: ['at ./index.rsh:216:12:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:215:35:application call to [unknown function] (defined at: ./index.rsh:215:35:function exp)', 'at ./index.rsh:123:31:application call to "runwithdrawAll0_195" (defined at: ./index.rsh:215:10:function exp)', 'at ./index.rsh:123:31:application call to [unknown function] (defined at: ./index.rsh:123:31:function exp)'],
    msg: 'Already withdrawn previously',
    who: 'withdrawAll'
    });
  const v3081 = stdlib.protect(map0_ctc, await stdlib.mapRef(map0, ctc8, v3074, ctc1), null);
  const v3082 = stdlib.fromSome(v3081, stdlib.checkedBigNumberify('./index.rsh:99:68:decimal', stdlib.UInt_max, '0'));
  const v3083 = v2995[stdlib.checkedBigNumberify('./index.rsh:218:37:application', stdlib.UInt_max, '1')];
  const v3084 = v3083[stdlib.checkedBigNumberify('./index.rsh:218:37:application', stdlib.UInt_max, '0')];
  const v3085 = stdlib.le(v3082, v3084);
  stdlib.assert(v3085, {
    at: 'reach standard library:57:5:application',
    fs: ['at ./index.rsh:217:12:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:215:35:application call to [unknown function] (defined at: ./index.rsh:215:35:function exp)', 'at ./index.rsh:123:31:application call to "runwithdrawAll0_195" (defined at: ./index.rsh:215:10:function exp)', 'at ./index.rsh:123:31:application call to [unknown function] (defined at: ./index.rsh:123:31:function exp)'],
    msg: 'Insufficient tokens in contract',
    who: 'withdrawAll'
    });
  const v3090 = ['withdrawAll0_195', v3076];
  
  const txn1 = await (ctc.sendrecv({
    args: [v2917, v2918, v2919, v2920, v2985, v2988, v2995, v3025, v3026, v3027, v3028, v3029, v3031, v3033, v3034, v3036, v3090],
    evt_cnt: 1,
    funcNum: 3,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '0'),
    onlyIf: true,
    out_tys: [ctc19],
    pay: [stdlib.checkedBigNumberify('./index.rsh:215:10:decimal', stdlib.UInt_max, '0'), [[stdlib.checkedBigNumberify('./index.rsh:167:14:decimal', stdlib.UInt_max, '0'), v2919], [stdlib.checkedBigNumberify('./index.rsh:167:14:decimal', stdlib.UInt_max, '0'), v2918]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      let sim_txn_ctr = stdlib.UInt_max;
      const getSimTokCtr = () => { sim_txn_ctr = sim_txn_ctr.sub(1); return sim_txn_ctr; };
      
      stdlib.simMapDupe(sim_r, 0, map0);
      stdlib.simMapDupe(sim_r, 1, map1);
      stdlib.simMapDupe(sim_r, 2, map2);
      stdlib.simMapDupe(sim_r, 3, map3);
      
      const {data: [v3273], secs: v3275, time: v3274, didSend: v1278, from: v3272 } = txn1;
      
      switch (v3273[0]) {
        case 'claim0_195': {
          const v3276 = v3273[1];
          
          break;
          }
        case 'setWinner0_195': {
          const v4281 = v3273[1];
          
          break;
          }
        case 'stake0_195': {
          const v5286 = v3273[1];
          
          break;
          }
        case 'unstake0_195': {
          const v6291 = v3273[1];
          
          break;
          }
        case 'updateTime0_195': {
          const v7296 = v3273[1];
          
          break;
          }
        case 'withdrawAll0_195': {
          const v8301 = v3273[1];
          sim_r.txns.push({
            kind: 'api',
            who: "withdrawAll"
            });
          ;
          const v8377 = v2995[stdlib.checkedBigNumberify('./index.rsh:123:31:dot', stdlib.UInt_max, '1')];
          const v8378 = v8377[stdlib.checkedBigNumberify('./index.rsh:123:31:dot', stdlib.UInt_max, '0')];
          ;
          ;
          stdlib.protect(map3_ctc, await stdlib.simMapRef(sim_r, 3, ctc8, v3272, ctc4), null);
          const v9267 = stdlib.protect(map0_ctc, await stdlib.simMapRef(sim_r, 0, ctc8, v3272, ctc1), null);
          const v9268 = stdlib.fromSome(v9267, stdlib.checkedBigNumberify('./index.rsh:99:68:decimal', stdlib.UInt_max, '0'));
          await stdlib.simMapSet(sim_r, 3, ctc8, v3272, ctc4, true);
          const v9296 = stdlib.sub(v8378, v9268);
          const v9298 = stdlib.Array_set(v8377, '0', v9296);
          const v9299 = stdlib.Array_set(v2995, stdlib.checkedBigNumberify('./index.rsh:226:58:application', stdlib.UInt_max, '1'), v9298);
          sim_r.txns.push({
            kind: 'from',
            to: v3272,
            tok: v2919
            });
          const v9300 = null;
          const v9301 = await txn1.getOutput('withdrawAll', 'v9300', ctc0, v9300);
          
          const v11293 = v2988;
          const v11295 = v9299;
          const v11296 = v2988.lastUpdateTime;
          const v11297 = v2988.prizeClaimed;
          const v11298 = v2988.rewardPerToken;
          const v11299 = v2988.totalStake;
          const v11300 = v2988.winner;
          const v11301 = v11298.sign;
          const v11302 = v11298.i;
          const v11303 = v11302.scale;
          const v11304 = v11302.i;
          const v11305 = {
            i: v11304,
            scale: v11303
            };
          const v11306 = {
            i: v11305,
            sign: v11301
            };
          sim_r.isHalt = false;
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined /* mto */,
    tys: [ctc8, ctc9, ctc9, ctc1, ctc5, ctc11, ctc13, ctc1, ctc4, ctc5, ctc1, ctc10, ctc4, ctc1, ctc1, ctc15, ctc19],
    waitIfNotPresent: false
    }));
  const {data: [v3273], secs: v3275, time: v3274, didSend: v1278, from: v3272 } = txn1;
  switch (v3273[0]) {
    case 'claim0_195': {
      const v3276 = v3273[1];
      return;
      break;
      }
    case 'setWinner0_195': {
      const v4281 = v3273[1];
      return;
      break;
      }
    case 'stake0_195': {
      const v5286 = v3273[1];
      return;
      break;
      }
    case 'unstake0_195': {
      const v6291 = v3273[1];
      return;
      break;
      }
    case 'updateTime0_195': {
      const v7296 = v3273[1];
      return;
      break;
      }
    case 'withdrawAll0_195': {
      const v8301 = v3273[1];
      undefined /* setApiDetails */;
      ;
      const v8377 = v2995[stdlib.checkedBigNumberify('./index.rsh:123:31:dot', stdlib.UInt_max, '1')];
      const v8378 = v8377[stdlib.checkedBigNumberify('./index.rsh:123:31:dot', stdlib.UInt_max, '0')];
      ;
      ;
      const v9263 = stdlib.protect(map3_ctc, await stdlib.mapRef(map3, ctc8, v3272, ctc4), null);
      const v9264 = stdlib.fromSome(v9263, false);
      const v9265 = v9264 ? false : true;
      stdlib.assert(v9265, {
        at: 'reach standard library:57:5:application',
        fs: ['at ./index.rsh:216:12:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:223:20:application call to [unknown function] (defined at: ./index.rsh:223:20:function exp)'],
        msg: 'Already withdrawn previously',
        who: 'withdrawAll'
        });
      const v9267 = stdlib.protect(map0_ctc, await stdlib.mapRef(map0, ctc8, v3272, ctc1), null);
      const v9268 = stdlib.fromSome(v9267, stdlib.checkedBigNumberify('./index.rsh:99:68:decimal', stdlib.UInt_max, '0'));
      const v9271 = stdlib.le(v9268, v8378);
      stdlib.assert(v9271, {
        at: 'reach standard library:57:5:application',
        fs: ['at ./index.rsh:217:12:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:223:20:application call to [unknown function] (defined at: ./index.rsh:223:20:function exp)'],
        msg: 'Insufficient tokens in contract',
        who: 'withdrawAll'
        });
      const v9274 = stdlib.le(v3274, v2920);
      const v9275 = v9274 ? false : true;
      stdlib.assert(v9275, {
        at: 'reach standard library:57:5:application',
        fs: ['at ./index.rsh:224:16:application call to "check" (defined at: reach standard library:49:32:function exp)', 'at ./index.rsh:223:20:application call to [unknown function] (defined at: ./index.rsh:223:20:function exp)'],
        msg: 'Withdrawal period has not started',
        who: 'withdrawAll'
        });
      await stdlib.mapSet(map3, ctc8, v3272, ctc4, true);
      const v9296 = stdlib.sub(v8378, v9268);
      const v9298 = stdlib.Array_set(v8377, '0', v9296);
      const v9299 = stdlib.Array_set(v2995, stdlib.checkedBigNumberify('./index.rsh:226:58:application', stdlib.UInt_max, '1'), v9298);
      ;
      const v9300 = null;
      const v9301 = await txn1.getOutput('withdrawAll', 'v9300', ctc0, v9300);
      if (v1278) {
        stdlib.protect(ctc0, await interact.out(v8301, v9301), {
          at: './index.rsh:215:11:application',
          fs: ['at ./index.rsh:215:11:application call to [unknown function] (defined at: ./index.rsh:215:11:function exp)', 'at ./index.rsh:227:19:application call to "callback" (defined at: ./index.rsh:223:20:function exp)', 'at ./index.rsh:223:20:application call to [unknown function] (defined at: ./index.rsh:223:20:function exp)'],
          msg: 'out',
          who: 'withdrawAll'
          });
        }
      else {
        }
      
      const v11293 = v2988;
      const v11295 = v9299;
      const v11296 = v2988.lastUpdateTime;
      const v11297 = v2988.prizeClaimed;
      const v11298 = v2988.rewardPerToken;
      const v11299 = v2988.totalStake;
      const v11300 = v2988.winner;
      const v11301 = v11298.sign;
      const v11302 = v11298.i;
      const v11303 = v11302.scale;
      const v11304 = v11302.i;
      const v11305 = {
        i: v11304,
        scale: v11303
        };
      const v11306 = {
        i: v11305,
        sign: v11301
        };
      return;
      
      break;
      }
    }
  
  
  };
export async function claim(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for claim expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for claim expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const step = await ctc.getCurrentStep()
  if (step == 4) {return _claim4(ctcTop, interact);}
  throw stdlib.apiStateMismatchError({ _stateSourceMap }, [stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '4')], stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, step))
  };
export async function setWinner(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for setWinner expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for setWinner expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const step = await ctc.getCurrentStep()
  if (step == 4) {return _setWinner4(ctcTop, interact);}
  throw stdlib.apiStateMismatchError({ _stateSourceMap }, [stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '4')], stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, step))
  };
export async function stake(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for stake expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for stake expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const step = await ctc.getCurrentStep()
  if (step == 4) {return _stake4(ctcTop, interact);}
  throw stdlib.apiStateMismatchError({ _stateSourceMap }, [stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '4')], stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, step))
  };
export async function unstake(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for unstake expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for unstake expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const step = await ctc.getCurrentStep()
  if (step == 4) {return _unstake4(ctcTop, interact);}
  throw stdlib.apiStateMismatchError({ _stateSourceMap }, [stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '4')], stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, step))
  };
export async function updateTime(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for updateTime expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for updateTime expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const step = await ctc.getCurrentStep()
  if (step == 4) {return _updateTime4(ctcTop, interact);}
  throw stdlib.apiStateMismatchError({ _stateSourceMap }, [stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '4')], stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, step))
  };
export async function withdrawAll(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for withdrawAll expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for withdrawAll expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const step = await ctc.getCurrentStep()
  if (step == 4) {return _withdrawAll4(ctcTop, interact);}
  throw stdlib.apiStateMismatchError({ _stateSourceMap }, [stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, '4')], stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, step))
  };
const _ALGO = {
  ABI: {
    impure: [`_reachp_0((uint64,uint64,uint64,uint64))void`, `_reachp_1((uint64))void`, `_reachp_3((uint64,(byte,byte[32])))void`, `claim()void`, `setWinner(address)void`, `stake(uint64)void`, `unstake(uint64)void`, `updateTime()uint64`, `withdrawAll()void`],
    pure: [`globalState()(uint64,uint64,(byte,(uint64,uint64)),(byte,byte[32]),byte)`, `initialState()(uint64,uint64,uint64)`, `localState(address)(uint64,(byte,(uint64,uint64)),(byte,(uint64,uint64)),byte)`],
    sigs: [`_reachp_0((uint64,uint64,uint64,uint64))void`, `_reachp_1((uint64))void`, `_reachp_3((uint64,(byte,byte[32])))void`, `claim()void`, `globalState()(uint64,uint64,(byte,(uint64,uint64)),(byte,byte[32]),byte)`, `initialState()(uint64,uint64,uint64)`, `localState(address)(uint64,(byte,(uint64,uint64)),(byte,(uint64,uint64)),byte)`, `setWinner(address)void`, `stake(uint64)void`, `unstake(uint64)void`, `updateTime()uint64`, `withdrawAll()void`]
    },
  GlobalNumByteSlice: 4,
  GlobalNumUint: 0,
  LocalNumByteSlice: 0,
  LocalNumUint: 0,
  appApproval: `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`,
  appApprovalMap: {
    0: `2`,
    1: `2`,
    10: `2`,
    100: `24`,
    1000: `542`,
    1001: `542`,
    1002: `543`,
    1003: `544`,
    1004: `545`,
    1005: `545`,
    1006: `546`,
    1007: `546`,
    1008: `547`,
    1009: `547`,
    101: `25`,
    1010: `548`,
    1011: `548`,
    1012: `549`,
    1013: `549`,
    1014: `550`,
    1015: `550`,
    1016: `550`,
    1017: `553`,
    1018: `553`,
    1019: `553`,
    102: `26`,
    1020: `555`,
    1021: `555`,
    1022: `556`,
    1023: `556`,
    1024: `556`,
    1025: `557`,
    1026: `558`,
    1027: `558`,
    1028: `559`,
    1029: `560`,
    103: `28`,
    1030: `561`,
    1031: `561`,
    1032: `562`,
    1033: `562`,
    1034: `563`,
    1035: `564`,
    1036: `565`,
    1037: `565`,
    1038: `566`,
    1039: `567`,
    104: `28`,
    1040: `569`,
    1041: `570`,
    1042: `571`,
    1043: `572`,
    1044: `573`,
    1045: `573`,
    1046: `574`,
    1047: `575`,
    1048: `575`,
    1049: `575`,
    105: `28`,
    1050: `576`,
    1051: `576`,
    1052: `576`,
    1053: `577`,
    1054: `578`,
    1055: `578`,
    1056: `579`,
    1057: `579`,
    1058: `580`,
    1059: `580`,
    106: `28`,
    1060: `581`,
    1061: `582`,
    1062: `587`,
    1063: `587`,
    1064: `588`,
    1065: `588`,
    1066: `589`,
    1067: `590`,
    1068: `595`,
    1069: `595`,
    107: `28`,
    1070: `596`,
    1071: `596`,
    1072: `597`,
    1073: `598`,
    1074: `603`,
    1075: `603`,
    1076: `604`,
    1077: `604`,
    1078: `604`,
    1079: `605`,
    108: `28`,
    1080: `605`,
    1081: `606`,
    1082: `606`,
    1083: `608`,
    1084: `608`,
    1085: `610`,
    1086: `611`,
    1087: `611`,
    1088: `612`,
    1089: `613`,
    109: `28`,
    1090: `614`,
    1091: `614`,
    1092: `615`,
    1093: `616`,
    1094: `616`,
    1095: `616`,
    1096: `617`,
    1097: `617`,
    1098: `617`,
    1099: `618`,
    11: `2`,
    110: `28`,
    1100: `618`,
    1101: `619`,
    1102: `619`,
    1103: `621`,
    1104: `622`,
    1105: `622`,
    1106: `623`,
    1107: `624`,
    1108: `625`,
    1109: `625`,
    111: `28`,
    1110: `626`,
    1111: `627`,
    1112: `627`,
    1113: `627`,
    1114: `628`,
    1115: `628`,
    1116: `628`,
    1117: `629`,
    1118: `629`,
    1119: `630`,
    112: `28`,
    1120: `630`,
    1121: `631`,
    1122: `631`,
    1123: `631`,
    1124: `632`,
    1125: `633`,
    1126: `633`,
    1127: `634`,
    1128: `635`,
    1129: `636`,
    113: `28`,
    1130: `636`,
    1131: `637`,
    1132: `637`,
    1133: `638`,
    1134: `638`,
    1135: `638`,
    1136: `639`,
    1137: `640`,
    1138: `640`,
    1139: `641`,
    114: `28`,
    1140: `642`,
    1141: `643`,
    1142: `643`,
    1143: `644`,
    1144: `644`,
    1145: `645`,
    1146: `645`,
    1147: `646`,
    1148: `646`,
    1149: `647`,
    115: `28`,
    1150: `647`,
    1151: `648`,
    1152: `649`,
    1153: `650`,
    1154: `650`,
    1155: `651`,
    1156: `651`,
    1157: `652`,
    1158: `652`,
    1159: `653`,
    116: `28`,
    1160: `654`,
    1161: `654`,
    1162: `654`,
    1163: `655`,
    1164: `655`,
    1165: `656`,
    1166: `656`,
    1167: `658`,
    1168: `658`,
    1169: `659`,
    117: `28`,
    1170: `659`,
    1171: `660`,
    1172: `661`,
    1173: `661`,
    1174: `661`,
    1175: `662`,
    1176: `662`,
    1177: `663`,
    1178: `663`,
    1179: `665`,
    118: `28`,
    1180: `665`,
    1181: `666`,
    1182: `666`,
    1183: `666`,
    1184: `667`,
    1185: `668`,
    1186: `668`,
    1187: `669`,
    1188: `669`,
    1189: `670`,
    119: `28`,
    1190: `670`,
    1191: `670`,
    1192: `671`,
    1193: `672`,
    1194: `673`,
    1195: `674`,
    1196: `674`,
    1197: `675`,
    1198: `676`,
    1199: `676`,
    12: `2`,
    120: `28`,
    1200: `677`,
    1201: `678`,
    1202: `678`,
    1203: `678`,
    1204: `679`,
    1205: `680`,
    1206: `680`,
    1207: `681`,
    1208: `681`,
    1209: `682`,
    121: `28`,
    1210: `682`,
    1211: `682`,
    1212: `683`,
    1213: `684`,
    1214: `684`,
    1215: `685`,
    1216: `685`,
    1217: `686`,
    1218: `686`,
    1219: `686`,
    122: `28`,
    1220: `687`,
    1221: `688`,
    1222: `689`,
    1223: `689`,
    1224: `690`,
    1225: `690`,
    1226: `691`,
    1227: `692`,
    1228: `692`,
    1229: `693`,
    123: `28`,
    1230: `693`,
    1231: `694`,
    1232: `695`,
    1233: `695`,
    1234: `696`,
    1235: `697`,
    1236: `697`,
    1237: `697`,
    1238: `698`,
    1239: `699`,
    124: `28`,
    1240: `699`,
    1241: `700`,
    1242: `700`,
    1243: `701`,
    1244: `701`,
    1245: `702`,
    1246: `702`,
    1247: `703`,
    1248: `704`,
    1249: `704`,
    125: `28`,
    1250: `704`,
    1251: `705`,
    1252: `705`,
    1253: `706`,
    1254: `706`,
    1255: `707`,
    1256: `708`,
    1257: `709`,
    1258: `709`,
    1259: `710`,
    126: `28`,
    1260: `711`,
    1261: `711`,
    1262: `711`,
    1263: `712`,
    1264: `713`,
    1265: `713`,
    1266: `715`,
    1267: `715`,
    1268: `716`,
    1269: `716`,
    127: `28`,
    1270: `716`,
    1271: `717`,
    1272: `718`,
    1273: `718`,
    1274: `719`,
    1275: `719`,
    1276: `720`,
    1277: `720`,
    1278: `721`,
    1279: `722`,
    128: `28`,
    1280: `723`,
    1281: `724`,
    1282: `724`,
    1283: `725`,
    1284: `725`,
    1285: `726`,
    1286: `726`,
    1287: `726`,
    1288: `727`,
    1289: `728`,
    129: `28`,
    1290: `728`,
    1291: `729`,
    1292: `730`,
    1293: `731`,
    1294: `732`,
    1295: `732`,
    1296: `733`,
    1297: `733`,
    1298: `734`,
    1299: `734`,
    13: `2`,
    130: `28`,
    1300: `735`,
    1301: `735`,
    1302: `736`,
    1303: `737`,
    1304: `738`,
    1305: `738`,
    1306: `739`,
    1307: `739`,
    1308: `740`,
    1309: `740`,
    131: `28`,
    1310: `741`,
    1311: `742`,
    1312: `742`,
    1313: `742`,
    1314: `743`,
    1315: `743`,
    1316: `744`,
    1317: `744`,
    1318: `746`,
    1319: `746`,
    132: `28`,
    1320: `747`,
    1321: `747`,
    1322: `748`,
    1323: `749`,
    1324: `749`,
    1325: `749`,
    1326: `750`,
    1327: `750`,
    1328: `751`,
    1329: `752`,
    133: `28`,
    1330: `752`,
    1331: `753`,
    1332: `754`,
    1333: `755`,
    1334: `755`,
    1335: `756`,
    1336: `757`,
    1337: `757`,
    1338: `757`,
    1339: `758`,
    134: `28`,
    1340: `759`,
    1341: `759`,
    1342: `761`,
    1343: `761`,
    1344: `762`,
    1345: `762`,
    1346: `762`,
    1347: `763`,
    1348: `764`,
    1349: `764`,
    135: `28`,
    1350: `765`,
    1351: `765`,
    1352: `766`,
    1353: `766`,
    1354: `766`,
    1355: `767`,
    1356: `768`,
    1357: `769`,
    1358: `770`,
    1359: `770`,
    136: `28`,
    1360: `771`,
    1361: `772`,
    1362: `772`,
    1363: `773`,
    1364: `774`,
    1365: `774`,
    1366: `774`,
    1367: `775`,
    1368: `776`,
    1369: `776`,
    137: `28`,
    1370: `777`,
    1371: `777`,
    1372: `778`,
    1373: `778`,
    1374: `778`,
    1375: `779`,
    1376: `780`,
    1377: `780`,
    1378: `781`,
    1379: `781`,
    138: `28`,
    1380: `782`,
    1381: `782`,
    1382: `782`,
    1383: `783`,
    1384: `784`,
    1385: `785`,
    1386: `786`,
    1387: `786`,
    1388: `787`,
    1389: `788`,
    139: `28`,
    1390: `788`,
    1391: `789`,
    1392: `790`,
    1393: `790`,
    1394: `790`,
    1395: `791`,
    1396: `792`,
    1397: `792`,
    1398: `793`,
    1399: `793`,
    14: `2`,
    140: `28`,
    1400: `794`,
    1401: `795`,
    1402: `795`,
    1403: `796`,
    1404: `796`,
    1405: `797`,
    1406: `798`,
    1407: `798`,
    1408: `798`,
    1409: `799`,
    141: `28`,
    1410: `799`,
    1411: `800`,
    1412: `800`,
    1413: `801`,
    1414: `802`,
    1415: `803`,
    1416: `803`,
    1417: `804`,
    1418: `805`,
    1419: `805`,
    142: `28`,
    1420: `805`,
    1421: `806`,
    1422: `807`,
    1423: `807`,
    1424: `809`,
    1425: `809`,
    1426: `810`,
    1427: `811`,
    1428: `811`,
    1429: `812`,
    143: `28`,
    1430: `813`,
    1431: `813`,
    1432: `814`,
    1433: `814`,
    1434: `814`,
    1435: `815`,
    1436: `815`,
    1437: `816`,
    1438: `817`,
    1439: `818`,
    144: `28`,
    1440: `818`,
    1441: `819`,
    1442: `819`,
    1443: `819`,
    1444: `820`,
    1445: `821`,
    1446: `821`,
    1447: `821`,
    1448: `822`,
    1449: `822`,
    145: `28`,
    1450: `823`,
    1451: `824`,
    1452: `824`,
    1453: `825`,
    1454: `826`,
    1455: `826`,
    1456: `827`,
    1457: `827`,
    1458: `827`,
    1459: `828`,
    146: `28`,
    1460: `828`,
    1461: `829`,
    1462: `830`,
    1463: `830`,
    1464: `831`,
    1465: `832`,
    1466: `832`,
    1467: `833`,
    1468: `833`,
    1469: `834`,
    147: `28`,
    1470: `835`,
    1471: `836`,
    1472: `836`,
    1473: `836`,
    1474: `837`,
    1475: `837`,
    1476: `839`,
    1477: `839`,
    1478: `840`,
    1479: `840`,
    148: `28`,
    1480: `841`,
    1481: `841`,
    1482: `841`,
    1483: `842`,
    1484: `843`,
    1485: `843`,
    1486: `844`,
    1487: `844`,
    1488: `844`,
    1489: `844`,
    149: `28`,
    1490: `844`,
    1491: `844`,
    1492: `844`,
    1493: `844`,
    1494: `844`,
    1495: `844`,
    1496: `845`,
    1497: `845`,
    1498: `846`,
    1499: `847`,
    15: `2`,
    150: `28`,
    1500: `848`,
    1501: `848`,
    1502: `849`,
    1503: `849`,
    1504: `850`,
    1505: `850`,
    1506: `851`,
    1507: `852`,
    1508: `852`,
    1509: `853`,
    151: `28`,
    1510: `854`,
    1511: `854`,
    1512: `854`,
    1513: `855`,
    1514: `856`,
    1515: `856`,
    1516: `857`,
    1517: `858`,
    1518: `858`,
    1519: `859`,
    152: `28`,
    1520: `859`,
    1521: `860`,
    1522: `861`,
    1523: `862`,
    1524: `863`,
    1525: `863`,
    1526: `864`,
    1527: `865`,
    1528: `865`,
    1529: `866`,
    153: `28`,
    1530: `866`,
    1531: `867`,
    1532: `867`,
    1533: `868`,
    1534: `868`,
    1535: `869`,
    1536: `869`,
    1537: `870`,
    1538: `871`,
    1539: `872`,
    154: `28`,
    1540: `872`,
    1541: `873`,
    1542: `873`,
    1543: `874`,
    1544: `874`,
    1545: `875`,
    1546: `875`,
    1547: `876`,
    1548: `876`,
    1549: `877`,
    155: `28`,
    1550: `877`,
    1551: `877`,
    1552: `880`,
    1553: `880`,
    1554: `881`,
    1555: `881`,
    1556: `882`,
    1557: `882`,
    1558: `882`,
    1559: `882`,
    156: `28`,
    1560: `882`,
    1561: `882`,
    1562: `882`,
    1563: `882`,
    1564: `882`,
    1565: `882`,
    1566: `883`,
    1567: `883`,
    1568: `884`,
    1569: `885`,
    157: `28`,
    1570: `886`,
    1571: `887`,
    1572: `887`,
    1573: `888`,
    1574: `889`,
    1575: `889`,
    1576: `890`,
    1577: `890`,
    1578: `891`,
    1579: `891`,
    158: `28`,
    1580: `892`,
    1581: `892`,
    1582: `892`,
    1583: `895`,
    1584: `895`,
    1585: `896`,
    1586: `896`,
    1587: `896`,
    1588: `897`,
    1589: `898`,
    159: `28`,
    1590: `898`,
    1591: `899`,
    1592: `900`,
    1593: `901`,
    1594: `901`,
    1595: `902`,
    1596: `904`,
    1597: `905`,
    1598: `906`,
    1599: `906`,
    16: `2`,
    160: `28`,
    1600: `907`,
    1601: `907`,
    1602: `908`,
    1603: `909`,
    1604: `909`,
    1605: `909`,
    1606: `910`,
    1607: `910`,
    1608: `910`,
    1609: `911`,
    161: `28`,
    1610: `912`,
    1611: `913`,
    1612: `918`,
    1613: `919`,
    1614: `921`,
    1615: `922`,
    1616: `923`,
    1617: `924`,
    1618: `925`,
    1619: `925`,
    162: `28`,
    1620: `926`,
    1621: `927`,
    1622: `927`,
    1623: `927`,
    1624: `928`,
    1625: `928`,
    1626: `928`,
    1627: `929`,
    1628: `930`,
    1629: `931`,
    163: `28`,
    1630: `931`,
    1631: `932`,
    1632: `932`,
    1633: `933`,
    1634: `934`,
    1635: `939`,
    1636: `939`,
    1637: `940`,
    1638: `940`,
    1639: `941`,
    164: `28`,
    1640: `942`,
    1641: `943`,
    1642: `948`,
    1643: `948`,
    1644: `948`,
    1645: `949`,
    1646: `949`,
    1647: `950`,
    1648: `950`,
    1649: `951`,
    165: `29`,
    1650: `952`,
    1651: `953`,
    1652: `953`,
    1653: `953`,
    1654: `954`,
    1655: `954`,
    1656: `956`,
    1657: `956`,
    1658: `957`,
    1659: `957`,
    166: `29`,
    1660: `958`,
    1661: `958`,
    1662: `958`,
    1663: `959`,
    1664: `960`,
    1665: `960`,
    1666: `961`,
    1667: `961`,
    1668: `961`,
    1669: `961`,
    167: `29`,
    1670: `961`,
    1671: `961`,
    1672: `961`,
    1673: `961`,
    1674: `961`,
    1675: `961`,
    1676: `962`,
    1677: `962`,
    1678: `963`,
    1679: `964`,
    168: `30`,
    1680: `965`,
    1681: `965`,
    1682: `966`,
    1683: `966`,
    1684: `967`,
    1685: `967`,
    1686: `968`,
    1687: `968`,
    1688: `969`,
    1689: `969`,
    169: `30`,
    1690: `970`,
    1691: `970`,
    1692: `971`,
    1693: `971`,
    1694: `972`,
    1695: `973`,
    1696: `974`,
    1697: `974`,
    1698: `975`,
    1699: `975`,
    17: `2`,
    170: `30`,
    1700: `976`,
    1701: `976`,
    1702: `977`,
    1703: `977`,
    1704: `978`,
    1705: `978`,
    1706: `978`,
    1707: `981`,
    1708: `981`,
    1709: `982`,
    171: `30`,
    1710: `983`,
    1711: `983`,
    1712: `986`,
    1713: `987`,
    1714: `987`,
    1715: `988`,
    1716: `989`,
    1717: `990`,
    1718: `990`,
    1719: `990`,
    172: `30`,
    1720: `991`,
    1721: `991`,
    1722: `992`,
    1723: `993`,
    1724: `994`,
    1725: `994`,
    1726: `995`,
    1727: `995`,
    1728: `996`,
    1729: `996`,
    173: `30`,
    1730: `996`,
    1731: `997`,
    1732: `997`,
    1733: `998`,
    1734: `998`,
    1735: `998`,
    1736: `998`,
    1737: `998`,
    1738: `998`,
    1739: `999`,
    174: `30`,
    1740: `999`,
    1741: `1000`,
    1742: `1001`,
    1743: `1002`,
    1744: `1002`,
    1745: `1003`,
    1746: `1004`,
    1747: `1006`,
    1748: `1006`,
    1749: `1007`,
    175: `30`,
    1750: `1007`,
    1751: `1007`,
    1752: `1008`,
    1753: `1008`,
    1754: `1009`,
    1755: `1010`,
    1756: `1011`,
    1757: `1011`,
    1758: `1011`,
    1759: `1011`,
    176: `30`,
    1760: `1011`,
    1761: `1011`,
    1762: `1011`,
    1763: `1011`,
    1764: `1011`,
    1765: `1011`,
    1766: `1011`,
    1767: `1011`,
    1768: `1011`,
    1769: `1011`,
    177: `30`,
    1770: `1012`,
    1771: `1012`,
    1772: `1012`,
    1773: `1015`,
    1774: `1015`,
    1775: `1016`,
    1776: `1017`,
    1777: `1018`,
    1778: `1021`,
    1779: `1021`,
    178: `30`,
    1780: `1021`,
    1781: `1022`,
    1782: `1022`,
    1783: `1023`,
    1784: `1024`,
    1785: `1024`,
    1786: `1025`,
    1787: `1026`,
    1788: `1027`,
    1789: `1027`,
    179: `30`,
    1790: `1028`,
    1791: `1029`,
    1792: `1029`,
    1793: `1030`,
    1794: `1031`,
    1795: `1031`,
    1796: `1032`,
    1797: `1033`,
    1798: `1033`,
    1799: `1033`,
    18: `2`,
    180: `30`,
    1800: `1034`,
    1801: `1035`,
    1802: `1035`,
    1803: `1037`,
    1804: `1037`,
    1805: `1038`,
    1806: `1039`,
    1807: `1040`,
    1808: `1042`,
    1809: `1042`,
    181: `30`,
    1810: `1042`,
    1811: `1045`,
    1812: `1045`,
    1813: `1046`,
    1814: `1047`,
    1815: `1048`,
    1816: `1048`,
    1817: `1048`,
    1818: `1049`,
    1819: `1049`,
    182: `30`,
    1820: `1050`,
    1821: `1051`,
    1822: `1052`,
    1823: `1055`,
    1824: `1055`,
    1825: `1055`,
    1826: `1056`,
    1827: `1056`,
    1828: `1057`,
    1829: `1058`,
    183: `30`,
    1830: `1058`,
    1831: `1059`,
    1832: `1060`,
    1833: `1061`,
    1834: `1061`,
    1835: `1062`,
    1836: `1063`,
    1837: `1064`,
    1838: `1065`,
    1839: `1065`,
    184: `30`,
    1840: `1066`,
    1841: `1066`,
    1842: `1067`,
    1843: `1067`,
    1844: `1067`,
    1845: `1070`,
    1846: `1070`,
    1847: `1071`,
    1848: `1072`,
    1849: `1073`,
    185: `30`,
    1850: `1076`,
    1851: `1076`,
    1852: `1076`,
    1853: `1077`,
    1854: `1077`,
    1855: `1078`,
    1856: `1078`,
    1857: `1079`,
    1858: `1079`,
    1859: `1080`,
    186: `30`,
    1860: `1081`,
    1861: `1081`,
    1862: `1083`,
    1863: `1084`,
    1864: `1084`,
    1865: `1085`,
    1866: `1086`,
    1867: `1087`,
    1868: `1087`,
    1869: `1088`,
    187: `30`,
    1870: `1089`,
    1871: `1089`,
    1872: `1089`,
    1873: `1090`,
    1874: `1090`,
    1875: `1090`,
    1876: `1091`,
    1877: `1092`,
    1878: `1092`,
    1879: `1093`,
    188: `30`,
    1880: `1093`,
    1881: `1093`,
    1882: `1094`,
    1883: `1094`,
    1884: `1095`,
    1885: `1095`,
    1886: `1097`,
    1887: `1098`,
    1888: `1098`,
    1889: `1099`,
    189: `30`,
    1890: `1100`,
    1891: `1101`,
    1892: `1101`,
    1893: `1102`,
    1894: `1103`,
    1895: `1103`,
    1896: `1103`,
    1897: `1104`,
    1898: `1104`,
    1899: `1104`,
    19: `2`,
    190: `30`,
    1900: `1105`,
    1901: `1106`,
    1902: `1106`,
    1903: `1107`,
    1904: `1107`,
    1905: `1107`,
    1906: `1108`,
    1907: `1108`,
    1908: `1109`,
    1909: `1110`,
    191: `30`,
    1910: `1112`,
    1911: `1113`,
    1912: `1114`,
    1913: `1115`,
    1914: `1116`,
    1915: `1116`,
    1916: `1117`,
    1917: `1118`,
    1918: `1118`,
    1919: `1118`,
    192: `30`,
    1920: `1119`,
    1921: `1119`,
    1922: `1119`,
    1923: `1120`,
    1924: `1120`,
    1925: `1121`,
    1926: `1121`,
    1927: `1121`,
    1928: `1122`,
    1929: `1122`,
    193: `30`,
    1930: `1123`,
    1931: `1123`,
    1932: `1123`,
    1933: `1124`,
    1934: `1124`,
    1935: `1125`,
    1936: `1125`,
    1937: `1125`,
    1938: `1126`,
    1939: `1127`,
    194: `32`,
    1940: `1128`,
    1941: `1129`,
    1942: `1129`,
    1943: `1130`,
    1944: `1130`,
    1945: `1130`,
    1946: `1131`,
    1947: `1131`,
    1948: `1132`,
    1949: `1132`,
    195: `35`,
    1950: `1132`,
    1951: `1133`,
    1952: `1133`,
    1953: `1134`,
    1954: `1134`,
    1955: `1134`,
    1956: `1135`,
    1957: `1136`,
    1958: `1137`,
    1959: `1138`,
    196: `35`,
    1960: `1140`,
    1961: `1141`,
    1962: `1142`,
    1963: `1142`,
    1964: `1143`,
    1965: `1143`,
    1966: `1144`,
    1967: `1145`,
    1968: `1145`,
    1969: `1145`,
    197: `36`,
    1970: `1146`,
    1971: `1146`,
    1972: `1146`,
    1973: `1147`,
    1974: `1148`,
    1975: `1148`,
    1976: `1149`,
    1977: `1149`,
    1978: `1149`,
    1979: `1152`,
    198: `36`,
    1980: `1153`,
    1981: `1154`,
    1982: `1155`,
    1983: `1155`,
    1984: `1156`,
    1985: `1157`,
    1986: `1158`,
    1987: `1158`,
    1988: `1159`,
    1989: `1159`,
    199: `36`,
    1990: `1159`,
    1991: `1162`,
    1992: `1163`,
    1993: `1164`,
    1994: `1165`,
    1995: `1165`,
    1996: `1166`,
    1997: `1167`,
    1998: `1168`,
    1999: `1168`,
    2: `2`,
    20: `2`,
    200: `37`,
    2000: `1169`,
    2001: `1170`,
    2002: `1171`,
    2003: `1172`,
    2004: `1172`,
    2005: `1173`,
    2006: `1173`,
    2007: `1173`,
    2008: `1176`,
    2009: `1177`,
    201: `38`,
    2010: `1178`,
    2011: `1178`,
    2012: `1179`,
    2013: `1179`,
    2014: `1180`,
    2015: `1181`,
    2016: `1182`,
    2017: `1182`,
    2018: `1183`,
    2019: `1184`,
    202: `38`,
    2020: `1185`,
    2021: `1186`,
    2022: `1186`,
    2023: `1187`,
    2024: `1187`,
    2025: `1187`,
    2026: `1190`,
    2027: `1190`,
    2028: `1190`,
    2029: `1190`,
    203: `39`,
    2030: `1190`,
    2031: `1190`,
    2032: `1190`,
    2033: `1190`,
    2034: `1190`,
    2035: `1190`,
    2036: `1190`,
    2037: `1190`,
    2038: `1190`,
    2039: `1190`,
    204: `40`,
    2040: `1190`,
    2041: `1190`,
    2042: `1190`,
    2043: `1190`,
    2044: `1190`,
    2045: `1190`,
    2046: `1190`,
    2047: `1190`,
    2048: `1190`,
    2049: `1190`,
    205: `41`,
    2050: `1190`,
    2051: `1190`,
    2052: `1190`,
    2053: `1190`,
    2054: `1190`,
    2055: `1190`,
    2056: `1190`,
    2057: `1190`,
    2058: `1190`,
    2059: `1190`,
    206: `41`,
    2060: `1190`,
    2061: `1190`,
    2062: `1190`,
    2063: `1190`,
    2064: `1190`,
    2065: `1190`,
    2066: `1190`,
    2067: `1190`,
    2068: `1190`,
    2069: `1191`,
    207: `42`,
    2070: `1191`,
    2071: `1192`,
    2072: `1192`,
    2073: `1192`,
    2074: `1195`,
    2075: `1195`,
    2076: `1195`,
    2077: `1195`,
    2078: `1195`,
    2079: `1195`,
    208: `42`,
    2080: `1195`,
    2081: `1195`,
    2082: `1195`,
    2083: `1195`,
    2084: `1195`,
    2085: `1195`,
    2086: `1195`,
    2087: `1195`,
    2088: `1195`,
    2089: `1195`,
    209: `43`,
    2090: `1195`,
    2091: `1195`,
    2092: `1195`,
    2093: `1195`,
    2094: `1195`,
    2095: `1195`,
    2096: `1195`,
    2097: `1195`,
    2098: `1195`,
    2099: `1195`,
    21: `2`,
    210: `44`,
    2100: `1195`,
    2101: `1195`,
    2102: `1195`,
    2103: `1195`,
    2104: `1195`,
    2105: `1195`,
    2106: `1195`,
    2107: `1195`,
    2108: `1195`,
    2109: `1195`,
    211: `49`,
    2110: `1195`,
    2111: `1195`,
    2112: `1195`,
    2113: `1195`,
    2114: `1195`,
    2115: `1195`,
    2116: `1195`,
    2117: `1196`,
    2118: `1196`,
    2119: `1197`,
    212: `49`,
    2120: `1197`,
    2121: `1197`,
    2122: `1200`,
    2123: `1200`,
    2124: `1201`,
    2125: `1201`,
    2126: `1202`,
    2127: `1202`,
    2128: `1203`,
    2129: `1204`,
    213: `50`,
    2130: `1205`,
    2131: `1205`,
    2132: `1206`,
    2133: `1206`,
    2134: `1207`,
    2135: `1208`,
    2136: `1209`,
    2137: `1209`,
    2138: `1210`,
    2139: `1210`,
    214: `51`,
    2140: `1211`,
    2141: `1211`,
    2142: `1212`,
    2143: `1213`,
    2144: `1213`,
    2145: `1214`,
    2146: `1214`,
    2147: `1215`,
    2148: `1215`,
    2149: `1216`,
    215: `52`,
    2150: `1217`,
    2151: `1217`,
    2152: `1218`,
    2153: `1218`,
    2154: `1218`,
    2155: `1218`,
    2156: `1218`,
    2157: `1218`,
    2158: `1219`,
    2159: `1219`,
    216: `52`,
    2160: `1220`,
    2161: `1221`,
    2162: `1222`,
    2163: `1222`,
    2164: `1223`,
    2165: `1224`,
    2166: `1225`,
    2167: `1225`,
    2168: `1226`,
    2169: `1227`,
    217: `52`,
    2170: `1228`,
    2171: `1228`,
    2172: `1229`,
    2173: `1230`,
    2174: `1231`,
    2175: `1233`,
    2176: `1233`,
    2177: `1234`,
    2178: `1234`,
    2179: `1234`,
    218: `52`,
    2180: `1235`,
    2181: `1235`,
    2182: `1236`,
    2183: `1237`,
    2184: `1238`,
    2185: `1238`,
    2186: `1239`,
    2187: `1240`,
    2188: `1241`,
    2189: `1242`,
    219: `52`,
    2190: `1242`,
    2191: `1243`,
    2192: `1244`,
    2193: `1244`,
    2194: `1244`,
    2195: `1245`,
    2196: `1246`,
    2197: `1247`,
    2198: `1247`,
    2199: `1248`,
    22: `2`,
    220: `52`,
    2200: `1248`,
    2201: `1249`,
    2202: `1250`,
    2203: `1250`,
    2204: `1251`,
    2205: `1252`,
    2206: `1252`,
    2207: `1252`,
    2208: `1253`,
    2209: `1254`,
    221: `53`,
    2210: `1255`,
    2211: `1255`,
    2212: `1256`,
    2213: `1256`,
    2214: `1257`,
    2215: `1257`,
    2216: `1258`,
    2217: `1258`,
    2218: `1259`,
    2219: `1259`,
    222: `53`,
    2220: `1260`,
    2221: `1261`,
    2222: `1264`,
    2223: `1264`,
    2224: `1265`,
    2225: `1265`,
    2226: `1266`,
    2227: `1267`,
    2228: `1271`,
    2229: `1271`,
    223: `53`,
    2230: `1272`,
    2231: `1272`,
    2232: `1272`,
    2233: `1273`,
    2234: `1275`,
    2235: `1275`,
    2236: `1276`,
    2237: `1276`,
    2238: `1277`,
    2239: `1277`,
    224: `56`,
    2240: `1277`,
    2241: `1278`,
    2242: `1278`,
    2243: `1279`,
    2244: `1279`,
    2245: `1279`,
    2246: `1280`,
    2247: `1282`,
    2248: `1282`,
    2249: `1283`,
    225: `56`,
    2250: `1283`,
    2251: `1284`,
    2252: `1284`,
    2253: `1284`,
    2254: `1286`,
    2255: `1286`,
    2256: `1287`,
    2257: `1287`,
    2258: `1288`,
    2259: `1289`,
    226: `57`,
    2260: `1290`,
    2261: `1290`,
    2262: `1291`,
    2263: `1292`,
    2264: `1293`,
    2265: `1293`,
    2266: `1294`,
    2267: `1295`,
    2268: `1296`,
    2269: `1296`,
    227: `57`,
    2270: `1297`,
    2271: `1298`,
    2272: `1298`,
    2273: `1298`,
    2274: `1299`,
    2275: `1300`,
    2276: `1301`,
    2277: `1302`,
    2278: `1302`,
    2279: `1303`,
    228: `58`,
    2280: `1303`,
    2281: `1303`,
    2282: `1306`,
    2283: `1307`,
    2284: `1307`,
    2285: `1308`,
    2286: `1309`,
    2287: `1310`,
    2288: `1310`,
    2289: `1310`,
    229: `59`,
    2290: `1311`,
    2291: `1311`,
    2292: `1312`,
    2293: `1313`,
    2294: `1313`,
    2295: `1314`,
    2296: `1314`,
    2297: `1314`,
    2298: `1314`,
    2299: `1314`,
    23: `2`,
    230: `64`,
    2300: `1314`,
    2301: `1315`,
    2302: `1315`,
    2303: `1316`,
    2304: `1317`,
    2305: `1318`,
    2306: `1320`,
    2307: `1320`,
    2308: `1321`,
    2309: `1321`,
    231: `64`,
    2310: `1321`,
    2311: `1322`,
    2312: `1322`,
    2313: `1323`,
    2314: `1323`,
    2315: `1323`,
    2316: `1324`,
    2317: `1324`,
    2318: `1325`,
    2319: `1326`,
    232: `65`,
    2320: `1326`,
    2321: `1327`,
    2322: `1327`,
    2323: `1327`,
    2324: `1330`,
    2325: `1330`,
    2326: `1331`,
    2327: `1331`,
    2328: `1332`,
    2329: `1333`,
    233: `66`,
    2330: `1336`,
    2331: `1336`,
    2332: `1337`,
    2333: `1337`,
    2334: `1338`,
    2335: `1338`,
    2336: `1339`,
    2337: `1340`,
    2338: `1341`,
    2339: `1342`,
    234: `67`,
    2340: `1342`,
    2341: `1343`,
    2342: `1344`,
    2343: `1345`,
    2344: `1346`,
    2345: `1347`,
    2346: `1347`,
    2347: `1348`,
    2348: `1349`,
    2349: `1350`,
    235: `68`,
    2350: `1350`,
    2351: `1351`,
    2352: `1351`,
    2353: `1352`,
    2354: `1352`,
    2355: `1353`,
    2356: `1354`,
    2357: `1355`,
    2358: `1356`,
    2359: `1357`,
    236: `69`,
    2360: `1358`,
    2361: `1359`,
    2362: `1359`,
    2363: `1360`,
    2364: `1360`,
    2365: `1361`,
    2366: `1361`,
    2367: `1362`,
    2368: `1362`,
    2369: `1363`,
    237: `74`,
    2370: `1363`,
    2371: `1364`,
    2372: `1364`,
    2373: `1364`,
    2374: `1366`,
    2375: `1366`,
    2376: `1366`,
    2377: `1367`,
    2378: `1367`,
    2379: `1367`,
    238: `74`,
    2380: `1367`,
    2381: `1368`,
    2382: `1368`,
    2383: `1368`,
    2384: `1370`,
    2385: `1371`,
    2386: `1372`,
    2387: `1372`,
    2388: `1373`,
    2389: `1373`,
    239: `75`,
    2390: `1374`,
    2391: `1374`,
    2392: `1376`,
    2393: `1376`,
    2394: `1376`,
    2395: `1376`,
    2396: `1376`,
    2397: `1376`,
    2398: `1376`,
    2399: `1376`,
    24: `2`,
    240: `75`,
    2400: `1377`,
    2401: `1377`,
    2402: `1378`,
    2403: `1378`,
    2404: `1378`,
    2405: `1379`,
    2406: `1379`,
    2407: `1380`,
    2408: `1382`,
    2409: `1382`,
    241: `76`,
    2410: `1383`,
    2411: `1383`,
    2412: `1385`,
    2413: `1385`,
    2414: `1385`,
    2415: `1386`,
    2416: `1386`,
    2417: `1387`,
    2418: `1387`,
    2419: `1387`,
    242: `77`,
    2420: `1389`,
    2421: `1389`,
    2422: `1389`,
    2423: `1391`,
    2424: `1391`,
    2425: `1391`,
    2426: `1392`,
    2427: `1392`,
    2428: `1393`,
    2429: `1393`,
    243: `78`,
    2430: `1393`,
    2431: `1395`,
    2432: `1395`,
    2433: `1395`,
    2434: `1397`,
    2435: `1397`,
    2436: `1397`,
    2437: `1398`,
    2438: `1398`,
    2439: `1399`,
    244: `83`,
    2440: `1399`,
    2441: `1399`,
    2442: `1401`,
    2443: `1402`,
    2444: `1402`,
    2445: `1403`,
    2446: `1404`,
    2447: `1405`,
    2448: `1406`,
    2449: `1406`,
    245: `84`,
    2450: `1407`,
    2451: `1408`,
    2452: `1409`,
    2453: `1410`,
    2454: `1410`,
    2455: `1411`,
    2456: `1412`,
    2457: `1413`,
    2458: `1414`,
    2459: `1414`,
    246: `84`,
    2460: `1415`,
    2461: `1416`,
    2462: `1417`,
    2463: `1418`,
    2464: `1418`,
    2465: `1419`,
    2466: `1419`,
    2467: `1419`,
    2468: `1420`,
    2469: `1420`,
    247: `85`,
    2470: `1420`,
    2471: `1421`,
    2472: `1422`,
    2473: `1423`,
    2474: `1424`,
    2475: `1424`,
    2476: `1424`,
    2477: `1427`,
    2478: `1427`,
    2479: `1427`,
    248: `85`,
    2480: `1430`,
    2481: `1430`,
    2482: `1430`,
    2483: `1433`,
    2484: `1433`,
    2485: `1433`,
    2486: `1435`,
    2487: `1435`,
    2488: `1435`,
    2489: `1437`,
    249: `85`,
    2490: `1437`,
    2491: `1437`,
    2492: `1439`,
    2493: `1439`,
    2494: `1439`,
    2495: `1441`,
    2496: `1441`,
    2497: `1441`,
    2498: `1443`,
    2499: `1443`,
    25: `2`,
    250: `85`,
    2500: `1443`,
    2501: `1445`,
    2502: `1445`,
    2503: `1445`,
    2504: `1447`,
    2505: `1447`,
    2506: `1448`,
    2507: `1453`,
    2508: `1454`,
    2509: `1454`,
    251: `85`,
    2510: `1455`,
    2511: `1456`,
    2512: `1461`,
    2513: `1461`,
    2514: `1462`,
    2515: `1462`,
    2516: `1463`,
    2517: `1464`,
    2518: `1465`,
    2519: `1470`,
    252: `85`,
    2520: `1472`,
    2521: `1472`,
    2522: `1473`,
    2523: `1473`,
    2524: `1474`,
    2525: `1474`,
    2526: `1474`,
    2527: `1475`,
    2528: `1476`,
    2529: `1476`,
    253: `85`,
    2530: `1477`,
    2531: `1477`,
    2532: `1477`,
    2533: `1477`,
    2534: `1477`,
    2535: `1477`,
    2536: `1477`,
    2537: `1477`,
    2538: `1477`,
    2539: `1477`,
    254: `85`,
    2540: `1478`,
    2541: `1478`,
    2542: `1479`,
    2543: `1480`,
    2544: `1481`,
    2545: `1481`,
    2546: `1482`,
    2547: `1482`,
    2548: `1483`,
    2549: `1483`,
    255: `85`,
    2550: `1484`,
    2551: `1485`,
    2552: `1486`,
    2553: `1487`,
    2554: `1487`,
    2555: `1488`,
    2556: `1489`,
    2557: `1489`,
    2558: `1490`,
    2559: `1491`,
    256: `85`,
    2560: `1492`,
    2561: `1492`,
    2562: `1493`,
    2563: `1494`,
    2564: `1494`,
    2565: `1495`,
    2566: `1495`,
    2567: `1496`,
    2568: `1496`,
    2569: `1497`,
    257: `86`,
    2570: `1497`,
    2571: `1498`,
    2572: `1499`,
    2573: `1500`,
    2574: `1501`,
    2575: `1501`,
    2576: `1502`,
    2577: `1502`,
    2578: `1503`,
    2579: `1503`,
    258: `86`,
    2580: `1504`,
    2581: `1504`,
    2582: `1505`,
    2583: `1505`,
    2584: `1506`,
    2585: `1506`,
    2586: `1506`,
    2587: `1508`,
    2588: `1509`,
    2589: `1509`,
    259: `87`,
    2590: `1510`,
    2591: `1510`,
    2592: `1510`,
    2593: `1512`,
    2594: `1512`,
    2595: `1513`,
    2596: `1513`,
    2597: `1513`,
    2598: `1514`,
    2599: `1514`,
    26: `2`,
    260: `88`,
    2600: `1515`,
    2601: `1516`,
    2602: `1516`,
    2603: `1517`,
    2604: `1517`,
    2605: `1517`,
    2606: `1519`,
    2607: `1519`,
    2608: `1520`,
    2609: `1520`,
    261: `89`,
    2610: `1521`,
    2611: `1522`,
    2612: `1522`,
    2613: `1523`,
    2614: `1523`,
    2615: `1524`,
    2616: `1525`,
    2617: `1526`,
    2618: `1526`,
    2619: `1527`,
    262: `89`,
    2620: `1527`,
    2621: `1528`,
    2622: `1528`,
    2623: `1529`,
    2624: `1529`,
    2625: `1530`,
    2626: `1530`,
    2627: `1531`,
    2628: `1532`,
    2629: `1533`,
    263: `90`,
    2630: `1533`,
    2631: `1534`,
    2632: `1534`,
    2633: `1535`,
    2634: `1535`,
    2635: `1536`,
    2636: `1537`,
    2637: `1537`,
    2638: `1537`,
    2639: `1538`,
    264: `90`,
    2640: `1538`,
    2641: `1539`,
    2642: `1539`,
    2643: `1541`,
    2644: `1541`,
    2645: `1542`,
    2646: `1542`,
    2647: `1543`,
    2648: `1544`,
    2649: `1544`,
    265: `91`,
    2650: `1544`,
    2651: `1545`,
    2652: `1545`,
    2653: `1546`,
    2654: `1547`,
    2655: `1547`,
    2656: `1548`,
    2657: `1549`,
    2658: `1550`,
    2659: `1551`,
    266: `91`,
    2660: `1551`,
    2661: `1553`,
    2662: `1553`,
    2663: `1554`,
    2664: `1554`,
    2665: `1554`,
    2666: `1555`,
    2667: `1556`,
    2668: `1556`,
    2669: `1557`,
    267: `92`,
    2670: `1557`,
    2671: `1558`,
    2672: `1558`,
    2673: `1558`,
    2674: `1559`,
    2675: `1560`,
    2676: `1561`,
    2677: `1562`,
    2678: `1562`,
    2679: `1563`,
    268: `93`,
    2680: `1564`,
    2681: `1564`,
    2682: `1565`,
    2683: `1566`,
    2684: `1566`,
    2685: `1566`,
    2686: `1567`,
    2687: `1568`,
    2688: `1568`,
    2689: `1569`,
    269: `93`,
    2690: `1569`,
    2691: `1570`,
    2692: `1570`,
    2693: `1570`,
    2694: `1571`,
    2695: `1572`,
    2696: `1572`,
    2697: `1573`,
    2698: `1573`,
    2699: `1574`,
    27: `2`,
    270: `94`,
    2700: `1574`,
    2701: `1574`,
    2702: `1575`,
    2703: `1576`,
    2704: `1577`,
    2705: `1578`,
    2706: `1578`,
    2707: `1579`,
    2708: `1580`,
    2709: `1580`,
    271: `95`,
    2710: `1581`,
    2711: `1582`,
    2712: `1582`,
    2713: `1582`,
    2714: `1583`,
    2715: `1584`,
    2716: `1584`,
    2717: `1585`,
    2718: `1585`,
    2719: `1586`,
    272: `95`,
    2720: `1587`,
    2721: `1587`,
    2722: `1588`,
    2723: `1588`,
    2724: `1589`,
    2725: `1590`,
    2726: `1590`,
    2727: `1590`,
    2728: `1591`,
    2729: `1591`,
    273: `95`,
    2730: `1592`,
    2731: `1592`,
    2732: `1593`,
    2733: `1594`,
    2734: `1595`,
    2735: `1595`,
    2736: `1596`,
    2737: `1597`,
    2738: `1597`,
    2739: `1597`,
    274: `96`,
    2740: `1598`,
    2741: `1599`,
    2742: `1599`,
    2743: `1601`,
    2744: `1601`,
    2745: `1602`,
    2746: `1602`,
    2747: `1602`,
    2748: `1603`,
    2749: `1603`,
    275: `97`,
    2750: `1604`,
    2751: `1605`,
    2752: `1606`,
    2753: `1606`,
    2754: `1607`,
    2755: `1607`,
    2756: `1607`,
    2757: `1608`,
    2758: `1609`,
    2759: `1609`,
    276: `97`,
    2760: `1610`,
    2761: `1610`,
    2762: `1610`,
    2763: `1612`,
    2764: `1612`,
    2765: `1613`,
    2766: `1613`,
    2767: `1614`,
    2768: `1615`,
    2769: `1615`,
    277: `98`,
    2770: `1616`,
    2771: `1617`,
    2772: `1618`,
    2773: `1618`,
    2774: `1619`,
    2775: `1620`,
    2776: `1621`,
    2777: `1621`,
    2778: `1622`,
    2779: `1623`,
    278: `99`,
    2780: `1623`,
    2781: `1623`,
    2782: `1624`,
    2783: `1625`,
    2784: `1625`,
    2785: `1626`,
    2786: `1626`,
    2787: `1626`,
    2788: `1628`,
    2789: `1628`,
    279: `99`,
    2790: `1629`,
    2791: `1629`,
    2792: `1630`,
    2793: `1631`,
    2794: `1631`,
    2795: `1632`,
    2796: `1633`,
    2797: `1634`,
    2798: `1634`,
    2799: `1635`,
    28: `2`,
    280: `100`,
    2800: `1636`,
    2801: `1637`,
    2802: `1638`,
    2803: `1639`,
    2804: `1639`,
    2805: `1640`,
    2806: `1640`,
    2807: `1640`,
    2808: `1642`,
    2809: `1642`,
    281: `101`,
    2810: `1643`,
    2811: `1643`,
    2812: `1644`,
    2813: `1645`,
    2814: `1645`,
    2815: `1646`,
    2816: `1646`,
    2817: `1647`,
    2818: `1648`,
    2819: `1648`,
    282: `102`,
    2820: `1649`,
    2821: `1649`,
    2822: `1650`,
    2823: `1651`,
    2824: `1652`,
    2825: `1653`,
    2826: `1653`,
    2827: `1654`,
    2828: `1654`,
    2829: `1654`,
    283: `103`,
    2830: `1655`,
    2831: `1656`,
    2832: `1656`,
    2833: `1657`,
    2834: `1658`,
    2835: `1659`,
    2836: `1659`,
    2837: `1660`,
    2838: `1660`,
    2839: `1660`,
    284: `103`,
    2840: `1661`,
    2841: `1662`,
    2842: `1663`,
    2843: `1664`,
    2844: `1665`,
    2845: `1665`,
    2846: `1666`,
    2847: `1666`,
    2848: `1666`,
    2849: `1667`,
    285: `104`,
    2850: `1668`,
    2851: `1668`,
    2852: `1669`,
    2853: `1669`,
    2854: `1669`,
    2855: `1671`,
    2856: `1671`,
    2857: `1672`,
    2858: `1673`,
    2859: `1674`,
    286: `104`,
    2860: `1674`,
    2861: `1675`,
    2862: `1676`,
    2863: `1676`,
    2864: `1677`,
    2865: `1678`,
    2866: `1679`,
    2867: `1679`,
    2868: `1680`,
    2869: `1681`,
    287: `104`,
    2870: `1682`,
    2871: `1682`,
    2872: `1683`,
    2873: `1683`,
    2874: `1683`,
    2875: `1684`,
    2876: `1685`,
    2877: `1685`,
    2878: `1686`,
    2879: `1686`,
    288: `105`,
    2880: `1686`,
    2881: `1688`,
    2882: `1688`,
    2883: `1689`,
    2884: `1690`,
    2885: `1691`,
    2886: `1691`,
    2887: `1692`,
    2888: `1693`,
    2889: `1693`,
    289: `106`,
    2890: `1694`,
    2891: `1695`,
    2892: `1696`,
    2893: `1696`,
    2894: `1697`,
    2895: `1698`,
    2896: `1699`,
    2897: `1699`,
    2898: `1700`,
    2899: `1700`,
    29: `2`,
    290: `107`,
    2900: `1700`,
    2901: `1701`,
    2902: `1702`,
    2903: `1702`,
    2904: `1703`,
    2905: `1703`,
    2906: `1703`,
    2907: `1705`,
    2908: `1705`,
    2909: `1706`,
    291: `107`,
    2910: `1706`,
    2911: `1707`,
    2912: `1708`,
    2913: `1708`,
    2914: `1709`,
    2915: `1709`,
    2916: `1710`,
    2917: `1711`,
    2918: `1711`,
    2919: `1712`,
    292: `108`,
    2920: `1712`,
    2921: `1713`,
    2922: `1714`,
    2923: `1715`,
    2924: `1716`,
    2925: `1716`,
    2926: `1717`,
    2927: `1717`,
    2928: `1717`,
    2929: `1718`,
    293: `108`,
    2930: `1719`,
    2931: `1719`,
    2932: `1720`,
    2933: `1721`,
    2934: `1722`,
    2935: `1722`,
    2936: `1723`,
    2937: `1723`,
    2938: `1723`,
    2939: `1724`,
    294: `109`,
    2940: `1725`,
    2941: `1726`,
    2942: `1727`,
    2943: `1728`,
    2944: `1728`,
    2945: `1729`,
    2946: `1729`,
    2947: `1729`,
    2948: `1730`,
    2949: `1731`,
    295: `109`,
    2950: `1731`,
    2951: `1732`,
    2952: `1732`,
    2953: `1732`,
    2954: `1734`,
    2955: `1734`,
    2956: `1735`,
    2957: `1736`,
    2958: `1737`,
    2959: `1737`,
    296: `112`,
    2960: `1738`,
    2961: `1739`,
    2962: `1739`,
    2963: `1740`,
    2964: `1741`,
    2965: `1742`,
    2966: `1742`,
    2967: `1743`,
    2968: `1744`,
    2969: `1745`,
    297: `112`,
    2970: `1745`,
    2971: `1746`,
    2972: `1746`,
    2973: `1746`,
    2974: `1747`,
    2975: `1748`,
    2976: `1748`,
    2977: `1749`,
    2978: `1749`,
    2979: `1749`,
    298: `113`,
    2980: `1751`,
    2981: `1751`,
    2982: `1752`,
    2983: `1752`,
    2984: `1753`,
    2985: `1754`,
    2986: `1754`,
    2987: `1755`,
    2988: `1756`,
    2989: `1757`,
    299: `114`,
    2990: `1757`,
    2991: `1758`,
    2992: `1759`,
    2993: `1760`,
    2994: `1760`,
    2995: `1761`,
    2996: `1762`,
    2997: `1762`,
    2998: `1762`,
    2999: `1763`,
    3: `2`,
    30: `2`,
    300: `115`,
    3000: `1764`,
    3001: `1764`,
    3002: `1765`,
    3003: `1765`,
    3004: `1765`,
    3005: `1767`,
    3006: `1767`,
    3007: `1768`,
    3008: `1768`,
    3009: `1769`,
    301: `115`,
    3010: `1770`,
    3011: `1770`,
    3012: `1771`,
    3013: `1771`,
    3014: `1772`,
    3015: `1773`,
    3016: `1773`,
    3017: `1774`,
    3018: `1774`,
    3019: `1775`,
    302: `116`,
    3020: `1776`,
    3021: `1777`,
    3022: `1778`,
    3023: `1778`,
    3024: `1779`,
    3025: `1779`,
    3026: `1779`,
    3027: `1780`,
    3028: `1781`,
    3029: `1781`,
    303: `116`,
    3030: `1782`,
    3031: `1783`,
    3032: `1784`,
    3033: `1784`,
    3034: `1785`,
    3035: `1785`,
    3036: `1785`,
    3037: `1786`,
    3038: `1787`,
    3039: `1788`,
    304: `117`,
    3040: `1789`,
    3041: `1790`,
    3042: `1790`,
    3043: `1791`,
    3044: `1791`,
    3045: `1791`,
    3046: `1792`,
    3047: `1793`,
    3048: `1793`,
    3049: `1794`,
    305: `117`,
    3050: `1794`,
    3051: `1794`,
    3052: `1796`,
    3053: `1796`,
    3054: `1797`,
    3055: `1798`,
    3056: `1799`,
    3057: `1802`,
    3058: `1802`,
    3059: `1802`,
    306: `117`,
    3060: `1803`,
    3061: `1803`,
    3062: `1804`,
    3063: `1805`,
    3064: `1805`,
    3065: `1806`,
    3066: `1807`,
    3067: `1808`,
    3068: `1808`,
    3069: `1809`,
    307: `118`,
    3070: `1810`,
    3071: `1811`,
    3072: `1812`,
    3073: `1812`,
    3074: `1813`,
    3075: `1813`,
    3076: `1814`,
    3077: `1814`,
    3078: `1814`,
    3079: `1816`,
    308: `119`,
    3080: `1816`,
    3081: `1817`,
    3082: `1817`,
    3083: `1818`,
    3084: `1819`,
    3085: `1819`,
    3086: `1820`,
    3087: `1820`,
    3088: `1821`,
    3089: `1822`,
    309: `119`,
    3090: `1823`,
    3091: `1823`,
    3092: `1824`,
    3093: `1824`,
    3094: `1825`,
    3095: `1825`,
    3096: `1826`,
    3097: `1826`,
    3098: `1827`,
    3099: `1827`,
    31: `2`,
    310: `120`,
    3100: `1828`,
    3101: `1829`,
    3102: `1830`,
    3103: `1830`,
    3104: `1831`,
    3105: `1831`,
    3106: `1832`,
    3107: `1832`,
    3108: `1833`,
    3109: `1834`,
    311: `120`,
    3110: `1834`,
    3111: `1834`,
    3112: `1835`,
    3113: `1835`,
    3114: `1836`,
    3115: `1836`,
    3116: `1838`,
    3117: `1838`,
    3118: `1839`,
    3119: `1839`,
    312: `121`,
    3120: `1840`,
    3121: `1841`,
    3122: `1841`,
    3123: `1841`,
    3124: `1842`,
    3125: `1842`,
    3126: `1843`,
    3127: `1844`,
    3128: `1844`,
    3129: `1845`,
    313: `121`,
    3130: `1846`,
    3131: `1847`,
    3132: `1848`,
    3133: `1848`,
    3134: `1850`,
    3135: `1850`,
    3136: `1851`,
    3137: `1851`,
    3138: `1851`,
    3139: `1852`,
    314: `121`,
    3140: `1853`,
    3141: `1853`,
    3142: `1854`,
    3143: `1854`,
    3144: `1855`,
    3145: `1855`,
    3146: `1855`,
    3147: `1856`,
    3148: `1857`,
    3149: `1858`,
    315: `122`,
    3150: `1859`,
    3151: `1859`,
    3152: `1860`,
    3153: `1861`,
    3154: `1861`,
    3155: `1862`,
    3156: `1863`,
    3157: `1863`,
    3158: `1863`,
    3159: `1864`,
    316: `122`,
    3160: `1865`,
    3161: `1865`,
    3162: `1866`,
    3163: `1866`,
    3164: `1867`,
    3165: `1867`,
    3166: `1867`,
    3167: `1868`,
    3168: `1869`,
    3169: `1869`,
    317: `123`,
    3170: `1870`,
    3171: `1870`,
    3172: `1871`,
    3173: `1871`,
    3174: `1871`,
    3175: `1872`,
    3176: `1873`,
    3177: `1874`,
    3178: `1875`,
    3179: `1875`,
    318: `123`,
    3180: `1876`,
    3181: `1877`,
    3182: `1877`,
    3183: `1878`,
    3184: `1879`,
    3185: `1879`,
    3186: `1879`,
    3187: `1880`,
    3188: `1881`,
    3189: `1881`,
    319: `124`,
    3190: `1882`,
    3191: `1882`,
    3192: `1883`,
    3193: `1884`,
    3194: `1884`,
    3195: `1885`,
    3196: `1885`,
    3197: `1886`,
    3198: `1887`,
    3199: `1887`,
    32: `2`,
    320: `124`,
    3200: `1887`,
    3201: `1888`,
    3202: `1888`,
    3203: `1889`,
    3204: `1889`,
    3205: `1890`,
    3206: `1891`,
    3207: `1892`,
    3208: `1892`,
    3209: `1893`,
    321: `125`,
    3210: `1894`,
    3211: `1894`,
    3212: `1894`,
    3213: `1895`,
    3214: `1896`,
    3215: `1896`,
    3216: `1898`,
    3217: `1898`,
    3218: `1899`,
    3219: `1899`,
    322: `126`,
    3220: `1899`,
    3221: `1900`,
    3222: `1900`,
    3223: `1901`,
    3224: `1902`,
    3225: `1903`,
    3226: `1903`,
    3227: `1904`,
    3228: `1904`,
    3229: `1904`,
    323: `126`,
    3230: `1905`,
    3231: `1906`,
    3232: `1906`,
    3233: `1907`,
    3234: `1907`,
    3235: `1907`,
    3236: `1909`,
    3237: `1909`,
    3238: `1910`,
    3239: `1910`,
    324: `127`,
    3240: `1911`,
    3241: `1912`,
    3242: `1912`,
    3243: `1913`,
    3244: `1914`,
    3245: `1915`,
    3246: `1915`,
    3247: `1916`,
    3248: `1917`,
    3249: `1918`,
    325: `127`,
    3250: `1918`,
    3251: `1919`,
    3252: `1920`,
    3253: `1920`,
    3254: `1920`,
    3255: `1921`,
    3256: `1922`,
    3257: `1922`,
    3258: `1923`,
    3259: `1923`,
    326: `128`,
    3260: `1923`,
    3261: `1925`,
    3262: `1925`,
    3263: `1926`,
    3264: `1926`,
    3265: `1927`,
    3266: `1928`,
    3267: `1928`,
    3268: `1929`,
    3269: `1930`,
    327: `128`,
    3270: `1931`,
    3271: `1931`,
    3272: `1932`,
    3273: `1933`,
    3274: `1934`,
    3275: `1935`,
    3276: `1936`,
    3277: `1936`,
    3278: `1937`,
    3279: `1937`,
    328: `128`,
    3280: `1937`,
    3281: `1939`,
    3282: `1939`,
    3283: `1940`,
    3284: `1940`,
    3285: `1941`,
    3286: `1942`,
    3287: `1942`,
    3288: `1943`,
    3289: `1943`,
    329: `129`,
    3290: `1944`,
    3291: `1945`,
    3292: `1945`,
    3293: `1946`,
    3294: `1946`,
    3295: `1947`,
    3296: `1948`,
    3297: `1949`,
    3298: `1950`,
    3299: `1950`,
    33: `2`,
    330: `129`,
    3300: `1951`,
    3301: `1951`,
    3302: `1951`,
    3303: `1952`,
    3304: `1953`,
    3305: `1953`,
    3306: `1954`,
    3307: `1955`,
    3308: `1956`,
    3309: `1956`,
    331: `130`,
    3310: `1957`,
    3311: `1957`,
    3312: `1957`,
    3313: `1958`,
    3314: `1959`,
    3315: `1960`,
    3316: `1961`,
    3317: `1962`,
    3318: `1962`,
    3319: `1963`,
    332: `130`,
    3320: `1963`,
    3321: `1963`,
    3322: `1964`,
    3323: `1965`,
    3324: `1965`,
    3325: `1966`,
    3326: `1966`,
    3327: `1966`,
    3328: `1968`,
    3329: `1968`,
    333: `131`,
    3330: `1969`,
    3331: `1970`,
    3332: `1971`,
    3333: `1971`,
    3334: `1972`,
    3335: `1973`,
    3336: `1973`,
    3337: `1974`,
    3338: `1975`,
    3339: `1976`,
    334: `131`,
    3340: `1976`,
    3341: `1977`,
    3342: `1978`,
    3343: `1979`,
    3344: `1979`,
    3345: `1980`,
    3346: `1980`,
    3347: `1980`,
    3348: `1981`,
    3349: `1982`,
    335: `131`,
    3350: `1982`,
    3351: `1983`,
    3352: `1983`,
    3353: `1983`,
    3354: `1985`,
    3355: `1985`,
    3356: `1986`,
    3357: `1987`,
    3358: `1988`,
    3359: `1988`,
    336: `132`,
    3360: `1989`,
    3361: `1990`,
    3362: `1990`,
    3363: `1991`,
    3364: `1992`,
    3365: `1993`,
    3366: `1993`,
    3367: `1994`,
    3368: `1995`,
    3369: `1996`,
    337: `133`,
    3370: `1996`,
    3371: `1997`,
    3372: `1997`,
    3373: `1997`,
    3374: `1998`,
    3375: `1999`,
    3376: `1999`,
    3377: `2000`,
    3378: `2000`,
    3379: `2000`,
    338: `133`,
    3380: `2002`,
    3381: `2002`,
    3382: `2003`,
    3383: `2003`,
    3384: `2004`,
    3385: `2005`,
    3386: `2005`,
    3387: `2006`,
    3388: `2006`,
    3389: `2007`,
    339: `134`,
    3390: `2008`,
    3391: `2008`,
    3392: `2009`,
    3393: `2009`,
    3394: `2010`,
    3395: `2011`,
    3396: `2012`,
    3397: `2013`,
    3398: `2013`,
    3399: `2014`,
    34: `2`,
    340: `134`,
    3400: `2014`,
    3401: `2014`,
    3402: `2015`,
    3403: `2016`,
    3404: `2016`,
    3405: `2017`,
    3406: `2018`,
    3407: `2019`,
    3408: `2019`,
    3409: `2020`,
    341: `135`,
    3410: `2020`,
    3411: `2020`,
    3412: `2021`,
    3413: `2022`,
    3414: `2023`,
    3415: `2024`,
    3416: `2025`,
    3417: `2025`,
    3418: `2026`,
    3419: `2026`,
    342: `135`,
    3420: `2026`,
    3421: `2027`,
    3422: `2028`,
    3423: `2028`,
    3424: `2029`,
    3425: `2029`,
    3426: `2029`,
    3427: `2031`,
    3428: `2031`,
    3429: `2032`,
    343: `135`,
    3430: `2033`,
    3431: `2034`,
    3432: `2034`,
    3433: `2035`,
    3434: `2036`,
    3435: `2036`,
    3436: `2037`,
    3437: `2038`,
    3438: `2039`,
    3439: `2039`,
    344: `136`,
    3440: `2040`,
    3441: `2041`,
    3442: `2042`,
    3443: `2042`,
    3444: `2043`,
    3445: `2043`,
    3446: `2043`,
    3447: `2044`,
    3448: `2045`,
    3449: `2045`,
    345: `137`,
    3450: `2046`,
    3451: `2046`,
    3452: `2046`,
    3453: `2048`,
    3454: `2048`,
    3455: `2049`,
    3456: `2049`,
    3457: `2050`,
    3458: `2051`,
    3459: `2051`,
    346: `137`,
    3460: `2052`,
    3461: `2053`,
    3462: `2054`,
    3463: `2054`,
    3464: `2055`,
    3465: `2056`,
    3466: `2057`,
    3467: `2057`,
    3468: `2058`,
    3469: `2059`,
    347: `138`,
    3470: `2059`,
    3471: `2059`,
    3472: `2060`,
    3473: `2061`,
    3474: `2061`,
    3475: `2062`,
    3476: `2062`,
    3477: `2062`,
    3478: `2064`,
    3479: `2064`,
    348: `139`,
    3480: `2065`,
    3481: `2065`,
    3482: `2066`,
    3483: `2067`,
    3484: `2067`,
    3485: `2068`,
    3486: `2068`,
    3487: `2069`,
    3488: `2070`,
    3489: `2070`,
    349: `140`,
    3490: `2071`,
    3491: `2071`,
    3492: `2072`,
    3493: `2073`,
    3494: `2074`,
    3495: `2075`,
    3496: `2075`,
    3497: `2076`,
    3498: `2076`,
    3499: `2076`,
    35: `2`,
    350: `140`,
    3500: `2077`,
    3501: `2078`,
    3502: `2078`,
    3503: `2079`,
    3504: `2080`,
    3505: `2081`,
    3506: `2081`,
    3507: `2082`,
    3508: `2082`,
    3509: `2082`,
    351: `141`,
    3510: `2083`,
    3511: `2084`,
    3512: `2085`,
    3513: `2086`,
    3514: `2087`,
    3515: `2087`,
    3516: `2088`,
    3517: `2088`,
    3518: `2088`,
    3519: `2089`,
    352: `141`,
    3520: `2090`,
    3521: `2090`,
    3522: `2091`,
    3523: `2091`,
    3524: `2091`,
    3525: `2093`,
    3526: `2094`,
    3527: `2094`,
    3528: `2095`,
    3529: `2095`,
    353: `142`,
    3530: `2096`,
    3531: `2096`,
    3532: `2096`,
    3533: `2097`,
    3534: `2097`,
    3535: `2097`,
    3536: `2099`,
    3537: `2100`,
    3538: `2101`,
    3539: `2102`,
    354: `143`,
    3540: `2103`,
    3541: `2105`,
    3542: `2106`,
    3543: `2106`,
    3544: `2107`,
    3545: `2108`,
    3546: `2108`,
    3547: `2109`,
    3548: `2109`,
    3549: `2110`,
    355: `144`,
    3550: `2110`,
    3551: `2111`,
    3552: `2112`,
    3553: `2114`,
    3554: `2115`,
    3555: `2115`,
    3556: `2116`,
    3557: `2117`,
    3558: `2117`,
    3559: `2118`,
    356: `144`,
    3560: `2118`,
    3561: `2119`,
    3562: `2119`,
    3563: `2120`,
    3564: `2120`,
    3565: `2121`,
    3566: `2122`,
    3567: `2125`,
    3568: `2125`,
    3569: `2125`,
    357: `145`,
    3570: `2126`,
    3571: `2126`,
    3572: `2127`,
    3573: `2127`,
    3574: `2127`,
    3575: `2130`,
    3576: `2130`,
    3577: `2130`,
    3578: `2131`,
    3579: `2131`,
    358: `145`,
    3580: `2132`,
    3581: `2132`,
    3582: `2132`,
    3583: `2135`,
    3584: `2135`,
    3585: `2135`,
    3586: `2136`,
    3587: `2137`,
    3588: `2137`,
    3589: `2138`,
    359: `146`,
    3590: `2138`,
    3591: `2138`,
    3592: `2141`,
    3593: `2141`,
    3594: `2141`,
    3595: `2142`,
    3596: `2143`,
    3597: `2143`,
    3598: `2144`,
    3599: `2144`,
    36: `2`,
    360: `147`,
    3600: `2144`,
    3601: `2146`,
    3602: `2147`,
    3603: `2149`,
    3604: `2150`,
    3605: `2151`,
    3606: `2152`,
    3607: `2152`,
    3608: `2153`,
    3609: `2153`,
    361: `147`,
    3610: `2154`,
    3611: `2154`,
    3612: `2154`,
    3613: `2155`,
    3614: `2157`,
    3615: `2158`,
    3616: `2159`,
    3617: `2159`,
    3618: `2159`,
    3619: `2160`,
    362: `147`,
    3620: `2161`,
    3621: `2161`,
    3622: `2164`,
    3623: `2164`,
    3624: `2165`,
    3625: `2165`,
    3626: `2166`,
    3627: `2167`,
    3628: `2168`,
    3629: `2169`,
    363: `148`,
    3630: `2169`,
    3631: `2170`,
    3632: `2171`,
    3633: `2171`,
    3634: `2172`,
    3635: `2172`,
    3636: `2173`,
    3637: `2173`,
    3638: `2174`,
    3639: `2175`,
    364: `148`,
    3640: `2176`,
    3641: `2176`,
    3642: `2177`,
    3643: `2178`,
    3644: `2179`,
    3645: `2180`,
    3646: `2180`,
    3647: `2181`,
    3648: `2182`,
    3649: `2183`,
    365: `149`,
    3650: `2185`,
    3651: `2185`,
    3652: `2186`,
    3653: `2186`,
    3654: `2187`,
    3655: `2188`,
    3656: `2191`,
    3657: `2192`,
    3658: `2193`,
    3659: `2193`,
    366: `150`,
    3660: `2194`,
    3661: `2194`,
    3662: `2195`,
    3663: `2195`,
    3664: `2196`,
    3665: `2196`,
    3666: `2197`,
    3667: `2197`,
    3668: `2198`,
    3669: `2198`,
    367: `150`,
    3670: `2199`,
    3671: `2199`,
    3672: `2200`,
    3673: `2202`,
    3674: `2202`,
    3675: `2204`,
    3676: `2204`,
    3677: `2205`,
    3678: `2206`,
    3679: `2206`,
    368: `151`,
    3680: `2207`,
    3681: `2207`,
    3682: `2207`,
    3683: `2209`,
    3684: `2209`,
    3685: `2210`,
    3686: `2211`,
    3687: `2211`,
    3688: `2212`,
    3689: `2213`,
    369: `152`,
    3690: `2214`,
    3691: `2214`,
    3692: `2214`,
    3693: `2217`,
    3694: `2217`,
    3695: `2217`,
    3696: `2220`,
    3697: `2220`,
    3698: `2220`,
    3699: `2222`,
    37: `2`,
    370: `153`,
    3700: `2223`,
    3701: `2223`,
    3702: `2223`,
    3703: `2224`,
    3704: `2225`,
    3705: `2226`,
    3706: `2227`,
    3707: `2228`,
    3708: `2230`,
    3709: `2231`,
    371: `154`,
    3710: `2232`,
    3711: `2233`,
    3712: `2233`,
    3713: `2233`,
    3714: `2234`,
    3715: `2234`,
    3716: `2235`,
    3717: `2236`,
    3718: `2237`,
    3719: `2239`,
    372: `154`,
    3720: `2240`,
    3721: `2241`,
    3722: `2242`,
    3723: `2242`,
    3724: `2242`,
    3725: `2243`,
    3726: `2243`,
    3727: `2244`,
    3728: `2244`,
    3729: `2244`,
    373: `156`,
    3730: `2245`,
    3731: `2245`,
    3732: `2245`,
    3733: `2247`,
    3734: `2248`,
    3735: `2248`,
    3736: `2248`,
    3737: `2250`,
    3738: `2251`,
    3739: `2251`,
    374: `156`,
    3740: `2251`,
    3741: `2252`,
    3742: `2252`,
    3743: `2253`,
    3744: `2254`,
    3745: `2254`,
    3746: `2255`,
    3747: `2256`,
    3748: `2256`,
    3749: `2257`,
    375: `157`,
    3750: `2258`,
    3751: `2258`,
    3752: `2259`,
    3753: `2260`,
    3754: `2260`,
    3755: `2261`,
    3756: `2262`,
    3757: `2262`,
    3758: `2263`,
    3759: `2264`,
    376: `157`,
    3760: `2264`,
    3761: `2265`,
    3762: `2266`,
    3763: `2266`,
    3764: `2266`,
    3765: `2267`,
    3766: `2267`,
    3767: `2268`,
    3768: `2269`,
    3769: `2269`,
    377: `158`,
    3770: `2269`,
    3771: `2270`,
    3772: `2270`,
    3773: `2271`,
    3774: `2272`,
    3775: `2272`,
    3776: `2272`,
    3777: `2273`,
    3778: `2273`,
    3779: `2274`,
    378: `159`,
    3780: `2275`,
    3781: `2275`,
    3782: `2275`,
    3783: `2276`,
    3784: `2277`,
    3785: `2277`,
    3786: `2278`,
    3787: `2279`,
    3788: `2279`,
    3789: `2279`,
    379: `160`,
    3790: `2280`,
    3791: `2281`,
    3792: `2281`,
    3793: `2282`,
    3794: `2283`,
    3795: `2283`,
    3796: `2283`,
    3797: `2284`,
    3798: `2284`,
    3799: `2285`,
    38: `2`,
    380: `160`,
    3800: `2286`,
    3801: `2286`,
    3802: `2286`,
    3803: `2287`,
    3804: `2288`,
    3805: `2288`,
    3806: `2289`,
    3807: `2290`,
    3808: `2290`,
    3809: `2290`,
    381: `161`,
    3810: `2291`,
    3811: `2291`,
    3812: `2292`,
    3813: `2293`,
    3814: `2293`,
    3815: `2293`,
    3816: `2294`,
    3817: `2295`,
    3818: `2295`,
    3819: `2296`,
    382: `162`,
    3820: `2297`,
    3821: `2297`,
    3822: `2297`,
    3823: `2298`,
    3824: `2299`,
    3825: `2299`,
    3826: `2300`,
    3827: `2301`,
    3828: `2301`,
    3829: `2301`,
    383: `163`,
    3830: `2302`,
    3831: `2303`,
    3832: `2303`,
    3833: `2304`,
    3834: `2304`,
    3835: `2304`,
    3836: `2305`,
    3837: `2305`,
    3838: `2306`,
    3839: `2307`,
    384: `163`,
    3840: `2307`,
    3841: `2308`,
    3842: `2310`,
    3843: `2310`,
    3844: `2311`,
    3845: `2312`,
    3846: `2312`,
    3847: `2313`,
    3848: `2315`,
    3849: `2316`,
    385: `164`,
    3850: `2316`,
    3851: `2317`,
    3852: `2319`,
    3853: `2320`,
    3854: `2321`,
    3855: `2322`,
    3856: `2323`,
    3857: `2323`,
    3858: `2324`,
    3859: `2325`,
    386: `165`,
    3860: `2326`,
    3861: `2327`,
    3862: `2329`,
    3863: `2330`,
    3864: `2330`,
    3865: `2330`,
    3866: `2332`,
    3867: `2332`,
    3868: `2333`,
    3869: `2333`,
    387: `166`,
    3870: `2334`,
    3871: `2335`,
    3872: `2336`,
    3873: `2336`,
    3874: `2336`,
    3875: `2337`,
    3876: `2337`,
    3877: `2337`,
    3878: `2339`,
    3879: `2340`,
    388: `166`,
    3880: `2340`,
    3881: `2340`,
    3882: `2341`,
    3883: `2341`,
    3884: `2342`,
    3885: `2343`,
    3886: `2343`,
    3887: `2344`,
    3888: `2345`,
    3889: `2345`,
    389: `167`,
    3890: `2346`,
    3891: `2347`,
    3892: `2347`,
    3893: `2348`,
    3894: `2349`,
    3895: `2349`,
    3896: `2350`,
    3897: `2351`,
    3898: `2351`,
    3899: `2352`,
    39: `2`,
    390: `168`,
    3900: `2353`,
    3901: `2353`,
    3902: `2354`,
    3903: `2354`,
    3904: `2354`,
    3905: `2355`,
    3906: `2355`,
    3907: `2356`,
    3908: `2358`,
    3909: `2359`,
    391: `168`,
    3910: `2360`,
    3911: `2360`,
    3912: `2361`,
    3913: `2361`,
    3914: `2362`,
    3915: `2362`,
    3916: `2363`,
    3917: `2363`,
    3918: `2364`,
    3919: `2364`,
    392: `169`,
    3920: `2365`,
    3921: `2366`,
    3922: `2369`,
    3923: `2369`,
    3924: `2370`,
    3925: `2370`,
    3926: `2371`,
    3927: `2372`,
    3928: `2373`,
    3929: `2374`,
    393: `170`,
    3930: `2374`,
    3931: `2375`,
    3932: `2376`,
    3933: `2376`,
    3934: `2377`,
    3935: `2377`,
    3936: `2378`,
    3937: `2378`,
    3938: `2379`,
    3939: `2380`,
    394: `170`,
    3940: `2381`,
    3941: `2381`,
    3942: `2382`,
    3943: `2383`,
    3944: `2384`,
    3945: `2385`,
    3946: `2385`,
    3947: `2386`,
    3948: `2386`,
    3949: `2387`,
    395: `171`,
    3950: `2388`,
    3951: `2389`,
    3952: `2389`,
    3953: `2390`,
    3954: `2391`,
    3955: `2392`,
    396: `172`,
    397: `172`,
    398: `173`,
    399: `174`,
    4: `2`,
    40: `2`,
    400: `175`,
    401: `175`,
    402: `176`,
    403: `177`,
    404: `177`,
    405: `177`,
    406: `178`,
    407: `179`,
    408: `179`,
    409: `180`,
    41: `2`,
    410: `181`,
    411: `181`,
    412: `182`,
    413: `183`,
    414: `184`,
    415: `184`,
    416: `185`,
    417: `186`,
    418: `186`,
    419: `187`,
    42: `2`,
    420: `188`,
    421: `188`,
    422: `188`,
    423: `189`,
    424: `190`,
    425: `190`,
    426: `191`,
    427: `192`,
    428: `193`,
    429: `193`,
    43: `2`,
    430: `194`,
    431: `195`,
    432: `196`,
    433: `196`,
    434: `197`,
    435: `198`,
    436: `199`,
    437: `199`,
    438: `201`,
    439: `201`,
    44: `2`,
    440: `202`,
    441: `202`,
    442: `203`,
    443: `204`,
    444: `204`,
    445: `205`,
    446: `205`,
    447: `205`,
    448: `206`,
    449: `207`,
    45: `2`,
    450: `208`,
    451: `208`,
    452: `209`,
    453: `209`,
    454: `209`,
    455: `210`,
    456: `211`,
    457: `212`,
    458: `213`,
    459: `213`,
    46: `2`,
    460: `213`,
    461: `214`,
    462: `215`,
    463: `216`,
    464: `216`,
    465: `217`,
    466: `218`,
    467: `218`,
    468: `219`,
    469: `220`,
    47: `2`,
    470: `221`,
    471: `221`,
    472: `222`,
    473: `223`,
    474: `224`,
    475: `225`,
    476: `225`,
    477: `226`,
    478: `227`,
    479: `228`,
    48: `2`,
    480: `230`,
    481: `230`,
    482: `230`,
    483: `232`,
    484: `232`,
    485: `233`,
    486: `233`,
    487: `233`,
    488: `235`,
    489: `235`,
    49: `2`,
    490: `235`,
    491: `235`,
    492: `235`,
    493: `235`,
    494: `236`,
    495: `236`,
    496: `237`,
    497: `238`,
    498: `240`,
    499: `241`,
    5: `2`,
    50: `2`,
    500: `244`,
    501: `244`,
    502: `244`,
    503: `246`,
    504: `246`,
    505: `247`,
    506: `248`,
    507: `249`,
    508: `249`,
    509: `250`,
    51: `2`,
    510: `250`,
    511: `251`,
    512: `251`,
    513: `251`,
    514: `252`,
    515: `252`,
    516: `253`,
    517: `253`,
    518: `254`,
    519: `254`,
    52: `2`,
    520: `255`,
    521: `255`,
    522: `255`,
    523: `258`,
    524: `258`,
    525: `259`,
    526: `259`,
    527: `260`,
    528: `261`,
    529: `266`,
    53: `2`,
    530: `266`,
    531: `267`,
    532: `267`,
    533: `267`,
    534: `268`,
    535: `268`,
    536: `269`,
    537: `269`,
    538: `271`,
    539: `271`,
    54: `2`,
    540: `273`,
    541: `274`,
    542: `274`,
    543: `275`,
    544: `276`,
    545: `277`,
    546: `277`,
    547: `278`,
    548: `279`,
    549: `279`,
    55: `2`,
    550: `279`,
    551: `280`,
    552: `280`,
    553: `280`,
    554: `281`,
    555: `281`,
    556: `282`,
    557: `283`,
    558: `285`,
    559: `286`,
    56: `2`,
    560: `287`,
    561: `288`,
    562: `289`,
    563: `289`,
    564: `290`,
    565: `291`,
    566: `291`,
    567: `291`,
    568: `292`,
    569: `292`,
    57: `2`,
    570: `292`,
    571: `293`,
    572: `294`,
    573: `294`,
    574: `295`,
    575: `295`,
    576: `297`,
    577: `298`,
    578: `298`,
    579: `299`,
    58: `2`,
    580: `300`,
    581: `301`,
    582: `301`,
    583: `302`,
    584: `303`,
    585: `303`,
    586: `303`,
    587: `304`,
    588: `304`,
    589: `304`,
    59: `2`,
    590: `305`,
    591: `305`,
    592: `306`,
    593: `306`,
    594: `307`,
    595: `307`,
    596: `307`,
    597: `308`,
    598: `309`,
    599: `309`,
    6: `2`,
    60: `2`,
    600: `310`,
    601: `311`,
    602: `312`,
    603: `312`,
    604: `313`,
    605: `313`,
    606: `314`,
    607: `314`,
    608: `314`,
    609: `315`,
    61: `2`,
    610: `316`,
    611: `316`,
    612: `317`,
    613: `318`,
    614: `319`,
    615: `319`,
    616: `320`,
    617: `320`,
    618: `321`,
    619: `321`,
    62: `2`,
    620: `322`,
    621: `322`,
    622: `323`,
    623: `323`,
    624: `324`,
    625: `325`,
    626: `326`,
    627: `326`,
    628: `327`,
    629: `327`,
    63: `2`,
    630: `328`,
    631: `328`,
    632: `329`,
    633: `330`,
    634: `330`,
    635: `330`,
    636: `331`,
    637: `331`,
    638: `332`,
    639: `332`,
    64: `2`,
    640: `334`,
    641: `334`,
    642: `335`,
    643: `335`,
    644: `336`,
    645: `337`,
    646: `337`,
    647: `337`,
    648: `338`,
    649: `338`,
    65: `2`,
    650: `339`,
    651: `339`,
    652: `341`,
    653: `341`,
    654: `342`,
    655: `342`,
    656: `342`,
    657: `343`,
    658: `344`,
    659: `344`,
    66: `2`,
    660: `345`,
    661: `345`,
    662: `346`,
    663: `346`,
    664: `346`,
    665: `347`,
    666: `348`,
    667: `349`,
    668: `350`,
    669: `350`,
    67: `2`,
    670: `351`,
    671: `352`,
    672: `352`,
    673: `353`,
    674: `354`,
    675: `354`,
    676: `354`,
    677: `355`,
    678: `356`,
    679: `356`,
    68: `2`,
    680: `357`,
    681: `357`,
    682: `358`,
    683: `358`,
    684: `358`,
    685: `359`,
    686: `360`,
    687: `360`,
    688: `361`,
    689: `361`,
    69: `2`,
    690: `362`,
    691: `362`,
    692: `362`,
    693: `363`,
    694: `364`,
    695: `365`,
    696: `365`,
    697: `366`,
    698: `366`,
    699: `367`,
    7: `2`,
    70: `2`,
    700: `368`,
    701: `368`,
    702: `369`,
    703: `369`,
    704: `370`,
    705: `371`,
    706: `371`,
    707: `372`,
    708: `373`,
    709: `373`,
    71: `2`,
    710: `373`,
    711: `374`,
    712: `375`,
    713: `375`,
    714: `376`,
    715: `376`,
    716: `377`,
    717: `377`,
    718: `378`,
    719: `378`,
    72: `2`,
    720: `379`,
    721: `380`,
    722: `380`,
    723: `380`,
    724: `381`,
    725: `381`,
    726: `382`,
    727: `382`,
    728: `383`,
    729: `384`,
    73: `4`,
    730: `385`,
    731: `385`,
    732: `386`,
    733: `387`,
    734: `387`,
    735: `387`,
    736: `388`,
    737: `389`,
    738: `389`,
    739: `391`,
    74: `4`,
    740: `391`,
    741: `392`,
    742: `392`,
    743: `392`,
    744: `393`,
    745: `394`,
    746: `394`,
    747: `395`,
    748: `395`,
    749: `396`,
    75: `5`,
    750: `396`,
    751: `397`,
    752: `398`,
    753: `399`,
    754: `400`,
    755: `400`,
    756: `401`,
    757: `401`,
    758: `402`,
    759: `402`,
    76: `5`,
    760: `402`,
    761: `403`,
    762: `404`,
    763: `404`,
    764: `405`,
    765: `406`,
    766: `407`,
    767: `408`,
    768: `408`,
    769: `409`,
    77: `5`,
    770: `409`,
    771: `410`,
    772: `410`,
    773: `411`,
    774: `411`,
    775: `412`,
    776: `413`,
    777: `414`,
    778: `414`,
    779: `415`,
    78: `6`,
    780: `415`,
    781: `416`,
    782: `416`,
    783: `417`,
    784: `418`,
    785: `418`,
    786: `418`,
    787: `419`,
    788: `419`,
    789: `420`,
    79: `7`,
    790: `420`,
    791: `422`,
    792: `422`,
    793: `423`,
    794: `423`,
    795: `424`,
    796: `425`,
    797: `425`,
    798: `425`,
    799: `426`,
    8: `2`,
    80: `8`,
    800: `426`,
    801: `427`,
    802: `428`,
    803: `428`,
    804: `429`,
    805: `430`,
    806: `431`,
    807: `431`,
    808: `432`,
    809: `433`,
    81: `9`,
    810: `433`,
    811: `433`,
    812: `434`,
    813: `435`,
    814: `435`,
    815: `437`,
    816: `437`,
    817: `438`,
    818: `438`,
    819: `438`,
    82: `10`,
    820: `439`,
    821: `440`,
    822: `440`,
    823: `441`,
    824: `441`,
    825: `442`,
    826: `442`,
    827: `442`,
    828: `443`,
    829: `444`,
    83: `11`,
    830: `445`,
    831: `446`,
    832: `446`,
    833: `447`,
    834: `448`,
    835: `448`,
    836: `449`,
    837: `450`,
    838: `450`,
    839: `450`,
    84: `11`,
    840: `451`,
    841: `452`,
    842: `452`,
    843: `453`,
    844: `453`,
    845: `454`,
    846: `454`,
    847: `454`,
    848: `455`,
    849: `456`,
    85: `12`,
    850: `456`,
    851: `457`,
    852: `457`,
    853: `458`,
    854: `458`,
    855: `458`,
    856: `459`,
    857: `460`,
    858: `461`,
    859: `462`,
    86: `13`,
    860: `462`,
    861: `463`,
    862: `464`,
    863: `464`,
    864: `465`,
    865: `466`,
    866: `466`,
    867: `466`,
    868: `467`,
    869: `468`,
    87: `14`,
    870: `468`,
    871: `469`,
    872: `469`,
    873: `470`,
    874: `471`,
    875: `471`,
    876: `472`,
    877: `472`,
    878: `473`,
    879: `474`,
    88: `15`,
    880: `474`,
    881: `474`,
    882: `475`,
    883: `475`,
    884: `476`,
    885: `476`,
    886: `477`,
    887: `478`,
    888: `479`,
    889: `479`,
    89: `15`,
    890: `480`,
    891: `481`,
    892: `481`,
    893: `481`,
    894: `482`,
    895: `483`,
    896: `483`,
    897: `485`,
    898: `485`,
    899: `486`,
    9: `2`,
    90: `16`,
    900: `487`,
    901: `487`,
    902: `488`,
    903: `489`,
    904: `489`,
    905: `490`,
    906: `490`,
    907: `490`,
    908: `491`,
    909: `491`,
    91: `16`,
    910: `492`,
    911: `493`,
    912: `494`,
    913: `494`,
    914: `495`,
    915: `495`,
    916: `495`,
    917: `496`,
    918: `497`,
    919: `497`,
    92: `17`,
    920: `497`,
    921: `498`,
    922: `498`,
    923: `499`,
    924: `500`,
    925: `500`,
    926: `501`,
    927: `502`,
    928: `502`,
    929: `503`,
    93: `18`,
    930: `503`,
    931: `503`,
    932: `504`,
    933: `504`,
    934: `505`,
    935: `506`,
    936: `506`,
    937: `507`,
    938: `508`,
    939: `508`,
    94: `18`,
    940: `509`,
    941: `509`,
    942: `510`,
    943: `511`,
    944: `512`,
    945: `512`,
    946: `512`,
    947: `513`,
    948: `514`,
    949: `514`,
    95: `19`,
    950: `515`,
    951: `515`,
    952: `515`,
    953: `515`,
    954: `515`,
    955: `515`,
    956: `515`,
    957: `515`,
    958: `515`,
    959: `515`,
    96: `20`,
    960: `516`,
    961: `516`,
    962: `517`,
    963: `518`,
    964: `519`,
    965: `519`,
    966: `520`,
    967: `520`,
    968: `521`,
    969: `521`,
    97: `21`,
    970: `522`,
    971: `523`,
    972: `523`,
    973: `524`,
    974: `525`,
    975: `525`,
    976: `525`,
    977: `526`,
    978: `527`,
    979: `527`,
    98: `22`,
    980: `528`,
    981: `529`,
    982: `529`,
    983: `530`,
    984: `530`,
    985: `531`,
    986: `532`,
    987: `533`,
    988: `534`,
    989: `534`,
    99: `23`,
    990: `535`,
    991: `536`,
    992: `536`,
    993: `537`,
    994: `537`,
    995: `538`,
    996: `538`,
    997: `539`,
    998: `540`,
    999: `541`
    },
  appClear: `CA==`,
  appClearMap: {
    },
  companionInfo: {
    _api_stake3: 1,
    _api_unstake3: 1
    },
  extraPages: 1,
  stateKeys: 3,
  stateSize: 275,
  unsupported: [],
  version: 13,
  warnings: []
  };
export const _stateSourceMap = {
  1: {
    at: './index.rsh:91:11:after expr stmt semicolon',
    fs: [],
    msg: null,
    who: 'Module'
    },
  3: {
    at: './index.rsh:273:11:after expr stmt semicolon',
    fs: [],
    msg: null,
    who: 'Module'
    },
  4: {
    at: './index.rsh:123:31:after expr stmt semicolon',
    fs: [],
    msg: null,
    who: 'Module'
    }
  };
export const _Connectors = {
  ALGO: _ALGO
  };
export const _Participants = {
  "Deployer": Deployer,
  "claim": claim,
  "setWinner": setWinner,
  "stake": stake,
  "unstake": unstake,
  "updateTime": updateTime,
  "withdrawAll": withdrawAll
  };
export const _APIs = {
  claim: claim,
  setWinner: setWinner,
  stake: stake,
  unstake: unstake,
  updateTime: updateTime,
  withdrawAll: withdrawAll
  };
